export const lang = {
    get: (string, parameters?) => {
        switch (string) {
            // Integrations + Fortnox (Z): source
            case 'INTEG_INTRO': return `Aktivera och hantera tillägg för ${parameters[0]}.`;
            case 'INTEG_CONNECTED_TO': return `Kopplat till ${parameters[0]}`;
            case 'INTEG_CONNECTED_TO_AUTO': return `Kopplat till ${parameters[0]} · automatisk export på`;
            case 'INTEG_STATUS_FAILED': return `Status kunde inte hämtas (${parameters[0]})`;
            case 'FZ_NOTICE_ORG_MISMATCH': return `Fel företag: Fortnox-kontot tillhör ${parameters[0]} (${parameters[1]}), men restaurangen tillhör ${parameters[2]}. Inget sparades.`;
            case 'FZ_NOTICE_DENIED': return `Kopplingen avbröts i Fortnox: ${parameters[0]}`;
            case 'FZ_NOTICE_ERROR': return `Kopplingen misslyckades: ${parameters[0]}`;
            case 'FZ_CONNECTED_META': return `kopplat ${parameters[0]} av ${parameters[1]}`;
            case 'FZ_SCOPE_NOTE': return `Kopplingen gäller alla restauranger som tillhör ${parameters[0]}. Inställningarna nedan gäller bara ${parameters[1]}.`;
            case 'FZ_ORG_MISMATCH_WARN': return `Restaurangens företag i PubQ har org.nr ${parameters[0]} men är kopplat till ${parameters[1]}.`;
            case 'FZ_REAUTH_WARN': return `Fortnox-kopplingen för ${parameters[0]} har gått ut och måste godkännas igen.`;
            case 'FZ_ALREADY_CONNECTED': return `Företaget ${parameters[0]} är redan kopplat – restaurangen är nu ansluten.`;
            case 'FZ_SETTINGS_FOR': return `Inställningar för ${parameters[0]}`;
            case 'FZ_FROM_Z': return `från Z ${parameters[0]}`;
            case 'FZ_EG': return `t.ex. ${parameters[0]}`;
            case 'FZ_APPROVED_SO_FAR': return `${parameters[0]} bokförda hittills`;
            case 'FZ_PREVIEW_TITLE': return `Verifikation för Z ${parameters[0]}`;
            case 'FZ_SERIES_X': return `serie ${parameters[0]}`;
            case 'FZ_PREVIEW_SUMMARY': return `${parameters[0]} kvitton · Z-rapportens total ${parameters[1]} kr`;
            case 'FZ_DROPPED': return `${parameters[0]} nollrad(er) utelämnade`;
            case 'FZ_RESEND_TITLE': return `Skicka Z ${parameters[0]} igen?`;
            case 'FZ_RESEND_ALREADY': return `Z ${parameters[0]} är redan bokförd.`;
            case 'FZ_RESEND_ALREADY_AS': return `Z ${parameters[0]} är redan bokförd som ${parameters[1]}.`;
            case 'FZ_DISCONNECT_ALL': return `Detta kopplar från Fortnox för alla restauranger som tillhör ${parameters[0]}.`;
            case 'FZ_TOAST_SENT': return `Z ${parameters[0]} bokförd`;
            case 'FZ_TOAST_SENT_AS': return `Z ${parameters[0]} bokförd som ${parameters[1]}`;
            case 'FZ_TOAST_NOT_SENT': return `Z ${parameters[0]} skickades inte`;
            case 'FZ_BACKFILL_RESULT': return `Efterskick: ${parameters[0]} bokförda, ${parameters[1]} ej`;
            case 'FZ_BACKFILL_STOPPED': return `Stoppade vid Z ${parameters[0]}: ${parameters[1]}`;
            case 'FZ_ERR_SECTION_TIMEOUT': return `Fortnox-tjänsten svarade inte inom ${parameters[0]} s`;
            case 'FZ_ERR_SIGNIN_TIMEOUT': return `Inloggningen svarade inte inom ${parameters[0]} s`;
            case 'FZ_CUST_REFRESHED': return `Uppdaterat från Fortnox: ${parameters[0]} fält ändrade.`;
            case 'CARD_ADDED_FOR': return `Kort tillagt hos ${parameters[0]}`;
            case 'REMOVE_NAME': return `Ta bort ${parameters[0]}?`;
            case 'REMOVED_IMAGE': return `Tog bort ${parameters[0]}`
            case 'PRODUCTS_UPDATED': return `${parameters[0]} produkter uppdaterade`
            case 'UPDATING_PRODUCTS_PROGRESS': return `Uppdaterar produkter ${parameters[0]} av ${parameters[1]}`
            case 'SAVING_MENU': return `Sparar meny för ${parameters[0]}`
            case 'REMOVE_MENU': return `Ta bort ${parameters[0]}?`;
            case 'SAVING_GALLERY': return `Sparar galleri för ${parameters[0]}`;
            case 'REMOVED_IMAGE': return `\uD83D\uDE04 Tog bort ${parameters[0]}`;
            case 'NUMBER_ARTICLES': return `${parameters[0]}  artiklar`;
            case 'UPDATE_ITEM': return `Uppdaterade ${parameters[0]}`;
            case 'PRODUCT_ADDED': return `${parameters[0]} tillagd`;
            case 'PRODUCT_REMOVED': return `${parameters[0]} borttagen`;
            case 'REMOVE_PRODUCT_CATEGORY': return `Är du säker på att du vill du ta bort produktkategori ${parameters[0]}?`;
            case 'REMOVE_BONG_CATEGORY': return `Är du säker på att du vill du ta bort bongkategorikategori ${parameters[0]}?`;
            case 'SHARE_NEWS_WITH': return `Delar nyheten med ${parameters[0]}`;
            case 'NEWS_SHARED': return `Delade ${parameters[0] ? parameters[0] : 'nyheten'}`
            case 'TIMELINE_SAVED_FOR': return `Sparar tidslinjen för ${parameters[0]}`;
            case 'SHARING_OFFER_WITH': return `Delar erbjudandet med ${parameters[0]}`;
            case 'OFFER_SHARED': return `Delade ${parameters[0]}`;
            case 'REMOVE_COUPON': return `Ta bort ${parameters[0]}?`;
            case 'LINKED_PRODUCT': return `Länkade ${parameters[0]}`;
            case 'COPY_FROM': return `Kopiera från ${parameters[0]}?`
            case 'REMOVE': return `Ta bort ${parameters[0]}?`;
            case 'REMOVE_CORPORATE_USER_QUESTION': return `Är du säker på att du vill ta bort ${parameters[0]}?`;
            case 'REMOVING': return `Tar bort ${parameters[0]}?`;
            case 'ADDED': return `Lade till ${parameters[0]}`;
            case 'PRODUCT_SAVED': return `${parameters[0]} sparades`;
            case 'SAVING_PRODUCT': return `Sparar produkt för ${parameters[0]}`;
            case 'CONFIRM_REMOVE_ACCOUNTING': return `Är du säker på att du vill ta bort ${parameters[0]}?`;
            case 'SAVED': return `Sparade ${parameters[0]}`;
            case 'RECEIPTS_AMOUNT': return `Totalt: ${parameters[0]} kvitton & ${parameters[1]}`;
            case 'ARE_YOU_SURE_YOU_WANT_TO_MARK_THIS_ORDER_AS': return `Är du säker på att du vill markera den här beställningen som ${parameters[0]}?`;
            case 'ARE_YOU_SURE_YOU_WANT_TO_REMOVE': return `Är du säker på att du vill ta bort "${parameters[0]}" från "${parameters[1]}"?`;
            case 'ARE_YOU_SURE_YOU_WANT_TO_MARK_THIS_ORDER_AS': return `Är du säker på att du vill markera den här beställningen som ${parameters[0]}?`;
            case 'ARE_YOU_SURE_YOU_WANT_TO_DELETE': return `Är du säker på att du vill ta bort "${parameters[0]}"? Denna åtgärd kan inte ångras.`;
            case 'MENU_DEACTIVATED_DETAIL': return `Meny "${parameters[0]}" har blivit avaktiverad.`;
            case 'MENU_ACTIVATED_DETAIL': return `Meny "${parameters[0]}" är nu aktiv.`;
            case 'CAMPAIGN_MENU_ACTIVATED_DETAIL': return `Kampanjmeny "${parameters[0]}" är nu aktiv.`;
            case 'PRODUCT_REMOVED_FROM_CATEGORY': return `Produkt "${parameters[0]}" borttagen från kategori "${parameters[1]}".`;
            case 'PRODUCT_ADDED_TO_CATEGORY': return `Produkt "${parameters[0]}" läggs till i kategori "${parameters[1]}".`;
            case 'ORDER_STATUS_UPDATED': return `Beställningsstatus uppdaterad till "${parameters[0]}".`;
            case 'COLUMNS_SELECTED': return `Kolumner valda: ${parameters[0]}`;
            case 'FOOD_ITEM_COMPLETED_DETAIL': return `${parameters[0]} markerades som klar.`;
            case 'FOOD_ITEMS_COMPLETED_DETAIL': return `${parameters[0]} matvaror markerade som klara: ${parameters[1]}`;
            case 'DRINK_ITEM_COMPLETED_DETAIL': return `${parameters[0]} markerades som klar.`;
            case 'DRINK_ITEMS_COMPLETED_DETAIL': return `${parameters[0]} dryck markerade som klara: ${parameters[1]}`;
            case 'ITEMS_COMPLETED_DETAIL': return `Mat: ${parameters[0]}. Dryck: ${parameters[1]}.`;
            case 'TIMER_STARTED_DETAIL': return `Timer startad för ${parameters[0]} minut${parameters[1]}.`;
            case 'CATERING_ADDON_MORE_PRODUCTS': return `+${parameters[0]} till`;
            case 'CATERING_ADDON_ERR_MAX_EXCEEDS_OPTIONS': return `Max antal valda kan inte överstiga ${parameters[0]} alternativ.`;
            case 'CATERING_ADDON_ERR_MIN_EXCEEDS_OPTIONS': return `Min antal valda kan inte överstiga ${parameters[0]} alternativ.`;

            default: return '';
        }
    },
    ALCOHOL_STRINGS: [
        'vin',
        'shot',
        'drink',
        'sprit',
        'cognac',
        'öl',
        'cider',
        'whisk',
        'whiskey',
        'whisky',
        'rom',
        'likör',
        'vodka',
        'limoncello',
        'alkoläsk',
    ],
    AMOUNT_MIN_MOBILE_WALLET: 'Minimibelopp',
    AMOUNT_1_MOBILE_WALLET: 'Belopp 1',
    AMOUNT_2_MOBILE_WALLET: 'Belopp 2',
    AMOUNT_3_MOBILE_WALLET: 'Belopp 3',
    AMOUNT_4_MOBILE_WALLET: 'Belopp 4',
    AMOUNT_5_MOBILE_WALLET: 'Belopp 5',
    AMOUNT_6_MOBILE_WALLET: 'Belopp 6',
    AMOUNT_7_MOBILE_WALLET: 'Belopp 7',
    AMOUNT_8_MOBILE_WALLET: 'Belopp 8',
    AMOUNT_9_MOBILE_WALLET: 'Belopp 9',
    AMOUNT_10_MOBILE_WALLET: 'Belopp 10',
    STRINGS: [
        'Öl',
        'Vin',
        'Alkoholfritt',
        'Mat',
        'Cider',
        'Drink',
        'Sprit',
        'Dricks',
        'Presentkort',
    ],
    DRINK_LIST: ['dricka', 'dryck'],
    WEEL_LIST: ['Sön', 'Mån', 'Tis', 'Ons', 'Tors', 'Fre', 'Lör'],
    CHOSE_PRINTER: 'Välj skrivare',
    SAVE_AS_PDF: 'Spara som PDF',
    MY_ACCOUNT: 'Mitt konto',
    USER_ID: 'Användar-ID',
    USER_NOT_FOUND: 'Ingen användare hittades',
    REMOVE_ACCOUNTING: 'Kontering raderad',
    SAVED_CARDS: 'Sparade kort',
    BONUS_POINTS: 'Bonuspoäng',
    POINTS: 'Poäng',
    SALDO: 'Saldo',
    ADJUST: 'Justera saldo',
    INVALID_DATE_RANGE: "Startdatum måste vara före slutdatum.",
    PROFILE: 'Profil',
    ADD_INFO_TO_PROFILE:
        'Lägg till information i din profil så att vi bättre kan stödja dig på denna resa.',
    PLEASE_ENTER_ADDRESS: 'Vänligen ange din adress',
    FIRST_NAME: 'Förnamn',
    LAST_NAME: 'Efternamn',
    POSTCODE: 'Postnummer',
    CITY: 'Stad',
    COUNTRY: 'Land',
    NEXT: 'Nästa',

    ORGANIZATION: 'Organisation',
    ENTER_ORG_INFO: 'Ange din organisationsinformation.',
    ENTER_COMPANY_NAME: 'Ange ett företagsnamn',
    ENTER_COMPANY_NUMBER: 'Ange ett bolagsnummer',
    VALIDATE: 'BEKRÄFTA',
    VALIDATING: 'VALIDERING',
    VALIDATED: 'VALIDERAD',
    PREVIOUS: 'Föregående',

    REVIEW_DETAILS_SUBMIT: 'Granska dina uppgifter och skicka in',
    WIZARD3_TEXT1:
        'Nu är vi nästan klara med registreringsdelen, dubbelkolla dina uppgifter nedan.',
    WIZARD3_TEXT2: 'Sedan kan du börja utforska PubQ-plattformen.',
    WIZARD3_TEXT3: 'Ett nytt företag kommer att skapas med namnet',

    FREE_REGISTER: 'Gratis registrering för att komma igång',
    STEP: 'Steg',

    SIGNUP: 'Skapa konto',
    CREATE_ACC_DETAILS: 'Ange dina uppgifter nedan',
    FULLNAME: 'Namn',
    IS_REQUIRED: 'krävs',
    CONFIRM_PASSWORD: 'Bekräfta lösenord',
    SHARE_GALLERY: 'Dela galleri',
    SELECT_RESTAURANTS: 'Välj restauranger',
    REGISTER: 'Registrera',
    LOG_OUT: 'Logga ut',
    HANDLE_PERSONNELCARD: 'Hantera personalkort',
    CREATE_NEW_CARD: 'Skapa nytt kort',
    PERSONNELCARD: 'Personalkort',
    NAME: 'Namn',
    NAME_REQUIRED: 'Namn krävs.',
    TEXT_ON_CARD: 'Text på kort',
    AVAILABLE_THROUGH: 'Giltigt till',
    URL_TO_BACKGROUND: 'URL till bakgrund',
    REMOVE: 'Ta bort',
    SAVE: 'Spara',
    SEARCH: 'Sök',
    SEARCH_IMAGE: 'Sök bild...',
    SEARCH_VIDEO: 'Sök video...',
    USER_WITH_CARD: 'Användare med kort',
    ID: 'Id',
    CARD: 'Kort',
    JANUARY: 'Januari',
    FEBRUARY: 'Februari',
    MARS: 'Mars',
    APRIL: 'April',
    MAY: 'Maj',
    JUNE: 'Juni',
    JULY: 'Juli',
    AUGUST: 'Augusti',
    SEPTEMBER: 'September',
    OCTOBER: 'Oktober',
    NOVEMBER: 'November',
    DECEMBER: 'December',
    JAN3: 'Jan',
    FEB3: 'Feb',
    MAR3: 'Mar',
    APR3: 'Apr',
    MAY3: 'Maj',
    JUN3: 'Jun',
    JUL3: 'Jul',
    AUG3: 'Aug',
    SEP3: 'Sep',
    OCT3: 'Okt',
    NOV3: 'Nov',
    DEC3: 'Dec',
    OK: 'OK',
    AUTHORIZED_USERS: 'Behöriga användare',
    ADD_NEW_USER: 'Lägg till ny användare',
    NO_AUTHORIZED_USERS: 'Inga behöriga användare ännu.',
    ENTER_USER_NAME: 'Ange användarnamn',
    ENTER_USER_EMAIL: 'Ange användarens e-post',
    CORPORATE_USER_INVITED: 'Behörig användare inbjuden.',
    RESEND_INVITATION: 'Skicka inbjudan igen',
    CORPORATE_USER_INVITATION_RESENT: 'Inbjudan skickades igen.',
    CORPORATE_USER_INVITATION_RESEND_FAILED: 'Kunde inte skicka inbjudan igen.',
    CORPORATE_USER_ALREADY_LINKED: 'Den här användaren är redan kopplad till detta företag för den här enheten.',
    CORPORATE_USER_REMOVED: 'Behörig användare borttagen.',
    CORPORATE_USER_REMOVE_FAILED: 'Kunde inte ta bort behörig användare.',
    FAILED_TO_LOAD_AUTHORIZED_USERS: 'Kunde inte ladda behöriga användare.',

    USERNAME: 'ANVÄNDARNAMN',
    DATE: 'DATUM',
    DATE_FOR_PUSH: 'Datum',
    ORDER_NAME: 'BESTÄLLNINGSNAMN',
    TOTAL_ITEMS: 'TOTALA ARTIKLAR',
    ADDRESS: 'Adress',
    ACTIONS: 'INSATSER',
    PLACE_ORDER: 'Beställa',
    CANCEL: 'Avbryt',
    SCHEDULE_VIEW: 'Schemavy',
    DISCARD: 'Avbryt',
    SORTED_ON_PRODUCT: 'Sorterat på produkt',
    DAY: 'Dag',
    TOTAL: 'Totalt',
    ORDERS_TODAY: 'Ordrar idag',
    ORDERS_THIS_MONTH: 'Ordrar denna månad',
    ACTIVITY: 'Aktivitet',
    COUPONS_IN_APP: 'Kuponger använda i appen',
    PER_PRODUCT: 'Per produkt',
    SELECT_PRODUCTS: 'Välj produkter',
    USERS_WITH_CODES: 'Användare med rabattkoder',
    RECEIPTNO: 'Kvittonr',
    TIME: 'Tid',
    CODE: 'Kod',
    ORDERCODE: 'Orderkod',
    NAVIGATE_HERE: 'Navigera här eller använd menyn i ovankant',
    UPLOADING: 'Laddar upp',
    UPLOAD: 'Ladda upp...',
    GALLERY: 'Galleri',
    GALLERY_IMAGE_LOAD_FAILED: 'Bilden kunde inte laddas',
    GALLERY_RETRY: 'Försök igen',
    GALLERY_SHOW_MORE: 'Visa fler',
    GALLERY_IMAGE_REMOVED: 'Bilden borttagen',
    GALLERY_VIDEO_REMOVED: 'Videon borttagen',
    DELETE_IMAGE: 'Ta bort bild',
    ARE_YOU_SURE_GALLERY: 'Är du säker på att du vill ta bort bilden från galleriet?',
    ARE_YOU_SURE: 'Är du säker?',
    UPDATING_IMAGE_QUICK: 'Vänta... vi uppdaterar din bild en snabbis',
    UPDATING: 'Uppdaterar',
    SYNC_PRODUCTS: 'Synka produkter',
    CLEAR_EXISTING_PROUCTS: 'Rensa existerande produkter?',
    UPDATING_PRODUCTS: 'Uppdaterar produkter',
    SAVING_OPTION_GROUP: 'Sparar tillvalsgrupp…',
    OPT_GROUP_SAVE_FAILED: 'Det gick inte att spara tillvalsgruppen.',
    PRODUCT_PAGE_VERIFY: 'Gå till produktsidan för att verifiera',
    FROM: 'Från',
    TO: 'Till',
    ORDERVALUE_COUPON: 'Ordervärde med kupongkod',
    SUM_RECEPITS_COUPON: 'Summan av kvitton där gästen handlat med kupongkod',
    CODE_CAPS: 'KOD',
    DISCOUNT_CAPS: 'RABATT',
    NETTO_CAPS: 'NETTO',
    VAT_CAPS: 'MOMS',
    TOTAL_CAPS: 'TOTALT',
    TODAY_CAPS: 'IDAG',
    CLOSE_CAPS: 'STÄNG',
    RESET_FORTNOX: 'Återställ Fortnox-koppling?',
    RESET_FORTNOX_TEXT:
        'Är du säker att du vill ta bort Fortnox-kopplingen och återställa så att det går att skapa en ny koppling?',
    NO: 'Nej',
    YES: 'Ja',
    CATEGORY_TEXT_DESCRIPTION:
        'De här underkategorierna kommer att vara synliga i appen när den här menyn är aktiv.',
    SUBCATEGORYGROUPS_TEXT_DESCRIPTION:
        'Koppla befintliga underkategorigrupper till menyn eller skapa en ny.',
    SUBCATEGORYGROUPS_HEADER: 'Underkategorigrupper',
    EAT_IN_PRICE: 'Äta här-pris',
    TAKEAWAY_PRICE: 'Takeaway-pris',
    ADD_SUBCATEGORYGROUP: 'Lägg till grupp',
    AUTHORIZATIONCODE: 'Auktoriseringskod',
    MENU_STYLE_TEXT: 'Meny-layout i appen',
    AUTHORIZED: 'AUKTORISERAD',
    VOUCHER_SERIES: 'Verifikationsserie',
    ROUNDING_ACCOUNT: 'Konto för öresutjämning',
    ACTIVATE: 'Aktivera',
    INTEGRATIONS: 'Integrationer',
    PASSWORD: 'Lösenord',
    FORWARD: 'Vidare',
    FORGOT_PASSWORD: 'Glömt lösenord?',
    RESET_EMAIL_HEAD: 'Email för återställande',
    RESET_EMAIL_TXT: 'Fyll i din email',
    NEW_MENU: 'Ny meny',
    ADD_NEW_OFFER: 'Lägg till erbjudande',
    COPY: 'Kopiera',
    ADVANCED_SETTINGS: 'Avancerade inställningar',
    QR_FOR_SCANNING: 'QR-kod för scanning',
    ADD_NEW_COUPON_CODE: 'Lägg till rabattkod',
    TABLE_SERVICE: 'Bordsservering',
    SET_LOCATIONS: 'Fasta platser',
    ACTION: 'Action',
    ADD_DOMAINS: 'Lägg till domäner',
    LINK: 'Länka',
    FRANCHISE_ID: 'Franchise-ID',
    MISCELLANEOUS: 'Övriga inställningar',
    NO_DATA_PERIOD: 'Ingen data under vald period',
    FETCH_DATA_ERROR: 'Något gick fel vid hämtning av data',
    DELETE_USER_GROUP: 'Ta bort användargrupp',
    USER_GROUP_DELETED: 'Användargrupp borttagen',
    USER_GROUP_UPDATED: 'Användargrupp uppdaterad',
    DELETE_GROUP: 'Ta bort grupp',
    LOADING_DATA: 'Hämtar data',
    DATA: 'Data',
    PRODUCT_IMAGE: 'Produktbild',
    EDIT_INVOICE: 'Ändra faktura',
    INVOICE_DETAILS: 'Fakturadetaljer',
    ADD_TO_ALL_USERS: 'Lägg till på alla användare',
    X_REPORT: 'X-rapport',
    Z_REPORTS: 'Z-rapport',
    X_REPORT_STARTED: 'X-rapport startad',
    SETTLEMENTNO: 'Z-rapportnummer',
    TIMESTAMP: 'Tidsstämpel',
    RECEIPTNOSTART: 'Kvittonummer start',
    RECEIPTNOSTOP: 'Kvittonummer stopp',
    TOTALAMOUNT: 'Totalsumma',
    UPLOAD_IMAGE: 'Ladda upp bild',
    SELECT_FILE: 'Välj fil',
    CREATE_NEW_MENU: 'Skapa ny meny',
    CREATE_CATEGORY: 'Skapa kategori',
    EDIT_CATEGORY: 'Ändra kategori',
    EDIT_CATEGORY_ON_PRODUCTS: 'Ändra kategori på produkter',
    CATEGORY_ACTIONS: 'Kategoristyrning',
    COUPON_CODE: 'Rabattkod',
    APPLY_CODE_AUTOMATICALLY: 'Applicera kod automatiskt',
    SURE: 'Är du säker?',
    MENU_SHARED: 'Delade menyn!',
    SOMETHING_WRONG: 'Något gick fel!',
    ACTIVATE_BEFORE_REMOVE:
        'Du måste aktivera en annan meny innan du kan ta bort den här',
    THIS_MENU_ACTIVE: 'Den här menyn är aktiv',
    REMOVE_FOR_ALL: 'Ta bort för alla?',
    REMOVE_EVEN_OTHERS:
        'Vill du även ta bort inlägget om det existerar på andra restaurangenheter?',
    REMOVED_FROM_ALL: 'Tog bort från alla restauranger',
    MONDAY: 'Måndag',
    TUESDAY: 'Tisdag',
    WEDNESDAY: 'Onsdag',
    THURSDAY: 'Torsdag',
    FRIDAY: 'Fredag',
    SATURDAY: 'Lördag',
    SUNDAY: 'Söndag',
    FAILED: 'Misslyckades',
    MISSING_TEXT:
        'Vissa produkter i produktregistret saknar bong- eller produktkategori. Detta kan leda till att de inte fungerar som förväntat i appen. Vänligen uppdatera produkterna för att säkerställa en smidig drift.',
    EDIT_ALL: 'Ändra alla',
    PERCENT: 'Procent',
    SAVED: 'Sparat!',
    MENUS: 'Menyer',
    VISIBLE_IN_APP: 'Synlig i appen',
    WEEKLY_MENU: 'Veckomeny',
    WEEKLY_MENU_PLANNER: 'Veckomenyplanerare',
    WEEKLY_MENU_PLANNER_DESCRIPTION: 'Bygg ett veckoschema med produkter från måndag till söndag.',
    GLOBAL_SETTINGS: 'Förbeställningsgränser',
    WEEKLY_MENU_GLOBAL_SETTINGS_DESCRIPTION: 'Välj hur många dagar i förväg gäster kan beställa.',
    ORDER_DAYS_IN_ADVANCE: 'Kunder kan beställa så här många dagar i förväg',
    DAY_SETTINGS: 'Dagsinställningar',
    SEARCH_PRODUCTS: 'Sök produkter',
    SEARCH_PRODUCT_REGISTER: 'Sök i produktregistret',
    WEEKLY_MENU_PRODUCT: 'Veckomenyprodukt',
    WEEKLY_MENU_PRODUCT_HINT: 'Visa denna produkt i veckomenyns produktregister.',
    WEEKLY_MENU_PRICE_HELP: 'Valfritt: lämna tomt för att använda grundpriset för den serveringsmetoden.',
    WEEKLY_MENU_AVAILABLE_THIS_DAY: 'Tillgänglig denna dag',
    WEEKLY_MENU_PRODUCT_ENABLED_EVERYWHERE_HINT: 'Avstängd produkt döljs överallt den används, inte bara denna veckodag.',
    CLOSED_FOR_ORDERING: 'Stängd för beställning',
    OPEN_FOR_ORDERING: 'Öppen för beställning',
    ORDER_CUTOFF_TIME: 'Beställningsstopp',
    AVAILABLE_FROM: 'Tillgänglig från',
    AVAILABLE_UNTIL: 'Tillgänglig till',
    ORDERS_MUST_BE_PLACED_BEFORE_THIS_TIME: 'Beställningar måste göras före denna tid.',
    SAVE_SETTINGS: 'Spara inställningar',
    GLOBAL_SETTINGS_SAVED: 'Globala inställningar sparade',
    SETTINGS_SAVED: 'Inställningar sparade',
    SHOW_BUTTON:
        "Visa knappen 'Veckomeny' på appens startsida. Uppdatera texten varje vecka så att användare ser vad som serveras",
    UPLOAD_PROGRESS: 'Laddar upp:',
    GALLERY_SHARED: 'Delade galleriet!',
    USE_IMAGE: 'Använd bild',
    USE_VIDEO: 'Använd video',
    PREVIEW_VIDEO: 'Förhandsgranska video',
    DELETE_VIDEO: 'Ta bort video',
    UPDATING_IMAGE: 'Vänta... vi uppdaterar din bild en snabbis',
    COMPRESSING: 'Komprimerar',
    HELP: 'Hjälp',
    IN_STOCK: 'I lager',
    OUT_OF_STOCK: 'Slut i lager',
    STOCK_BALANCE_ERROR: 'Lagersaldo måste vara större än 0',
    FEW_LEFT_IN_STOCK: 'Få kvar i lager',
    CATEGORIES: 'Kategorier',
    FOOD: 'Mat',
    PRODUCTS: 'Produkter',
    REDEMPTION_AGREEMENT: 'Inlösenavtal',
    ADD: 'Lägg till',
    UPDATE: 'Uppdatera',
    CONFIRM: 'Bekräfta',
    NO_CRITERIA_ADDED: 'Inga kriteriar tillagda för erbjudandet',
    PRODUCT_CATEGORIES: 'Produktkategorier',
    BONG_CATEGORIES: 'Bongkategorier',
    NEW_PRODUCT_CATEGORY: 'Ny produktkategori',
    REMOVE_CATEGORY: 'Ta bort kategori',
    REMOVE_PRODUCT_CATEGORY:
        'Är du säker på att du vill ta bort produktkategori',
    EDIT_PRODUCT_CATEGORY: 'Ändra produktkategori',
    MENU_TIMES_UPDATED: 'Menytider uppdaterade',
    SUBCATEGORY_UPDATED: 'Subkategorin uppdaterad.',
    MENU_SCHEDULE: 'Menyschema',
    MENU_SCHEDULE_DEACTIVATED: 'Menyschema avaktiverat',
    ACTIVATED: 'aktiverad',
    DEACTIVATED: 'avaktiverad',
    MENU_NAME_UPDATED: 'Menynamn uppdaterat',
    SUBCATEGORY_DELETED: 'Subkategori borttaget',
    SERVING_OPTIONS_UPDATED: 'Leveransalternativ uppdaterade',
    DELIVERY_TO_FIXED_LOCATIONS: 'Leverans till fast plats',
    UPDATED_SUCCESSFULLY: 'Uppdatering genomförd',
    NEW_BONG_CATEGORY: 'Ny bongkategori',
    REMOVE_BONG_CATEGORY: 'Ta bort bongkategori?',
    EDIT_BONG_CATEGORY: 'Ändra bongkategori',
    COURSE: 'Rätt',
    COURSE_NAME_1: 'Förrätt',
    COURSE_NAME_2: 'Varmrätt',
    COURSE_NAME_3: 'Efterrätt',
    NO_COURSE: 'Ingen rätt',
    NO_COURSE_DIRECT: 'Ingen rätt (skickas direkt)',
    COURSE_HINT: 'Kassan lägger varor i den här bongkategorin i vald rätt. Ingen rätt: skickas direkt till köket.',
    TIMELINE: 'Tidslinje',
    NEW_POST: 'Ny post',
    SHARE: 'Dela',
    SHARE_IMAGE: 'Dela bild',
    CHOOSE_IMAGE: 'Välj bild...',
    ALL_ORDERS: 'Alla ordrar',
    FIXED_LOCATIONS: 'Fasta platser',
    AUTOCOMPLETE: 'Klarmarkera automatiskt',
    SHOW_ON_KDS: 'Visa på köksskärm (KDS)',
    KDS_AND_PRINTER: 'KDS & skrivare',
    COOKINGTIME_MINUTES: 'Tillagningstid i minuter',
    PRINTED_ON: 'Skrivs ut på...',
    TITLE: 'Titel',
    TEXT: 'Text',
    OFFER: 'Erbjudande',
    ADDON_GROUPS: 'Tillvalsgrupper',
    PRODUCT: 'Produkt',
    URL: 'Url',
    STATIC: 'Statisk',
    APP_TAB: 'Tabb i appen som produkten ligger under',
    OFFER_INFO: 'Info om erbjudande',
    WARNING: 'Varning',
    ALREADY_EDITING:
        'Du redigerar redan en annan post. Är du säker på att du vill förlora data?',
    ABORT_Q: 'Avbryt?',
    CONFIRM_CHANGES:
        'Är du säker på att du vill avbryta? Ändringar kommer att gå förlorade',
    FILL_ALL_FIELDS: 'Du måste fylla i alla fält förutom titel och text',
    SAVE_NEWS: 'Sparar nyheter',
    MAIN_TEXT: 'Huvudtext',
    NEW_TITLE: 'Ny titel',
    REMOVE_POST: 'Ta bort inlägg?',
    REMOVE_POST_CONFIRM: 'Är du säker på att du vill ta bort inlägget?',
    REMOVE_FOR_OTHERS:
        'Vill du även ta bort inlägget om det existerar på andra restaurangenheter?',
    TIMELINE_SHARED: 'Delade tidslinjen!',
    TYPE: 'Typ',
    SERVING_METHOD: 'Serveringssätt',
    APPLIES_FOR: 'Gäller för',
    SEARCH_BY_EMAIL: 'Sök på e-postadress',
    PRODUCT_TYPES: 'Produkttyper',
    SEARCH_USER_EMAIL_PHONE:
        'Sök efter användare med email eller telefonnummer',
    DISCOUNT_PERCENTAGE: 'Procent i rabatt',
    AUTOMATIC_ACTIVATION: 'Aktivera automatiskt för användare',
    CREATING_OFFER: 'Skapar erbjudandet',
    OFFER_CREATED: 'Erbjudande skapat!',
    UPDATING_OFFER: 'Uppdaterar erbjudandet',
    OFFER_UPDATED: 'Uppdaterade erbjudandet',
    REMOVING: 'Tar bort',
    OFFER_REMOVED: 'Tog bort erbjudandet',
    NEW_BUTTON: 'Ny knapp',
    CREATE_NEW_BUTTON: 'Skapa ny knapp',
    CONNECT_BUTTON: 'Vad ska knappen vara kopplad till?',
    CHOOSE_BG_IMAGE: 'Välj bakgrundsbild...',
    BUTTON_LAYER: 'Knapplager',
    FREE_TEXT: 'Fritext',
    ACTIVATE_IN_POS: 'AKTIVERA I KASSAN',
    ALLERGY_INFO_SAVED: 'Allergiinfo sparad och syns i appen',
    MINIMUM_BONUS_SAVED: 'Minimum bonus sparad',
    PAYMENT_OPTIONS_SAVED: 'Betalalternativ sparade',
    SERVING_OPTIONS_SAVED: 'Serveringsinställningar sparade',
    NOTIFICATION_SAVED: 'Notis sparad',
    INSTAGRAM_SAVED: 'Instagram sparat',
    FACEBOOK_SAVED: 'Facebook sparat',
    MENU_STYLE_SAVED: 'Menyutseende sparat',
    FOOD_SETTINGS_SAVED: 'Matinställningar sparade',
    DRINK_SETTINGS_SAVED: 'Dryckinställningar sparade',
    DISCOUNT_SETTINGS_SAVED: 'Rabattinställningar sparade',
    INVOICE: 'Fakturering',
    STATUS: 'Status',
    USER_GROUP_ID: 'Användargrupp-ID',
    EDIT_USER_GROUP: 'Ändra användargrupp',
    EDIT_USER: 'Ändra användare',
    FEATURED_PRODUCTS: 'Utvalda produkter',
    TITLE_TEXT_COLOR: 'Textfärg',
    HAS_BACKGROUND_TEXT: 'Lägg till bakgrund bakom text',
    SHOW_BADGE_TEXT: 'Visa ikon för nyhetstyp',
    ADD_COLOR: 'Välj färg',
    ADD_TO_UNITS: 'Lägg till enheter',
    JUST_PUBQSE: 'Ex: bara pubq.se, inte @pubq.se',
    LINK_EXISTING_OFFER: 'Länka befintligt erbjudande',
    SELECT_ONE: 'Välj en',
    SELECT_MULTIPLE: 'Välj flera',
    CREATE_OFFER: 'Skapa erbjudande',
    EDIT_OFFER: 'Ändra erbjudande',
    OFFER_TITLE: 'Titel på erbjudande',
    ADD_DISCOUNT_CODE: 'Lägg till rabattkod',
    TRANSACTIONS_NOT_FOUND: "Inga transaktioner hittades",
    TRANSACTIONS: 'Transaktioner',
    GUEST_INFORMATION: 'Gästinformation',
    SEARCH_EMAIL_ORDER_CODE: 'Sök med e-postadress eller användar-ID',
    NEW_DEVIATION: 'Ny avvikelse',
    OCCASION: 'Anledning',
    DEVIATION_EXAMPLE: '(ex. julafton)',
    DEVIATION_INCOMPLETE: 'Tillfälle, startdatum och slutdatum krävs',
    DEVIATION_START_DATE_IN_PAST: 'Startdatum kan inte vara före idag',
    DEVIATION_END_DATE_IN_PAST: 'Slutdatum kan inte vara före idag',
    OVERLAPPING_DEVIATION_DATE_RANGE: 'Detta datumintervall överlappar en annan avvikelse',
    TAKEAWAY_EAT_HERE: 'Takeaway & äta här',
    ADD_FEE: 'Lägg till avgift',
    HOME_DELIVERY: 'Hemleverans',
    DEVIATION_DATE: 'Datum',
    AMOUNT: 'Belopp',
    EDITOR: 'Redigerare',
    SEARCH_USER: 'Sök användare',
    CUSTOMER_INFORMATION: 'Gästinformation',
    RESTAURANT_INFORMATION: 'Restauranginfo',
    PAYMENT_METHOD: 'Betalsätt',
    PAYMENT_SOURCE: 'Betalningskälla',
    COMPANY_INFORMATION: 'Bolagsinformation',
    RESTAURANT_ID: 'Restaurang-ID',
    DESCRIPTION: 'Beskrivning',
    OFFER_CONFIGURATION: 'Konfiguration',
    INVITED_USERS: 'Inbjudna användare',
    CONFIRM_USERGROUP: 'Bekräfta',
    SEARCH_USERGROUP: 'Sök grupp',
    ADD_NEW_USERGROUP: 'Lägg till användargrupp',
    COUPON_NAME: 'Kupongens namn',
    PERCENTAGE_IN_DISOUNT: 'Antal procent i rabatt',
    TAKEAWAY: 'Takeaway',
    TABLE_SERVING: 'Bordsservering',
    COLLECT_IN_BAR: 'Hämta i baren',
    DELIVERY: 'Utkörning',
    SENDING_PUSH: 'Skickar pushnotis',
    PUSH_SENT: 'Push skickad!',
    GENERAL: 'Generellt',
    GENERATE_REPORT: 'Generera rapport',
    PUSH_NOTIFICATIONS: 'Pushnotiser',
    OFFERS: 'Erbjudanden',
    STAMP_CARDS: 'Stämpelkort',
    ADD_NEW_STAMP_CARD: 'Skapa nytt',
    STAMPS_REQUIRED: 'Stämplar krävs',
    REWARD: 'Belöning',
    NO_STAMP_CARDS: 'Inga stämpelkort. Lägg till ett för att komma igång.',
    CREATE_STAMP_CARD: 'Skapa stämpelkort',
    EDIT_STAMP_CARD: 'Redigera stämpelkort',
    IMPORT: 'Importera',
    IMPORT_STAMP_CARD: 'Importera stämpelkort',
    IMPORT_STAMP_CARD_DESCRIPTION: 'Hämta stämpelkort från andra enheter i din lojalitetsgrupp och låt gäster samla och använda stämplar på alla anslutna enheter.',
    NO_STAMP_CARDS_TO_IMPORT: 'Inga stämpelkort tillgängliga att importera från din lojalitetsgrupp.',
    STAMP_CARD_IMPORTED: 'Stämpelkortet har importerats',
    FAILED_TO_IMPORT: 'Det gick inte att importera stämpelkortet',
    STAMP_CARD_NAME: 'Namn på stämpelkort',
    STAMP_CARD_DESCRIPTION: 'Beskrivning',
    STAMP_CARD_DESCRIPTION_PLACEHOLDER: 'T.ex. Köp 10 luncher och få den 11:e gratis.',
    HOW_IT_WORKS: 'Så fungerar det',
    HOW_IT_WORKS_PLACEHOLDER: 'Valfria regler eller instruktioner som visas i appen',
    STAMPS_REQUIRED_FOR_FULL_CARD: 'Stämplar krävs för fullt kort',
    REWARD_TYPE: 'Belöningstyp',
    FULL_DISCOUNT: '100% rabatt',
    HALF_DISCOUNT: '50% rabatt',
    SALES_CHANNELS: 'Försäljningskanaler',
    CHANNEL_APP: 'App',
    CHANNEL_KIOSK: 'Kiosk',
    CHANNEL_POS: 'POS',
    CHANNEL_WEB: 'Webb',
    CUSTOMER_VISIBILITY: 'Kundsynlighet',
    ALL_CUSTOMERS: 'Alla kunder',
    LOGGED_IN_USERS_ONLY: 'Endast inloggade användare',
    DELETE_STAMP_CARD: 'Ta bort stämpelkort',
    DELETE_STAMP_CARD_CONFIRM:
        'Ta bort detta stämpelkort?\n\nAlla stämplar, användarprogress och loggar för detta kort tas bort permanent för alla användare.\n\nVill du behålla historik och bara sluta använda kortet, inaktivera det (sätt kortet som inaktivt) i stället för att ta bort det.',
    STAMP_CARD_DELIVERY_METHODS: 'Leveransmetoder',
    STAMP_CARD_DELIVERY_METHODS_HINT: 'Alla metoder är tillåtna som standard; avmarkera för att begränsa vilka leveransmetoder som kan ge och använda stämplar.',
    STAMP_CARD_DM_EAT_IN: 'Äta här',
    STAMP_CARD_DM_TAKEAWAY: 'Takeaway',
    STAMP_CARD_DM_DELIVER_TO_WORKPLACE: 'Leverans till arbetsplats',
    STAMP_CARD_DM_DELIVERY: 'Utkörning',
    STAMP_CARD_DM_TABLE_SERVING: 'Bordsservering',
    REWARD_ELIGIBLE: 'Belöning',
    STAMP_CARD_SEPARATE_REWARD_ITEMS: 'Ange separata belöningsprodukter',
    STAMP_CARD_SEPARATE_REWARD_ITEMS_HINT: 'Aktivera detta om belöningen ska gälla för andra produkter än de som ger stämplar.',
    SC_USERS_CARD_RECORDS: 'Kortposter',
    SC_USERS_READY_TO_REDEEM: 'Redo att lösa in',
    SC_USERS_AVG_STAMPS: 'Snitt stämplar per kort',
    SC_USERS_SEARCH_PLACEHOLDER: 'Sök på namn, användar-ID eller kort...',
    SC_USERS_NO_RECORDS: 'Inga användarposter hittades.',
    SC_DEACTIVATED_BY_ADMIN: 'Inaktiverat av admin',
    SC_DEACTIVATED: 'Inaktiverat',
    SC_CARD_ACTIVE: 'Kort aktivt',
    SC_CARD_INACTIVE: 'Kort inaktivt',
    SC_USER_DEACTIVATED: 'Användare inaktiverad',
    SC_USER_ACTIVE: 'Användare aktiv',
    SC_DEACTIVATED_BANNER: 'Detta kort är inaktiverat för denna användare — stämplar bevaras men inlösning är blockerad tills det återaktiveras.',
    SC_STAMP_PROGRESS: 'Stämpelframsteg',
    SC_LAST_STAMP: 'Senaste stämpel',
    SC_LAST_REDEEMED: 'Senast inlöst',
    SC_LAST_USED_DATE: 'Datum för senaste aktivitet',
    SC_CARD_NAME: 'Kortnamn',
    SC_CARD_ID: 'Kort-ID',
    SC_ADD_STAMP: 'Lägg till stämpel',
    SC_REMOVE_STAMP: 'Ta bort stämpel',
    SC_NO_STAMPS_TO_REMOVE: 'Inga stämplar att ta bort',
    SC_MAX_STAMPS_REACHED: 'Max antal stämplar uppnått – markera som inlöst',
    SC_NOT_READY_TO_REDEEM: 'Kortet är inte klart för inlösen ännu',
    SC_MARK_REDEEMED: 'Markera som inlöst',
    SC_DEACTIVATE: 'Inaktivera',
    SC_REACTIVATE: 'Återaktivera',
    SC_LOADING_HISTORY: 'Laddar historik…',
    SC_NO_HISTORY: 'Ingen aktivitet registrerad ännu.',
    SC_LOG_STAMP_ADDED: 'Stämpel insamlad',
    SC_LOG_REDEEMED: 'Inlöst',
    SC_LOG_ADMIN_STAMP_ADDED: 'Admin: Stämpel tillagd',
    SC_LOG_ADMIN_STAMP_REMOVED: 'Admin: Stämpel borttagen',
    SC_LOG_ADMIN_REDEEMED: 'Admin: Markerad som inlöst',
    SC_LOG_ADMIN_DEACTIVATED: 'Admin: Kort inaktiverat',
    SC_LOG_ADMIN_REACTIVATED: 'Admin: Kort återaktiverat',
    SC_STAMP: 'stämpel',
    SC_STAMPS: 'stämplar',
    SC_REFRESH: 'Uppdatera',
    SC_USER_COL: 'Användare',
    SC_STAMP_CARD_COL: 'Stämpelkort',
    SC_STAMPS_COL: 'Stämplar',
    SC_PROGRESS_COL: 'Framsteg',
    SC_NOT_READY: 'Inte redo',
    SC_ALL_CARDS: 'Alla kort',
    SC_STAMP_CARD_DETAILS: 'Stämpelkortsdetaljer',
    SC_FAILED_LOAD_PROGRESS: 'Misslyckades att ladda användarframsteg',
    ADD_ROUTE: 'Lägg till route',
    LOADING_ROUTES: 'Laddar routes...',
    EXPIRATION: 'Utgång',
    DELIVERY_OPTIONS: 'Utkörningsalternativ',
    DELIVERY_OPTIONS_DESCRIPTION:
        'Det finns två typer av utkörningsalternativ. Det ena låter dig definiera fasta leveransplatser (till exempel en specifik byggnad eller plats), medan det andra gör det möjligt att leverera direkt till kundernas egna adresser.',
    PAYMENT_OPTIONS: 'Betalalternativ',
    USE_SAVE_BUTTON:
        'Ändringar på denna sida påverkar mobilappen och "Spara"-knapparna måste användas för att ändringarna ska slå igenom',
    OPEN_FOR_SALE: 'Öppen för försäljning',
    MESSAGE_WHEN_CLOSED: 'Meddelande till kund när tabben är stängd',
    FOOD_TAB: 'Matförsäljning',
    DRINK_TAB: 'Dryckesförsäljning',
    NOTIFICATION_IN_APP: 'Notis i appen',
    SHOW_NOTIFICATION: 'Visa notis',
    NOTIFICATION_TEXT: 'Text för notis',
    SEARCH_KEYWORD: 'Sök på produkt',
    CLEAR: 'Rensa',
    ALLERGY_INFO: 'Allergiinfo',
    PHONE_NUMBER: 'Telefonnummer',
    OPENING: 'Öppnar klockan',
    CLOSING: 'Stänger klockan',
    SHOW_FACEBOOK: 'Visa Facebook-ikon på startsidan',
    INSTAGRAM: 'Instagram',
    SHOW_INSTAGRAM: 'Visa Instagram-ikon på startsidan',
    CREATE_PRODUCT: 'Skapa produkt',
    EXPORT: 'Exportera',
    BONUS_BUY: 'Aktiv för bonus',
    BONUS_TOOLTIP: 'Bonuspoäng kan användas vid köp av den här produkten',
    SHOW_YAMMER: 'Visa Yammer-ikon på startsidan',
    SHOW_TIKTOK: 'Visa TikTok-ikon på startsidan',
    WHICH_ACTIVE: 'Vilka ska vara aktiverade i appen?',
    SWISH: 'Swish',
    TAB: 'Bordsnota',
    TABLENUMBER_FROM: 'Bordsnummer från',
    TABLENUMBER_TO: 'Bordsnummer till',
    AREA_1: 'Område 1',
    AREA_2: 'Område 2',
    AREA_3: 'Område 3',
    AREA_4: 'Område 4',
    DELIVERY_RADIUS: 'Utkörningsradie i meter',
    DELIVERY_RADIUS_COST: 'Pris för utkörningsradie',
    BONUSSYSTEM: 'Bonussystem',
    BONUS: 'Bonus %',
    LEAST_AMOUNT_BONUS: 'Minsta antal bonuspoäng som kan användas vid köp',
    ACTIVE_OR_DEACTIVE_BONUS_SYSTEM: 'Aktivera eller avaktivera bonussystem',
    ACTIVE_OR_DEACTIVE_MAX_BONUS_POINTS:
        'Aktivera eller avaktivera maximala bonuspoäng',
    GLOBAL_OFFERS: 'Globala erbjudanden',
    APPLIES_TO_ALL: 'Gäller för alla i appen',
    ONETIME: 'Engångs',
    USER_GROUPS: 'Användargrupper',
    SINGLE_OFFER: 'Engångserbjudande',
    MULTIPLE_OFFER: 'Flergångserbjudande',
    ADD_NEW: 'Lägg till ny',
    ADD_NEW_USERGROUP_LABEL: 'Namn på användargrupp',
    GROUP_NAME: 'Gruppnamn',
    DISCOUNT_CODES: 'Rabattkoder',
    DISCOUNTPERCENT: 'Rabattprocent',
    APPLY_AUTOMATICALLY: 'Applicera rabattkod automatiskt för kunderna i appen',
    SEND_PUSH: 'Pushnotis',
    SEND_PUSH_TEXT:
        'Push-notiser skickas omedelbart till alla kunder som accepterat aviseringar på den här restaurangen',
    SEND: 'Skicka',
    ALTERNATIVES: 'Alternativ',
    HEADER_EX: 'Rubrik (t.ex Stekgrad)',
    OPTION_TYPE: 'Typ av tillval',
    CHECKBOX: 'Checkruta',
    MULTIPLE: 'Flerval',
    PRICE: 'Pris',
    OPTIONS: 'Tillval',
    OPTIONS_NEWS: 'Alternativ',
    COPY_FROM: 'Kopiera från',
    USING_STEP_BY_STEP: 'Använder Steg-för-steg-flödet',
    HEADER: 'Rubrik',
    SUBHEADER: 'Underrubrik',
    LINK_WITH: 'Länkad med',
    EDIT_EXCEPTION: 'Ändra undantag',
    REASON: 'Anledning',
    REASON_DETAILS: 'Anledningsdetaljer',
    ACCOUNTING: 'Kontering',
    SEARCH_PRODUCT: 'Sök produkt',
    DELIVERY_TYPES: 'Utkörningsalternativ',
    REMOVE_EXCEPTION_CONFIRM: 'Vill du ta bort undantaget?',
    REMOVE_EXCEPTION: 'Ta bort undantag!',
    SAVE_WITHOUT_ACCOUNTING:
        'Du kan inte spara produkter utan bokföringsinformation och produkttyp',
    REMOVE_PRODUCT_RESTURANTS:
        'Vill du ta bort produkten på fler restauranger?',
    PRODUCT_SHARED: 'Delade produkten!',
    PRODUCT_INFORMATION: 'Produktinformation',
    BASIC_INFO: 'Grundinformation',
    ACTIVE: 'Aktiv',
    PRODUCT_ACTIVE: 'Produkt aktiv',
    PRICE_OPTIONS: 'Prisalternativ',
    PRODUCT_LIST: 'Produktlista',
    PRICE_KR: 'Pris',
    WEIGHT_BASED_PRODUCT: 'Viktbaserad produkt',
    WEIGHT_BASED_HINT: 'Gästen väljer vikten i appen. Priset beräknas som vikt i gram / 100 × pris per 100 g.',
    WEIGHT_BASED_APP_ONLY: 'Denna produkt är endast tillgänglig i appen. Den kan inte visas i expresskiosk eller webborder.',
    PRICE_PER_100G: 'Pris per 100 g',
    MIN_WEIGHT_G: 'Minsta vikt (g)',
    MAX_WEIGHT_G: 'Högsta vikt (g)',
    WEIGHT_STEP_G: 'Viktsteg (g)',
    PER_100_G: '/ 100 g',
    WEIGHT_CONFIG_INVALID: 'Ogiltig viktkonfiguration. Min måste vara minst steget, max måste vara större än min, och (max − min) måste vara delbart med steget.',
    WEIGHT_BASED_INCOMPATIBLE: 'Viktbaserat pris kan inte kombineras med Build-a-Burger eller kombinerade produkter.',
    BONUS_CONVERT: 'Procent som konverteras till bonuspoäng vid köp av produkt',
    BONUS_CONVERT_WALLET:
        'Procent som konverteras till bonuspoäng vid påfyllning av mobile wallet',
    NOT_ALLOWED_TO_BY_WITH_BONUS: 'Får inte köpas för bonuspoäng',
    DESCRIPTION_SHORT: 'Beskrivning (kort)',
    DESCRIPTION_LONG: 'Beskrivning (lång)',
    DELETE: 'Ta bort',
    DELETE_MENU: 'Ta bort meny',
    CATEGORY_BONG_INFO: 'Kategori- & bonginformation',
    NAME_ON_BONG: 'Namn på bong (valfri)',
    PRODUCT_TYPE: 'Produkttyp',
    PRODUCT_CATEGORY: 'Produktkategori',
    BONG_CATEGORY: 'Bongkategori',
    ACCOUNTING_VAT: 'Bokföring & moms',
    EXCEPTION: 'Undantag',
    CONTAINS_ALCOHOL: 'Innehåller alkohol',
    AGE_LIMIT: '18+ åldersgräns',
    PURCHASE: 'Inköp',
    COST: 'Kostnad',
    MARGIN: 'Marginal',
    TAGS: 'Taggar',
    NEW_TAG: 'Ny tagg',
    EXTERNAL_ID: 'Externt ID',
    STOCK_BALANCE: 'Lagersaldo',
    COUNT: 'Antal',
    ACOUNTINGS: 'Konteringar',
    VAT_RATE: 'Momssats',
    VAT_RATES: 'Momssatser',
    ACCOUNTING_ACCOUNT: 'Bokföringskonto',
    NO_ACCOUNT: 'Inget konto',
    ACCOUNTING_CREATED: 'Kontering skapad',
    PAYMENT_TYPES: 'Betalsätt',
    ACTIVATED_PAYMENT_TYPES: 'Aktiverade betalsätt',
    ADITIONAL_PAYMENT_TYPES: 'Fler betalsätt',
    NO_PAYMENT_TYPES:
        "har inga betalsätt aktiverade. Tryck på 'Fler betalsätt' för att aktivera några",
    ADDED: 'Tillagd',
    PAYMENT_FEES:
        'En del betalsätt är förknippade med avgifter. Här väljer du konton för dessa',
    VAT: 'Moms',
    HOME: 'Hem',
    RESTAURANT: 'Restaurang',
    MENU: 'Meny',
    MANAGE: 'Hantera',
    REPORTS: 'Rapporter',
    PREPARING_REPORT: 'Förbereder rapport...',
    REPORT_STATUS_QUEUED: 'I kö...',
    REPORT_STATUS_RUNNING: 'Genererar rapport...',
    REPORT_STATUS_DONE: 'Klar, hämtar filen...',
    REPORT_RUNS_IN_BACKGROUND: 'Du kan stänga rutan - rapporten fortsätter köras.',
    SCHEDULED_REPORTS: 'Schemalagda rapporter',
    SCHEDULED_REPORTS_DESCRIPTION: 'Rapporter som skapas automatiskt och mejlas som CSV-bilagor.',
    SCHEDULED_REPORTS_NO_ACCESS: 'Du har inte behörighet till schemalagda rapporter. Be en administratör på PubQ att lägga till dig.',
    SCHEDULED_REPORTS_EMPTY: 'Inga schemalagda rapporter än.',
    SCHEDULED_REPORT_ADD: 'Ny schemalagd rapport',
    SCHEDULED_REPORT_EDIT: 'Redigera schemalagd rapport',
    SCHEDULED_REPORT_SECTION_REPORT: 'Rapport',
    SCHEDULED_REPORT_SECTION_SETTINGS: 'Inställningar',
    SCHEDULED_REPORT_NAME_PLACEHOLDER: 't.ex. Fakturaunderlag, två gånger i månaden',
    SCHEDULED_REPORT_TYPE: 'Rapport',
    SCHEDULED_REPORT_TYPE_PLACEHOLDER: 'Välj rapport',
    SCHEDULED_REPORT_SCHEDULE: 'Schema',
    SCHEDULED_REPORT_UNITS: 'Enheter',
    SCHEDULED_REPORT_UNITS_HINT: 'Alla valda enheter måste tillhöra samma franchise.',
    SCHEDULED_REPORT_FRANCHISE: 'Franchise',
    SCHEDULED_REPORT_FRANCHISE_MIXED: 'De valda enheterna tillhör olika franchiser.',
    SCHEDULED_REPORT_FRANCHISE_MISSING: 'Kunde inte hitta franchise för de valda enheterna.',
    SCHEDULED_REPORT_RESOLVING_FRANCHISE: 'Hämtar franchise...',
    SCHEDULED_REPORT_RECIPIENTS: 'Mottagare',
    SCHEDULED_REPORT_RECIPIENTS_HINT: 'Tryck Enter eller komma efter varje adress. Varje mottagare får ett eget mejl.',
    SCHEDULED_REPORT_INVALID_EMAIL: 'Ogiltig e-postadress',
    SCHEDULED_REPORT_TRIGGERS: 'När rapporten skickas',
    SCHEDULED_REPORT_TRIGGERS_HINT: 'Varje rapport skickas strax efter midnatt (00:30 svensk tid) efter en dag som matchar och täcker perioden till och med slutet av den dagen.',
    SCHEDULED_REPORT_ADD_TRIGGER: 'Lägg till rapportdag',
    SCHEDULED_REPORT_PRESET_HALF_MONTH: 'Två gånger i månaden (15:e och sista dagen)',
    SCHEDULED_REPORT_SEND_ON: 'Rapportdag',
    SCHEDULED_REPORT_SENT_ON: 'skickas',
    SCHEDULED_REPORT_COVERING: 'Period',
    SCHEDULED_REPORT_DAY: 'Dag',
    SCHEDULED_REPORT_WEEKDAY: 'Veckodag',
    SCHEDULED_REPORT_DAY_OF_MONTH: 'Dag i månaden',
    SCHEDULED_REPORT_LAST_DAY_OF_MONTH: 'Sista dagen i månaden',
    SCHEDULED_REPORT_DAY_OF_WEEK: 'Veckodag',
    SCHEDULED_REPORT_DAILY: 'Varje dag',
    SCHEDULED_REPORT_EVERY: 'Varje',
    SCHEDULED_REPORT_RANGE_FIRST_HALF: '1:a till 15:e i månaden',
    SCHEDULED_REPORT_RANGE_SECOND_HALF: '16:e till sista dagen i månaden',
    SCHEDULED_REPORT_RANGE_PREVIOUS_MONTH: 'Föregående månad',
    SCHEDULED_REPORT_RANGE_MONTH_TO_DATE: 'Månaden hittills',
    SCHEDULED_REPORT_RANGE_LAST_7_DAYS: 'Senaste 7 dagarna',
    SCHEDULED_REPORT_RANGE_CUSTOM: 'Anpassad (dagar relativt rapportdagen)',
    SCHEDULED_REPORT_RANGE_CUSTOM_SHORT: 'Dagar',
    SCHEDULED_REPORT_FROM_DAY: 'Från dag',
    SCHEDULED_REPORT_TO_DAY: 'Till dag',
    SCHEDULED_REPORT_TIME_ZONE: 'Tidszon',
    SCHEDULED_REPORT_ENABLED: 'Aktiv',
    SCHEDULED_REPORT_LAST_RUN: 'Senaste körning',
    SCHEDULED_REPORT_NEXT_RUN: 'Nästa körning',
    SCHEDULED_REPORT_NEXT_RUNS: 'Nästa',
    SCHEDULED_REPORT_NEVER_RUN: 'Inte körd än',
    SCHEDULED_REPORT_STATUS_QUEUED: 'I kö',
    SCHEDULED_REPORT_STATUS_RUNNING: 'Körs',
    SCHEDULED_REPORT_STATUS_SENT: 'Skickad',
    SCHEDULED_REPORT_STATUS_PARTIAL: 'Delvis skickad',
    SCHEDULED_REPORT_STATUS_FAILED: 'Misslyckades',
    SCHEDULED_REPORT_STATUS_CANCELLED: 'Avbruten',
    SCHEDULED_REPORT_STATUS_ENQUEUE_FAILED: 'Kunde inte köas',
    SCHEDULED_REPORT_STATUS_INVALID: 'Ogiltigt schema',
    SCHEDULED_REPORT_SAVED: 'Schemalagd rapport sparad',
    SCHEDULED_REPORT_DELETED: 'Schemalagd rapport borttagen',
    SCHEDULED_REPORT_DELETE_TITLE: 'Ta bort schemalagd rapport',
    SCHEDULED_REPORT_DELETE_CONFIRM: 'Ta bort den schemalagda rapporten? Inga fler mejl skickas för den.',
    SCHEDULED_REPORT_SAVE_FAILED: 'Kunde inte spara den schemalagda rapporten.',
    SCHEDULED_REPORT_DELETE_FAILED: 'Kunde inte ta bort den schemalagda rapporten.',
    SCHEDULED_REPORT_TYPES_FAILED: 'Kunde inte hämta rapporttyperna.',
    SCHEDULED_REPORT_TOGGLE_FAILED: 'Kunde inte ändra schemat.',
    SCHEDULED_REPORT_FIX_ERRORS: 'Åtgärda följande innan du sparar:',
    SCHEDULED_REPORT_ERR_REPORT_TYPE: 'Välj en rapport',
    SCHEDULED_REPORT_ERR_UNITS: 'Välj minst en enhet',
    SCHEDULED_REPORT_ERR_PARAM: 'Fyll i',
    SCHEDULED_REPORT_ERR_RECIPIENTS: 'Lägg till mellan 1 och 20 mottagare',
    SCHEDULED_REPORT_ERR_TRIGGERS: 'Lägg till mellan 1 och 10 rapportdagar',
    SCHEDULED_REPORT_ERR_CUSTOM_RANGE: 'En anpassad period måste börja före eller på sitt slutdatum, inom 400 dagar',
    SCHEDULED_REPORT_ERR_DAY: 'Välj en giltig dag',
    DOWNLOAD_USER_GROUP_REPORT: 'Ladda ner rapport',
    SELECT_DATE: 'Välj datum',
    WORKING_LATE_MEALS_REPORT: 'Ladda ner rapport för sena måltider',
    EMPLOYEE_TAG_MEAL_REPORT: 'Ladda ner rapport för anställdas måltider',
    WALLET_BALANCES_REPORT: 'Ladda ner rapport för plånbokssaldon',

    USR_GRP_ORDERS_RPT_TITLE: 'Användargruppsordrar',
    USR_GRP_ORDERS_RPT_DESC: 'Rapport med detaljerad information om beställningar gjorda av olika användargrupper.',

    WRK_LATE_MEALS_RPT_TITLE: 'Sena måltider',
    WRK_LATE_MEALS_RPT_DESC: 'Översikt över måltider beställda utanför ordinarie arbetstid.',

    EMPLY_TAG_MEAL_RPT_TITLE: 'Anställdas måltider',
    EMPLY_TAG_MEAL_RPT_DESC: 'Rapport baserad på anställdas taggar för måltidskonsumtion.',

    WALLET_BAL_RPT_TITLE: 'Plånbokssaldon',
    WALLET_BAL_RPT_DESC: 'Aktuella saldon för användarnas digitala plånböcker.',
    ADMIN: 'Administration',
    NEWS: 'Nyhetsflöde',
    NEWS_CAROUSEL: 'Nyhetskarusell',
    LOYALTY: 'Lojalitet',
    TIMESLOTS: 'Tidsslot',
    APP: 'App',
    POS: 'Kassa',
    INACTIVE: 'Inaktiv',
    ADDONS: 'Tillval',
    POS_TITLE: 'Kassa',
    POS_BUTTONS: 'Knappar',
    POS_V2_BUTTONS: 'POS v2 menyer',
    POS_V2_MENUS: 'POS v2 menyer',
    POS_V2_MENUS_TITLE: 'POS menyer',
    POS_V2_MENUS_SUBTITLE: 'Skapa och hantera POS menyer. Endast en meny kan vara aktiv åt gången på dina kassor.',
    POS_V2_CREATE_MENU: 'Skapa meny',
    POS_V2_SEARCH_MENUS: 'Sök menyer...',
    POS_V2_NO_MATCHING_MENUS: 'Inga menyer hittades som matchar din sökning.',
    POS_V2_NEW_MENU_NAME: 'Menynamn',
    POS_V2_MENU_NAME_PLACEHOLDER: 't.ex. Lunch, Middag, Bar',
    POS_V2_ACTIVE_MENU: 'Aktiv',
    POS_V2_INACTIVE_MENU: 'Inaktiv',
    POS_V2_SET_ACTIVE: 'Aktivera',
    POS_V2_MENU_ACTIVE_SUCCESS: 'Meny aktiverades framgångsrikt.',
    POS_V2_DUPLICATE_MENU: 'Duplicera meny',
    POS_V2_DELETE_MENU: 'Ta bort meny',
    POS_V2_DELETE_MENU_CONFIRM: 'Är du säker på att du vill ta bort menyn "{name}"?',
    POS_V2_CANNOT_DELETE_ACTIVE_MENU: 'En aktiv meny kan inte tas bort. Aktivera en annan meny först.',
    POS_V2_NO_MENUS_TITLE: 'Inga POS menyer ännu',
    POS_V2_NO_MENUS_HINT: 'Skapa din första meny för att börja konfigurera lager och knappar för dina kassor.',
    POS_V2_BACK_TO_MENUS: 'Tillbaka till menyer',
    POS_V2_EDIT_LAYERS: 'Redigera lager',
    POS_V2_LAYERS_COUNT: '{count} lager',
    POS_V2_RENAME_MENU: 'Byt namn på meny',
    POS_V2_LAYERS: 'Lager',
    POS_V2_LAYOUT_SAVED: 'Layout sparad.',
    POS_V2_LAYOUT_SAVE_FAILED: 'Kunde inte spara layouten. Försök igen.',
    POS_V2_UNSAVED_CHANGES_TITLE: 'Osparade ändringar',
    POS_V2_UNSAVED_CHANGES_CONFIRM: 'Du har osparade ändringar i denna meny. Vill du slänga dem och gå tillbaka till menyerna?',
    POS_V2_DISCARD_AND_LEAVE: 'Släng och lämna',
    POS_V2_KEEP_EDITING: 'Fortsätt redigera',
    POS_V2_CREATE_FAV_LAYER: 'Skapa favoritlager',
    POS_V2_FAV_LAYER: 'Favoriter',
    POS_V2_TOGGLE_FAVORITE: 'Växla favorit',
    POS_V2_NO_LAYERS_TITLE: 'Inga lager ännu',
    POS_V2_NO_LAYERS_HINT: 'Skapa ditt första lager för att organisera kategorier och kassaknappar.',
    POS_V2_ADD_LAYER: 'Lägg till lager',
    POS_V2_ADD_CATEGORY: 'Lägg till kategori',
    POS_V2_MENU_CATEGORIES: 'Menykategorier',
    POS_V2_ALL_CATEGORIES_ADDED: 'Alla menykategorier har lagts till i detta lager.',
    POS_V2_SEARCH_CATEGORIES: 'Sök kategorier...',
    POS_V2_SELECT_ALL_CATEGORIES: 'Välj alla',
    POS_V2_DESELECT_ALL_CATEGORIES: 'Avmarkera alla',
    POS_V2_CUSTOM_CATEGORY_NAME: 'Kategorinamn',
    POS_V2_CUSTOM_CATEGORY_PLACEHOLDER: 'Ange kategorinamn...',
    POS_V2_CUSTOM_CATEGORY_DESC: 'Skapa en egen kategori för att manuellt lägga till artiklar eller snabbknappar.',
    POS_V2_CREATE_CUSTOM_INSTEAD: 'Skapa en egen kategori istället',
    POS_V2_NO_MATCHING_CATEGORIES: 'Inga kategorier matchar "{query}"',
    POS_V2_ADD_MENU_CATEGORY: 'Lägg till menykategori',
    POS_V2_ADD_CUSTOM_CATEGORY: 'Lägg till egen kategori',
    POS_V2_RENAME_CUSTOM_CATEGORY: 'Byt namn på egen kategori',
    POS_V2_DRAG_CATEGORY: 'Dra för att ändra ordning på kategori',
    POS_V2_CUSTOM_CATEGORY: 'Egen',
    POS_V2_MENU_CATEGORY: 'Menykategori',
    POS_V2_NO_PRODUCTS: 'Inga produkter',
    POS_V2_CUSTOM_CATEGORY_HINT: 'Lägg till knappar manuellt för denna egna kategori.',
    POS_V2_DELETE_LAYER: 'Ta bort lager',
    POS_V2_DELETE_LAYER_CONFIRM: 'Är du säker på att du vill ta bort lagret "{name}"?',
    POS_V2_DELETE_CATEGORY_CONFIRM: 'Är du säker på att du vill ta bort kategorin "{name}"?',
    POS_V2_DELETE_BUTTON: 'Ta bort knapp',
    POS_V2_DELETE_BUTTON_CONFIRM: 'Är du säker på att du vill ta bort knappen "{name}"?',
    POS_V2_BUTTON: 'Knapp',
    POS_V2_PAGE_SUBTITLE: 'Konfigurera lager, kategorier och kassaknappar.',
    POS_V2_SAVE_LAYOUT: 'Spara layout',
    POS_V2_ADD_BUTTON: 'Lägg till knapp',
    POS_V2_MANAGE_CATEGORY_PRODUCTS: 'Hantera produkter',
    POS_V2_ADD_PRODUCTS: 'Lägg till produkter',
    POS_V2_ADD_SELECTED: 'Lägg till valda',
    POS_V2_SPECIAL_BUTTONS: 'Specialknappar',
    POS_V2_IN_CATEGORY: 'I kategori',
    POS_V2_PRODUCT_CATALOG: 'Produktkatalog',
    POS_V2_CUSTOM_LABEL: 'Anpassad kassatext',
    POS_V2_CUSTOM_LABEL_PLACEHOLDER: 'Anpassad knapptext...',
    POS_V2_ADD_FREE_TEXT_BTN: 'Lägg till fritextknapp',
    POS_V2_ADD_STOCK_BTN: 'Lägg till underlagerknapp',
    POS_V2_NO_PRODUCTS_IN_CATEGORY: 'Inga knappar i denna kategori ännu. Byt till Produktkatalog för att lägga till.',
    POS_V2_NO_PRODUCTS_FOUND: 'Inga produkter hittades',
    POS_V2_SELECT_ALL: 'Välj alla',
    POS_V2_HIDE_ADDED: 'Dölj redan tillagda',
    POS_V2_FREE_TEXT_PREFILL_HINT: 'Text som läggs till på artikeln när knappen trycks',
    POS_V2_LAYER_VISIBLE_IN_POS: 'Synlig i kassa',
    POS_V2_LAYER_HIDDEN: 'Dold i kassa',
    POS_V2_DRAG_LAYER: 'Dra för att ändra ordning',
    POS_V2_LAYER_DISABLED_HINT: 'Detta lager visas inte i POS v2-kassan förrän det aktiveras.',
    POS_V2_GENERATE_HINT: 'Lägger till knappar för menyprodukter med vald kategori. Ersätter befintliga knappar i denna flik.',
    POS_V2_GENERATE_CONFIRM:
        'Generera knappar från menyprodukter med vald kategori? Befintliga knappar i denna flik ersätts.',
    POS_V2_GRID_EMPTY: 'Inga knappar ännu. Lägg till en eller generera från menyn.',
    POS_V2_NO_CATEGORIES_IN_LAYER: 'Inga kategorier i detta lager.',
    POS_V2_NO_BUTTONS_IN_CATEGORY: 'Inga knappar i denna kategori.',
    POS_V2_ALL_READONLY: 'Endast visning. Välj en kategori för att lägga till eller redigera knappar.',
    POS_V2_BUTTON_COLOR: 'Färg',
    POS_V2_STOCK_EMPTY: 'Lägg till knappar i detta lager med +-rutan.',
    POS_V2_CUSTOM_NAME_TOGGLE: 'Anpassat knappnamn',
    POS_V2_CUSTOM_NAME_HINT: 'Åsidosätt det visade namnet på kassaknappen',
    POS_V2_CUSTOM_NAME_LABEL: 'Anpassat namn',
    POS_V2_SYNCED_WITH_REGISTER: 'Synkas automatiskt med produktregistret',
    GENERATE_POS_BUTTONS: 'Generera knappar',
    POS_BUTTON_LINK_TYPE: 'Vad ska knappen vara kopplad till?',
    PREFILLED_TEXT: 'Förifylld text',
    POS_USERS: 'Användare',
    POS_V2_USERS: 'POS V2-användare',
    // -- Personal (personalliggare) --
    STAFF_MENU: 'Personal',
    STAFF_EMPLOYEES: 'Anställda',
    STAFF_DEVICES: 'Stämpelklockor',
    STAFF_LEDGER: 'Personalliggare',
    STAFF_ACCESS_LOG: 'Granskningslogg',
    STAFF_EMPLOYEES_SUBTITLE: 'Personal som stämplar in och ut i den elektroniska personalliggaren',
    STAFF_DEVICES_SUBTITLE: 'Stämpelklockor och personliga telefoner som registrerats för lokalen',
    STAFF_LEDGER_SUBTITLE: 'Närvaro, arbetspass och export för kontrollbesök',
    STAFF_NOT_CONFIGURED: 'Personalliggaren är inte konfigurerad i den här miljön.',
    // Schemaläggning (staff scheduling)
    STAFF_SCHEDULE_TITLE: 'Schema',
    STAFF_SCHEDULE_INTRO: 'Planera veckans pass, se planerat mot faktiskt arbetad tid och publicera när det är klart.',
    STAFF_SCHEDULE_THIS_WEEK: 'Denna vecka',
    STAFF_SCHEDULE_COPY_PREVIOUS: 'Kopiera föregående vecka',
    STAFF_SCHEDULE_REPEAT: 'Upprepa',
    STAFF_SCHEDULE_REPEAT_FROM: 'Upprepar passet från',
    STAFF_SCHEDULE_REPEAT_UNTIL: 'Till och med',
    STAFF_SCHEDULE_REPEAT_EVERY: 'Hur ofta',
    STAFF_SCHEDULE_REPEAT_DAYS: 'Veckodagar',
    STAFF_SCHEDULE_REPEAT_DAYS_HINT: 'Lämna tomt för samma veckodag som passet.',
    STAFF_SCHEDULE_REPEAT_DO: 'Skapa passen',
    STAFF_SCHEDULE_REPEAT_NOTE: 'Passen skapas som utkast och blir fristående — att ändra ett av dem ändrar bara det. Vill du ändra mönstret får du ta bort passen och upprepa igen.',
    STAFF_SCHEDULE_REPEAT_CREATED: '{count} pass skapade.',
    STAFF_SCHEDULE_REPEAT_SKIPPED: '{count} dagar hoppades över (passet fanns redan).',
    STAFF_SCHEDULE_REPEAT_CAPPED: 'Gränsen nåddes — upprepa igen för resten.',
    STAFF_SCHEDULE_EVERY_WEEK: 'Varje vecka',
    STAFF_SCHEDULE_EVERY_2ND_WEEK: 'Varannan vecka',
    STAFF_SCHEDULE_EVERY_3RD_WEEK: 'Var tredje vecka',
    STAFF_SCHEDULE_EVERY_4TH_WEEK: 'Var fjärde vecka',
    STAFF_SCHEDULE_VIEW_MONTH: 'Månad',
    STAFF_SCHEDULE_THIS_MONTH: 'Denna månad',
    STAFF_SCHEDULE_WEEK_SHORT: 'v.',
    STAFF_SCHEDULE_OPEN_SHORT: 'lediga',
    STAFF_SCHEDULE_VIEW_WEEK: 'Vecka',
    STAFF_SCHEDULE_VIEW_DAY: 'Dag',
    STAFF_SCHEDULE_BY_EMPLOYEE: 'Per anställd',
    STAFF_SCHEDULE_BY_ROLE: 'Per roll',
    STAFF_SCHEDULE_NO_ROLES_USED: 'Inga pass den här veckan.',
    STAFF_SCHEDULE_PRINT: 'Skriv ut',
    STAFF_SCHEDULE_PRINTED_AT: 'Utskrivet',
    STAFF_SCHEDULE_EXPORT_CSV: 'Exportera CSV',
    STAFF_SCHEDULE_DATE: 'Datum',
    STAFF_SCHEDULE_WEEKDAY: 'Veckodag',
    STAFF_SETTINGS_TITLE: 'Roller och mallar',
    STAFF_SETTINGS_INTRO: 'Vilka roller enheten bemannar, och vilka passformer som används. Ändras sällan.',
    STAFF_SETTINGS_BACK: 'Till schemat',
    STAFF_ROLE_SECTION: 'Roller',
    STAFF_ROLE_ADD: 'Ny roll',
    STAFF_ROLE_EDIT: 'Ändra roll',
    STAFF_ROLE_NAME: 'Roll',
    STAFF_ROLE_COLOUR: 'Färg i schemat',
    STAFF_ROLE_ORDER: 'Ordning',
    STAFF_ROLE_NONE: 'Inga roller angivna. Schemat använder då de roller som redan finns på pass och anställda.',
    STAFF_ROLE_RETIRED: 'Avställd',
    STAFF_ROLE_RETIRE: 'Ställ av — rollen kan inte väljas på nya pass',
    STAFF_ROLE_REINSTATE: 'Aktivera igen',
    STAFF_ROLE_NAME_REQUIRED: 'Ange ett rollnamn.',
    STAFF_ROLE_USAGE: 'Pass med den här rollen',
    STAFF_ROLE_RENAME_WARNING: 'Namnbytet ändrar bara listan. Befintliga pass behåller det gamla namnet och visas som okatalogiserade.',
    STAFF_ROLE_DRIFT_TITLE: 'Roller som används men inte finns i listan',
    STAFF_ROLE_DRIFT_HINT: 'De kommer från pass och anställda. Lägg in dem för att ge dem färg och ordning — eller städa bort dem som inte ska finnas.',
    STAFF_ROLE_ADD_THIS: 'Lägg in den här rollen',
    STAFF_ROLE_SEED: 'Lägg in alla',
    STAFF_ROLE_SEEDED: '{count} roll(er) lades in.',
    STAFF_TEMPLATE_SECTION: 'Passmallar',
    STAFF_TEMPLATE_HINT: 'En mall är en genväg, inte en regel: att ändra en mall ändrar inga redan lagda pass.',
    STAFF_TEMPLATE_ADD: 'Ny mall',
    STAFF_TEMPLATE_EDIT: 'Ändra mall',
    STAFF_TEMPLATE_NAME: 'Namn',
    STAFF_TEMPLATE_TIME: 'Tid',
    STAFF_TEMPLATE_PAID: 'Betalt',
    STAFF_TEMPLATE_NONE: 'Inga mallar ännu.',
    STAFF_TEMPLATE_NAME_REQUIRED: 'Ange ett namn på mallen.',
    STAFF_TEMPLATE_NO_LINK: 'Mallen fylls i när du lägger ett pass. Den kopplas inte till passet efteråt.',
    STAFF_SCHEDULE_COPY_FROM: 'Kopiera från vecka…',
    STAFF_SCHEDULE_COPY_SOURCE: 'Kopiera från',
    STAFF_SCHEDULE_COPY_MODE: 'Hur',
    STAFF_SCHEDULE_COPY_REPLACE: 'Ersätt veckan',
    STAFF_SCHEDULE_COPY_ADD: 'Lägg till passen',
    STAFF_SCHEDULE_COPY_REPLACE_HINT: 'Passen i den här veckan tas bort först. Publicerade pass ersätts också.',
    STAFF_SCHEDULE_COPY_ADD_HINT: 'Passen läggs till utöver dem som redan finns. Kan ge dubbletter.',
    STAFF_SCHEDULE_COPY_TARGET: 'Kopieras till',
    STAFF_SCHEDULE_COPY_DO: 'Kopiera',
    STAFF_SCHEDULE_COPY_RESULT: '{created} pass kopierade från {from}.',
    STAFF_SCHEDULE_PUBLISH: 'Publicera',
    STAFF_SCHEDULE_REPUBLISH: 'Publicera ändringar',
    STAFF_SCHEDULE_PUBLISHED: 'Publicerat',
    STAFF_SCHEDULE_CHANGED: 'Ändrat sedan publicering',
    STAFF_SCHEDULE_DRAFT: 'Utkast',
    STAFF_SCHEDULE_WHO: 'Vem',
    STAFF_SCHEDULE_PLANNED: 'Planerat',
    STAFF_SCHEDULE_ACTUAL: 'Arbetat',
    STAFF_SCHEDULE_DIFF: 'Diff',
    STAFF_SCHEDULE_COST: 'Kostnad',
    STAFF_SCHEDULE_TOTAL: 'Totalt',
    STAFF_SCHEDULE_OPEN_SHIFTS: 'Lediga pass',
    STAFF_SCHEDULE_OPEN_SHIFT: 'Ledigt pass (ingen)',
    STAFF_SCHEDULE_NO_ROLE: 'Ingen roll',
    STAFF_SCHEDULE_ROLE: 'Roll',
    STAFF_SCHEDULE_START: 'Börjar',
    STAFF_SCHEDULE_END: 'Slutar',
    STAFF_SCHEDULE_BREAK: 'Rast (min)',
    STAFF_SCHEDULE_NOTE: 'Anteckning',
    STAFF_SCHEDULE_ADD: 'Lägg till pass',
    STAFF_SCHEDULE_NEW_SHIFT: 'Nytt pass',
    STAFF_SCHEDULE_EDIT_SHIFT: 'Ändra pass',
    STAFF_SCHEDULE_DELETE: 'Ta bort',
    STAFF_SCHEDULE_BAD_TIME: 'Ange tid som HH:MM, till exempel 16:00.',
    STAFF_SCHEDULE_TIME_HINT: 'Sluttid före starttid betyder att passet går över midnatt.',
    STAFF_SCHEDULE_NO_EMPLOYEES: 'Inga anställda på enheten än. Lägg till dem under Anställda först.',
    STAFF_SCHEDULE_NO_WORKPLACE: 'Personalmodulen är inte upplagd för den här enheten än.',
    STAFF_SCHEDULE_WARNINGS: '{count} varning(ar) om arbetstid',
    STAFF_SCHEDULE_WARNINGS_HINT: 'endast rådgivande, schemat sparas ändå. Kollektivavtal kan vara strängare än lagen.',
    STAFF_SCHEDULE_FOOTER: '{shifts} pass denna vecka, {open} lediga.',
    STAFF_SCHEDULE_NO_WEATHER: 'Inget väder: ange enhetens koordinater för att visa prognosen.',
    STAFF_SCHEDULE_WEATHER_SOURCE: 'Väder från SMHI.',
    STAFF_INACTIVE: 'inaktiv',
    STAFF_ABSENCE_PENDING: 'Frånvaroansökningar att besluta',
    STAFF_ABSENCE_APPROVE: 'Bevilja',
    STAFF_ABSENCE_DECLINE: 'Avslå',
    STAFF_SMS_OPT_OUT: 'Inga schema-SMS',
    STAFF_SMS_OPT_OUT_HINT: 'Påslaget: den anställda får inget SMS när schema eller lediga pass publiceras.',
    STAFF_PHONE_HINT: 'Svenskt mobilnummer, eller med landskod: +358…. Används för inloggning i Mina sidor och schema-SMS.',
    STAFF_UNIT_ALERT_PHONE: 'Telefon för frånvaroansökningar',
    STAFF_UNIT_ALERT_PHONE_HINT: 'Ett SMS skickas hit när en anställd ansöker om frånvaro. Lämna tomt för inget — ansökningar syns ändå under Schema.',
    STAFF_ERROR: 'Något gick fel',
    STAFF_SAVED: 'Sparat',
    STAFF_RETRY: 'Försök igen',
    STAFF_CANCEL: 'Avbryt',
    STAFF_SAVE: 'Spara',
    STAFF_DONE: 'Klar',
    STAFF_SEARCH: 'Sök',
    STAFF_REQUIRED: 'Obligatoriskt',
    STAFF_SETUP_TITLE: 'Kom igång med personalliggaren',
    STAFF_SETUP_HINT: 'Ange verksamhetslokalens uppgifter. Företagsnamn och organisationsnummer skrivs in på varje händelse i liggaren.',
    STAFF_SETUP_REQUIRED: 'Personalliggaren är inte uppsatt för den här lokalen ännu. Börja under Anställda.',
    STAFF_DISPLAY_NAME: 'Lokalens namn',
    STAFF_COMPANY_NAME: 'Företagsnamn',
    STAFF_ORG_NO: 'Organisationsnummer',
    STAFF_ADDRESS: 'Adress',
    STAFF_SETUP_SAVE: 'Kom igång',
    STAFF_ADD_EMPLOYEE: 'Lägg till anställd',
    STAFF_EDIT_EMPLOYEE: 'Redigera anställd',
    STAFF_FORM_HINT: 'Uppgifterna används i personalliggaren. Tidigare händelser behåller de uppgifter som gällde då.',
    STAFF_SECTION_PERSON: 'Person',
    STAFF_SECTION_EMPLOYMENT: 'Anställning',
    STAFF_SECTION_CONTACT: 'Kontakt',
    STAFF_FIRST_NAME: 'Förnamn',
    STAFF_LAST_NAME: 'Efternamn',
    STAFF_NATIONAL_ID: 'Personnummer eller samordningsnummer',
    STAFF_NATIONAL_ID_HINT: 'Sparas skyddat och visas bara maskerat. Kan inte ändras i efterhand.',
    STAFF_ROLES: 'Roller',
    STAFF_ROLES_HINT: 'Kommaseparerade, t.ex. kock, servis',
    STAFF_EMPLOYMENT_FORM: 'Anställningsform',
    STAFF_START_DATE: 'Startdatum',
    STAFF_EMAIL: 'E-post',
    STAFF_PHONE: 'Telefon',
    STAFF_PIN: 'PIN-kod (4 siffror)',
    STAFF_PIN_HINT: 'Används för att stämpla in och ut. Unik inom restaurangen. Kan lämnas tom och sättas senare.',
    STAFF_PIN_INVALID: '4 siffror, inte samma siffra upprepad',
    STAFF_SET_PIN: 'Sätt ny PIN',
    STAFF_SET_PIN_HINT: 'Den gamla PIN-koden slutar fungera direkt online, och på stämpelklockorna vid nästa synk.',
    STAFF_PIN_SET_FOR: 'Ny PIN satt för {name}',
    STAFF_NO_PIN: 'Ingen PIN',
    STAFF_DEACTIVATE: 'Avsluta anställning',
    STAFF_DEACTIVATE_HINT: 'Personen kan inte längre stämpla. Historiken i personalliggaren finns kvar.',
    STAFF_END_DATE: 'Slutdatum',
    STAFF_SHOW_INACTIVE: 'Visa avslutade',
    STAFF_EMPLOYEE: 'Anställd',
    STAFF_IDENTITY: 'Identitet',
    STAFF_STATUS: 'Status',
    STAFF_STATUS_ACTIVE: 'Aktiv',
    STAFF_STATUS_INACTIVE: 'Avslutad',
    STAFF_NO_EMPLOYEES: 'Inga anställda ännu',
    STAFF_NO_EMPLOYEES_HINT: 'Lägg till personalen som ska stämpla i lokalen.',
    STAFF_ENROL_DEVICE: 'Registrera enhet',
    STAFF_SCOPE: 'Typ',
    STAFF_SCOPE_WORKPLACE: 'Delad stämpelklocka',
    STAFF_SCOPE_EMPLOYEE: 'Personlig telefon',
    STAFF_SCOPE_EMPLOYEE_HINT: 'En personlig telefon kan bara stämpla för en person och sparar bara den personens PIN.',
    STAFF_DEVICE_NAME: 'Enhetens namn',
    STAFF_CODE_VALID_MINUTES: 'Koden gäller',
    STAFF_CREATE_CODE: 'Skapa kod',
    STAFF_NEW_CODE: 'Ny kod',
    STAFF_CODE_HINT: 'Skanna QR-koden med enheten, öppna länken eller skriv in koden. Den kan användas en gång.',
    STAFF_CODE_EXPIRES: 'Går ut om {time}',
    STAFF_CODE_EXPIRED: 'Koden har gått ut. Skapa en ny.',
    STAFF_COPY_LINK: 'Kopiera länk',
    STAFF_LINK_COPIED: 'Länken är kopierad',
    STAFF_OPEN_LINK: 'Öppna',
    STAFF_DEVICE: 'Enhet',
    STAFF_ENROLLED: 'Registrerad',
    STAFF_LAST_SEEN: 'Senast aktiv',
    STAFF_NEVER: 'Aldrig',
    STAFF_JUST_NOW: 'Nyss',
    STAFF_MINUTES_AGO: 'För {n} min sedan',
    STAFF_REVOKE: 'Spärra',
    STAFF_REVOKED: 'Spärrad',
    STAFF_REVOKE_HINT: 'Enheten slutar fungera vid nästa anrop. Stämplingar som inte synkats ligger kvar på enheten tills den registreras igen.',
    STAFF_REASON: 'Anledning',
    STAFF_NO_DEVICES: 'Inga enheter registrerade',
    STAFF_NO_DEVICES_HINT: 'Registrera stämpelklockan vid personalingången med en engångskod.',
    STAFF_PRESENT_NOW: 'Närvarande nu',
    STAFF_NOBODY_PRESENT: 'Ingen är i lokalen.',
    STAFF_SINCE: 'Sedan',
    STAFF_PERIOD: 'Period',
    STAFF_SHIFTS: 'Arbetspass',
    STAFF_EVENTS: 'Händelser',
    STAFF_START: 'Start',
    STAFF_END: 'Slut',
    STAFF_DURATION: 'Tid',
    STAFF_NOTES: 'Anmärkningar',
    STAFF_NO_SHIFTS: 'Inga arbetspass under perioden.',
    STAFF_ANOMALY_OPEN: 'Ej utstämplad',
    STAFF_ANOMALY_DUPLICATE_IN: 'Dubbel instämpling',
    STAFF_ANOMALY_ORPHAN_OUT: 'Utstämpling utan instämpling',
    STAFF_OFFLINE_CAPTURED: 'Registrerad offline',
    STAFF_INTEGRITY_OK: 'Kedjan verifierad',
    STAFF_INTEGRITY_BROKEN: 'Kedjan är bruten',
    STAFF_EXPORT: 'Exportera',
    STAFF_EXPORT_JSON: 'JSON',
    STAFF_EXPORT_SHIFTS_CSV: 'Arbetspass (CSV)',
    STAFF_EXPORT_EVENTS_CSV: 'Granskningsspår (CSV)',
    STAFF_EXPORT_WITH_IDS: 'Export med personnummer',
    STAFF_EXPORT_WITH_IDS_HINT: 'Personnummer lämnas bara ut med en angiven anledning. Anledningen och antalet personnummer loggas.',
    STAFF_EXPORT_FORMAT: 'Format',
    STAFF_EXPORT_REASON_PLACEHOLDER: 't.ex. Kontrollbesök Skatteverket',
    STAFF_EXPORT_DONE: 'Exporten är nedladdad',
    STAFF_TIME: 'Tidpunkt',
    STAFF_TYPE: 'Typ',
    STAFF_IDENTIFICATION: 'Identifiering',
    STAFF_RECORDED_BY: 'Registrerad av',
    STAFF_SUPERSEDED: 'Ersatt',
    STAFF_TYPE_PUNCH_IN: 'Instämpling',
    STAFF_TYPE_PUNCH_OUT: 'Utstämpling',
    STAFF_TYPE_PUNCH_CORRECTION: 'Korrigering',
    STAFF_TYPE_PUNCH_VOID: 'Makulering',
    STAFF_VERIFIED_SERVER: 'PIN (kontrollerad av servern)',
    STAFF_VERIFIED_DEVICE: 'PIN (kontrollerad offline på enheten)',
    STAFF_VERIFIED_NONE: 'Ej verifierad',
    STAFF_BY_MANAGER: 'Chef',
    STAFF_CORRECT: 'Korrigera',
    STAFF_VOID: 'Makulera',
    STAFF_CORRECT_HINT: 'Korrigeringen läggs till som en ny händelse. Originalet finns kvar och syns i granskningsspåret.',
    STAFF_VOID_HINT: 'Makuleringen läggs till som en ny händelse och tar bort stämplingen ur arbetspassen. Originalet finns kvar i granskningsspåret.',
    STAFF_CORRECTED_TYPE: 'Ska vara',
    STAFF_CORRECTED_TIME: 'Rätt tidpunkt',
    STAFF_ACCESS_LOG_SUBTITLE: 'Vem som gjort vad: exporter och utlämnade personnummer, PIN-koder, enheter och ändringar av personal',
    STAFF_ACTION: 'Händelse',
    STAFF_ACTOR: 'Utförd av',
    STAFF_TARGET: 'Avser',
    STAFF_IDS_REVEALED: 'Personnummer',
    STAFF_NO_LOG: 'Inga poster under perioden.',
    STAFF_ACTION_LEDGER_EXPORT: 'Export av personalliggaren',
    STAFF_ACTION_LEDGER_READ: 'Läsning av personalliggaren',
    STAFF_ADD_TILL_INTRO_NO_STAFF: 'Skapa en ny kassa med ett namn. Ange sedan kassans enhets-id i kassan för att ta den i bruk.',
    STAFF_TILL_NAME_REQUIRED: 'Ange ett namn för kassan.',
    STAFF_TILL_CREATE_FAILED: 'Det gick inte att skapa kassan. Försök igen.',
    STAFF_TILL_NEW_CODE_TITLE: 'Ny engångskod för kassan',
    STAFF_TILL_NEW_CODE_INTRO: 'Skapa en engångskod som ansluter personalens PIN-inloggning till den här kassan.',
    STAFF_TILL_DEVICE_ID: 'Kassans enhets-id',
    STAFF_TILL_STEP_SETUP_ID: 'Ange kassans enhets-id i rutan "Registrera kassan" (på finska "Ota tämä kassa käyttöön") och tryck Registrera.',
    STAFF_ADD_TILL: 'Lägg till kassa',
    STAFF_ADD_TILL_INTRO: 'Skapa en ny kassa med ett namn. Du får en engångskod för just den kassan: när koden anges i kassan tar den över kassan och ansluter personalens PIN-inloggning i samma steg.',
    STAFF_TILL_NAME: 'Kassans namn',
    STAFF_TILL_NAME_PLACEHOLDER: 't.ex. Kassa 2',
    STAFF_TILL_NAME_HINT: 'Namnet anges bara här — kassan hämtar det härifrån.',
    STAFF_TILL_CREATE_CODE: 'Skapa kod',
    STAFF_TILL_CODE_LABEL: 'Engångskod för kassan',
    STAFF_TILL_STEP_OPEN: 'Öppna kassan på den nya enheten och logga in på enheten.',
    STAFF_TILL_STEP_SETUP: 'Ange engångskoden i rutan "Registrera kassan" (på finska "Ota tämä kassa käyttöön") och tryck Registrera.',
    STAFF_TILL_STEP_DONE: 'Klart. Kassan syns under Kassa → Enheter, och personalen loggar in med sin PIN.',
    STAFF_TILL_CODE_UNAVAILABLE: 'Personalmodulen är inte aktiverad för enheten, eller så saknar du behörighet. Utan personalmodulen registreras en ny kassa direkt i kassan med ett namn.',
    STAFF_KIND_TILL: 'Kassa',
    STAFF_KIND_KIOSK: 'Stämpelklocka',
    STAFF_ACTION_EMPLOYEE_POS_ACCESS: 'Kassaåtkomst ändrad',
    STAFF_POS_ACCESS: 'Kassaåtkomst',
    STAFF_POS_ENABLED: 'Får använda kassan',
    STAFF_POS_ENABLED_HINT: 'Personen loggar in i kassan med samma fyrsiffriga PIN som i stämpelklockan. Namnet hamnar på kvittot och i journalminnet.',
    STAFF_POS_PERMISSIONS: 'Behörigheter i kassan',
    STAFF_POS_MAX_DISCOUNT: 'Högsta rabatt',
    STAFF_POS_PERM_REFUND: 'Får göra returer',
    STAFF_POS_PERM_REMOVE_FROM_TAB: 'Får ta bort artiklar från en nota',
    STAFF_POS_PERM_SPLIT_TAB: 'Får dela en nota',
    STAFF_POS_PERM_VIEW_SETTINGS: 'Får öppna kassans inställningar',
    STAFF_POS_PERM_VIEW_JOURNAL: 'Får läsa kassaregisterjournalen',
    STAFF_POS_PERM_VIEW_JOURNAL_HINT: 'Kassan visar sina egna journalposter (journalminnet). Hela journalen läses i admin.',
    STAFF_POS_PERM_MOVE_BOOKING: 'Får flytta bokningar',
    STAFF_POS_PERM_EDIT_BOOKING_TIME: 'Får ändra bokningstider',
    STAFF_POS_PERM_EDIT_TABLE_MAP: 'Får ändra bordskartan',
    STAFF_POS_NEEDS_PIN: 'Ange en PIN-kod först — utan den går det inte att logga in i kassan.',
    STAFF_POS_HANDLE: 'Kassa-id',
    STAFF_POS_HANDLE_HINT: 'Numret som står på kvitton och i journalminnet. Det ändras aldrig.',
    STAFF_PUNCH_ONLY: 'Endast stämpling',
    STAFF_POS_GRANTED: '{name} kan nu använda kassan (kassa-id #{id}).',
    STAFF_POS_WITHDRAWN: '{name} har inte längre kassaåtkomst.',
    STAFF_REQUIRE_PUNCH_TO_SELL: 'Kräv instämpling för att använda kassan',
    STAFF_REQUIRE_PUNCH_TO_SELL_HINT: 'När detta är på kan ingen logga in i kassan utan att vara instämplad i personalliggaren.',
    STAFF_ACTION_LEDGER_MANUAL_PUNCH: 'Manuell stämpling',
    STAFF_ACTION_LEDGER_CORRECT: 'Korrigerad stämpling',
    STAFF_ACTION_LEDGER_VOID: 'Makulerad stämpling',
    STAFF_ACTIONS: 'Åtgärder',
    STAFF_MANUAL_ENTRY: 'Manuell',
    STAFF_CLOSE_SHIFT: 'Stäng pass',
    STAFF_ADD_PUNCH: 'Lägg till stämpling',
    STAFF_MANUAL_HINT: 'Lägg till en stämpling som aldrig registrerades i stämpelklockan. Den märks som manuell i personalliggaren, med din motivering, ditt namn och tidpunkten du la in den.',
    STAFF_MANUAL_TIME: 'När passet faktiskt började eller slutade',
    STAFF_MANUAL_AFTER: 'Måste vara efter {time}.',
    STAFF_MANUAL_BEFORE: 'Måste vara före {time}.',
    STAFF_MANUAL_REASON_HINT: 'T.ex. Glömde stämpla ut, bekräftat med schemat',
    STAFF_WHICH_PUNCH: 'Gäller stämplingen',
    STAFF_ACTION_IDENTITY_RESOLVE: 'Personnummer hämtat',
    STAFF_ACTION_PIN_CREDENTIALS_ISSUE: 'PIN-uppgifter till enhet',
    STAFF_ACTION_WORKPLACE_UPSERT: 'Lokal sparad',
    STAFF_ACTION_EMPLOYEE_CREATE: 'Anställd skapad',
    STAFF_ACTION_EMPLOYEE_UPDATE: 'Anställd ändrad',
    STAFF_ACTION_EMPLOYEE_PIN: 'PIN-kod satt',
    STAFF_ACTION_EMPLOYEE_DEACTIVATE: 'Anställning avslutad',
    STAFF_ACTION_DEVICE_ENROLMENT_CODE: 'Registreringskod skapad',
    STAFF_ACTION_DEVICE_ENROL: 'Enhet registrerad',
    STAFF_ACTION_DEVICE_REVOKE: 'Enhet spärrad',
    STAFF_ACTION_PAYROLL_RATE_SET: 'Lön angiven',
    STAFF_ACTION_PAYROLL_RATE_READ: 'Löner visade',
    STAFF_ACTION_PAYROLL_REPORT: 'Personalkostnad visad',
    STAFF_PAYROLL: 'Löner',
    STAFF_PAYROLL_SUBTITLE: 'Timlön eller månadslön per anställd, från det datum den gäller',
    STAFF_PAYROLL_SENSITIVE: 'Lönedata är känsliga uppgifter. Varje visning och ändring loggas i granskningsloggen.',
    STAFF_LABOUR_COST: 'Personalkostnad',
    STAFF_LABOUR_COST_SUBTITLE: 'Personalkostnad jämfört med försäljning, per dag och per anställd',
    STAFF_CURRENT_RATE: 'Nuvarande lön',
    STAFF_UPCOMING_RATE: 'Kommande',
    STAFF_NO_RATE: 'Ingen lön angiven',
    STAFF_NEW_RATE: 'Ny lön',
    STAFF_NEW_RATE_HINT: 'En ny lön läggs till från ett datum. Tidigare löner ändras aldrig, så redan beräknad personalkostnad står fast.',
    STAFF_RATE_HISTORY: 'Lönehistorik',
    STAFF_RATE: 'Lön',
    STAFF_RATE_TYPE: 'Lönetyp',
    STAFF_RATE_HOURLY: 'Timlön',
    STAFF_RATE_MONTHLY: 'Månadslön',
    STAFF_VALID_FROM: 'Gäller från',
    STAFF_OVERHEAD: 'Arbetsgivaravgift / påslag (%)',
    STAFF_OVERHEAD_HINT: 'Läggs på lönen i personalkostnaden, t.ex. 31,42 % arbetsgivaravgift.',
    STAFF_PER_HOUR: 'kr/tim',
    STAFF_PER_MONTH: 'kr/mån',
    STAFF_SET_BY: 'Angiven av',
    STAFF_NO_HISTORY: 'Ingen lön registrerad ännu.',
    STAFF_SALES_NET: 'Försäljning exkl. moms',
    STAFF_SALES_GROSS: 'inkl. moms',
    STAFF_LABOUR_PCT: 'Personalkostnad %',
    STAFF_HOURS: 'Timmar',
    STAFF_COSTED_HOURS: 'med angiven lön',
    STAFF_BY_DAY: 'Per dag',
    STAFF_BY_EMPLOYEE: 'Per anställd',
    STAFF_DATE: 'Datum',
    STAFF_RATE_MISSING: 'Lön saknas',
    STAFF_WARNING_NO_RATE: '{n} anställda har arbetat utan angiven lön – de timmarna räknas inte in i kostnaden.',
    STAFF_WARNING_OPEN_SHIFTS: '{n} pass är inte utstämplade och räknas inte.',
    STAFF_SALES_UNAVAILABLE: 'Ingen försäljning för perioden – personalkostnaden visas ändå.',
    STAFF_SALES_SOURCE: 'Försäljning från kassakvitton',
    STAFF_ASSUMPTIONS: 'Så räknas det',
    STAFF_GO_TO_PAYROLL: 'Ange löner',
    POS_V2_DEVICES: 'POS V2-enheter',
    POS_JOURNAL_TITLE: 'Kassaregisterjournal',
    POS_JOURNAL_INTRO: 'Journalminnet för enheten: alla kassor i samma serie, nyast först.',
    POS_JOURNAL_REGISTER: 'Kassaregister',
    POS_JOURNAL_SCOPE_UNIT: 'alla kassor',
    POS_JOURNAL_SCOPE_DEVICE: 'en kassa',
    POS_JOURNAL_DEVICE: 'Kassa',
    POS_JOURNAL_ALL_DEVICES: 'Alla kassor',
    POS_JOURNAL_NO_DEVICE: 'Servern',
    POS_JOURNAL_SEQ: 'Nr',
    POS_JOURNAL_TIME: 'Tid',
    POS_JOURNAL_TYPE: 'Typ',
    POS_JOURNAL_RECEIPT: 'Kvitto',
    POS_JOURNAL_AMOUNT: 'Belopp',
    POS_JOURNAL_CASHIER: 'Kassör',
    POS_JOURNAL_OLDER: 'Visa äldre',
    POS_JOURNAL_PERIOD: 'Period',
    POS_JOURNAL_EMPTY_RANGE: 'Inga journalposter under den valda perioden.',
    POS_JOURNAL_RANGE_CAPPED: 'Journalen läses nyast först, så äldre perioder hämtas i steg. Välj Visa äldre för att fortsätta bakåt.',
    POS_JOURNAL_COUNT_LOADED: 'visade av hämtade poster',
    POS_JOURNAL_RELOAD: 'Uppdatera',
    POS_JOURNAL_LOADING: 'Hämtar journalen…',
    POS_JOURNAL_EMPTY: 'Inga journalposter för enheten än.',
    POS_JOURNAL_LOAD_FAILED: 'Det gick inte att hämta journalen.',
    POS_JOURNAL_NO_PERMISSION: 'Du har inte behörighet att läsa journalen.',
    POS_JOURNAL_UNAVAILABLE: 'Journalen är inte tillgänglig i den här miljön än.',
    POS_JOURNAL_TYPE_SALE: 'Försäljning',
    POS_JOURNAL_TYPE_RETURN: 'Retur',
    POS_JOURNAL_TYPE_COPY: 'Kvittokopia',
    POS_JOURNAL_TYPE_CORRECTION: 'Rättelse',
    POS_JOURNAL_TYPE_PROFORMA: 'Preliminärt kvitto',
    POS_JOURNAL_TYPE_INTERRUPTED: 'Avbrutet kvitto',
    POS_JOURNAL_TYPE_X_REPORT: 'X-rapport',
    POS_JOURNAL_TYPE_Z_REPORT: 'Z-rapport',
    POS_JOURNAL_TYPE_LOGIN: 'Inloggning',
    POS_JOURNAL_TYPE_LOGOUT: 'Utloggning',
    POS_JOURNAL_TYPE_MODE_CHANGE: 'Lägesbyte',
    POS_JOURNAL_TYPE_CLOCK_CHANGE: 'Klockändring',
    POS_JOURNAL_TYPE_PRICE_CHANGE: 'Prisändring',
    FR_TITLE_X: 'X-dagrapport',
    FR_TITLE_Z: 'Z-dagrapport',
    FR_SUBTITLE: 'Innehållet följer Skatteverkets föreskrifter SKVFS 2014:9, 7 kap. 2 § (X) och 3 § (Z). Hänvisningen vid varje rad visar vilket krav raden uppfyller.',
    FR_PDF_SUBTITLE: 'Dagrapport enligt SKVFS 2014:9 7 kap. Hänvisningen i högerkolumnen anger punkt i föreskriften.',
    FR_PDF_PAGE: 'Sida',
    FR_FILE_PREFIX: 'dagrapport',
    FR_FOOTNOTE_PLAIN: 'Belopp i SEK. Tidpunkter i svensk tid (Europe/Stockholm).',
    FR_FOOTNOTE: 'Belopp i SEK. Tidpunkter i svensk tid (Europe/Stockholm). Ett streck betyder att uppgiften inte kan hämtas ur underlaget — inte att värdet är noll.',
    FR_NO_REPORT: 'Ingen rapport att visa för den valda perioden.',
    FR_NO_ROWS: 'Inga rader.',
    FR_TOTAL: 'Summa',
    FR_AMOUNT: 'Belopp',
    FR_QTY: 'Antal',
    FR_ACCOUNT: 'Konto',
    FR_BALANCE: 'Differens',

    FR_EXPORT_PDF: 'PDF',
    FR_EXPORT_CSV: 'CSV',
    FR_PRINT: 'Skriv ut',

    FR_SECTION_IDENTITY: 'Säljare och kassaregister',
    FR_SECTION_PERIOD: 'Period och tidpunkt',
    FR_SECTION_TOTALS: 'Försäljning och summor',
    FR_SECTION_VAT: 'Moms per skattesats',
    FR_SECTION_PAYMENTS: 'Försäljning per betalningsmedel',
    FR_SECTION_GROUPS: 'Försäljning per varugrupp',
    FR_SECTION_COUNTERS: 'Räknare',
    FR_SECTION_REDUCTIONS: 'Returer, rabatter och ej avslutade försäljningar',
    FR_SECTION_ACCOUNTINGS: 'Bokföringskonton',
    FR_SECTION_GAPS: 'Uppgifter som saknas i underlaget',

    FR_COMPANY: 'Företagsnamn',
    FR_ORGNO: 'Organisationsnummer',
    FR_VATNO: 'Momsregistreringsnummer',
    FR_SALESLOCATION: 'Försäljningsställe',
    FR_ADDRESS: 'Adress',
    FR_KASSABETECKNING: 'Kassabeteckning',

    FR_ZNO: 'Z-rapportens löpnummer',
    FR_PRINTED_AT: 'Rapporten togs',
    FR_PERIOD_FROM: 'Perioden börjar',
    FR_PERIOD_TO: 'Perioden slutar',

    FR_SALES_NET: 'Försäljning netto (exkl. moms)',
    FR_SALES_VAT: 'Moms',
    FR_SALES_TOTAL: 'Försäljning brutto (inkl. moms)',
    FR_ROUNDING: 'Öresavrundning',
    FR_CASH_FLOAT: 'Växelkassa',
    FR_CASH_TAKEN: 'Kontant in',
    FR_CASH_EXPECTED: 'Ska finnas i kassan',
    FR_CASH_COUNTED: 'Räknat (senaste)',
    FR_CASH_DIFFERENCE: 'Kassadifferens',
    FR_NOTE_CASH_FROM_TILL: 'Kontant som stannat i kassan (efter växel) under dagen, enligt kassan.',
    FR_NOTE_CASH_EXPECTED: 'Växelkassa + kontant in.',
    FR_NOTE_CASH_COUNTED: 'Dagens senaste räkning av kassan, gjord i kassan.',
    FR_NOTE_CASH_DIFFERENCE: 'Räknat minus vad som skulle finnas vid räkningen.',
    FR_GRAND_SALES: 'Grand total försäljning',
    FR_GRAND_RETURNS: 'Grand total retur',
    FR_GRAND_NET: 'Grand total netto',

    FR_VAT_RATE: 'Skattesats',
    FR_VAT_NET: 'Netto',
    FR_VAT_VAT: 'Moms',
    FR_VAT_GROSS: 'Brutto',
    FR_PAYMENT_MEANS: 'Betalningsmedel',
    FR_GROUP: 'Varugrupp',
    FR_GROUP_NONE: 'Utan varugrupp',

    FR_GOODS_QTY: 'Antal sålda varor',
    FR_SERVICES_QTY: 'Antal sålda tjänster',
    FR_RECEIPT_COUNT: 'Antal kvitton',
    FR_RECEIPT_RANGE: 'Kvittonummer från–till',
    FR_DRAWER_OPENINGS: 'Antal kassalådeöppningar',
    FR_RECEIPT_COPIES: 'Kvittokopior, antal',
    FR_TRAINING_COUNT: 'Antal övningsregistreringar',

    FR_RETURNS: 'Returer, belopp',
    FR_DISCOUNTS: 'Rabatter, belopp',
    FR_DISCOUNT_COUNT: 'Rabatter, antal',
    FR_OTHER_REDUCTIONS: 'Andra prisnedsättningar',
    FR_INTERRUPTED: 'Ej avslutade försäljningar, antal',
    FR_CORRECTIONS: 'Rättade kvitton (felslag), antal',
    FR_PROFORMA: 'Preliminära kvitton (proforma), antal',

    FR_GAPS_TITLE: 'Följande uppgifter som SKVFS 2014:9 7 kap. kräver kan inte hämtas ur underlaget:',
    FR_STATE_OK: 'Hämtad ur underlaget',
    FR_STATE_DERIVED: 'Beräknad här, inte rapporterad direkt',
    FR_STATE_UNRELIABLE: 'Underlaget lämnar ett känt felaktigt värde',
    FR_STATE_MISSING: 'Lämnas inte av underlaget',
    FR_STATE_NOT_APPLICABLE: 'Funktionen finns inte i kassaregistret',

    FR_NOTE_GRAND_ZERO: 'Kvitto-API:t returnerar alltid noll för grand total (ärvt från den gamla VB-implementationen). De ackumulerade summorna finns i journalminnet men exponeras inte hit.',
    FR_NOTE_NO_KASSABETECKNING: 'Kassabeteckningen ingår inte i dagsavslutets svar. Den finns i journalminnets rapporthuvud.',
    FR_NOTE_NO_ZNO: 'Inget löpnummer satt — en X-rapport förbrukar inget nummer.',
    FR_NOTE_ROUNDING: 'Läst ur bokföringsraden för avrundningskontot. Öresavrundning är inte ett SKVFS-krav på dagrapporten, men behövs för avstämning.',
    FR_NOTE_NO_CASH_FLOAT: 'Växelkassan registreras per dag i enhetens inställningar men lämnas inte av dagsavslutet och läses inte in här.',
    FR_NOTE_NO_DRAWER: 'Kassan rapporterar inga kassalådehändelser, så det finns ingen räknare att visa.',
    FR_NOTE_COPIES_IN_JOURNAL: 'Kvittokopior räknas i journalminnet, inte i dagsavslutet.',
    FR_NOTE_NO_TRAINING: 'Kassaregistret har inget övningsläge, så kravet aktualiseras inte.',
    FR_NOTE_RETURNS_FOLDED: 'En retur lagras som ett kvitto med negativa belopp och räknas in i försäljningssummorna. Journalminnet skiljer ut returer.',
    FR_NOTE_NO_OTHER_REDUCTIONS: 'Andra prisnedsättningar än rabatter särredovisas inte i underlaget.',
    FR_NOTE_GROUP_ID: 'Underlaget anger varugruppens ID, inte dess namn, och de sammanslagna raderna innehåller inga kvantiteter — antal sålda varor och tjänster redovisas i stället under Räknare.',

    FR_CSV_FIELD: 'Uppgift',
    FR_CSV_VALUE: 'Värde',
    FR_CSV_SKVFS: 'SKVFS',
    FR_CSV_STATE: 'Status',
    FR_CSV_NOTE: 'Kommentar',

    FR_NOTE_COPIES_AMOUNT_X: 'Varken dagsavslutet eller journalminnets löpande summor har kopiornas belopp; det finns först på Z-dagrapporten.',
    FR_NOTE_INTERRUPTED_AMOUNT_SETTLEMENT: 'Dagsavslutet räknar ej avslutade kvitton men summerar inte deras belopp.',
    TIP_TAB: 'Dricks',
    TIP_TITLE: 'Dricks',
    TIP_UNIT: 'Enhet',
    TIP_PERIOD: 'Period',
    TIP_GENERATED: 'Framtagen',
    TIP_TOTAL: 'Dricks totalt',
    TIP_RECEIPT_COUNT: 'Kvitton med dricks',
    TIP_LINE_COUNT: 'Dricksrader',
    TIP_DAYS_WITH_TIPS: 'Dagar med dricks',
    TIP_AVERAGE: 'Snitt per kvitto',
    TIP_RECEIPTS_WORD: 'kvitton',
    TIP_SECTION_SUMMARY: 'Sammanfattning',
    TIP_SECTION_RECEIPTS: 'Dricks per kvitto',
    TIP_SECTION_CHECK: 'Avstämning',
    TIP_PER_DAY: 'Dricks per dag',
    TIP_PER_SETTLEMENT: 'Dricks per dagsavslut (Z)',
    TIP_PER_MEANS: 'Dricks per betalsätt',
    TIP_RECEIPTS: 'Kvittolistan',
    TIP_COL_DATE: 'Datum',
    TIP_COL_TIME: 'Tid',
    TIP_COL_RECEIPT_NO: 'Kvittonr',
    TIP_COL_SETTLEMENT: 'Dagsavslut',
    TIP_COL_RECEIPT_RANGE: 'Kvittonr från–till',
    TIP_COL_MEANS: 'Betalsätt',
    TIP_COL_TIP: 'Dricks',
    TIP_COL_RECEIPTS: 'Kvitton',
    TIP_COL_RECEIPT_TOTAL: 'Kvittobelopp',
    TIP_OPEN_DAY: 'Ej avslutad dag',
    TIP_EXPORT_RECEIPTS_CSV: 'CSV per kvitto (lön)',
    TIP_EXPORT_SUMMARY_CSV: 'CSV sammanställning',
    TIP_FILE_PREFIX: 'dricks',
    TIP_FILE_RECEIPTS: 'per-kvitto',
    TIP_FILE_SUMMARY: 'sammanstallning',
    TIP_DEFINITION: 'Dricks är kvittorader med benämningen "Extra" och 0 % moms, från både äldre och nya kassor. Ett underlag för lön, inte en del av kassaregistrets dagrapporter.',
    TIP_NOTE_DAY: 'Kvittots egen dag i svensk tid, inte affärsdagen.',
    TIP_NOTE_MEANS: '"Inget", "Okänt" och "Flera betalsätt" är dricks som inte kan knytas till ett enskilt betalsätt.',
    TIP_NOTE_SETTLEMENT: '"Ej avslutad dag" är kvitton som ännu inte ingår i något dagsavslut.',
    TIP_CHECK_OK: 'Stämmer',
    TIP_CHECK_BAD: 'Stämmer inte',
    TIP_CHECK_OK_SUMMARY: 'Per dag, per dagsavslut, per betalsätt och per kvitto summerar alla till periodens total.',
    TIP_CHECK_BAD_SUMMARY: 'Uppdelningarna summerar inte till periodens total:',
    TIP_NONE: 'Ingen dricks registrerad under perioden.',
    TIP_ERROR: 'Dricksrapporten kunde inte hämtas.',
    TIP_TRUNCATED: 'Kvittolistan är avkortad till de 5 000 senaste kvittona. Totaler och uppdelningar omfattar hela perioden; välj en kortare period för hela listan.',
    TIP_PRINT_TOO_MANY: 'För många kvitton för utskrift. Använd PDF eller CSV för hela listan.',
    TIP_FOOTNOTE: 'Belopp i SEK. Tider i svensk tid (Europe/Stockholm).',

    FR_TITLE_COMPILATION: 'Sammanställning av dagsavslut',
    FR_DIALOG_SETTLEMENT: 'Dagsavslut nr',
    FR_EMAIL_SIE: 'E-posta kontering (SIE)',
    FR_SOURCE_JOURNAL: 'Källa: Z-dagrapporten i kassaregistrets journalminne, som den förseglades vid dagens stängning. Kontering från dagsavslutet för samma dag.',
    FR_SOURCE_SETTLEMENT: 'Källa: dagsavslutet (SQL). Uppgifter som dagsavslutet inte innehåller anges som saknade nedan.',
    FR_SOURCE_SETTLEMENT_JOURNAL: 'Källa: ej avslutade kvitton sedan senaste dagsavslut. Grand totaler, kvittokopior och kassabeteckning ur journalminnet.',
    FR_LIST_SOURCE_JOURNAL: 'Z-dagrapporter ur journalminnet, en per affärsdag. Klicka på en rad för rapporten.',
    FR_LIST_SOURCE_SETTLEMENT: 'Dagsavslut. Enheten har inga Z-dagrapporter i journalminnet.',
    FR_BUSINESS_DATE: 'Affärsdag',
    FR_DAY_CLOSED_AT: 'Dagen stängd',
    FR_FIRST_SALE: 'Första registrering',
    FR_LAST_SALE: 'Sista registrering',
    FR_CONTROL_UNIT: 'Kontrollenhet (tillverkningsnummer)',
    FR_CASHIER: 'Kassör',
    FR_SALES_GROSS: 'Total försäljning (före returer)',
    FR_RETURNS_AMOUNT_TOTALS: 'Avgår: returer',
    FR_SALES_AFTER_RETURNS: 'Försäljning efter returer (inkl. moms)',
    FR_GROUPS: 'Försäljning per huvudgrupp',
    FR_RECEIPT_COPIES_AMOUNT: 'Kvittokopior, belopp',
    FR_RETURNS_COUNT: 'Returer, antal',
    FR_INTERRUPTED_AMOUNT: 'Ej avslutade försäljningar, belopp',
    FR_SECTION_EVENTS: 'Löpande användning',
    FR_EVENT_LOGIN: 'Inloggningar',
    FR_EVENT_LOGOUT: 'Utloggningar',
    FR_EVENT_PRICE_CHANGE: 'Prisändringar',
    FR_EVENT_MODE_CHANGE: 'Lägesbyten',
    FR_EVENT_CLOCK_CHANGE: 'Klockändringar',
    FR_VAT_CHECK_OK: 'Momsspecifikationen summerar till försäljningen efter returer ({expected} {cur}).',
    FR_VAT_CHECK_BAD: 'Momsspecifikationen summerar INTE till försäljningen efter returer: summa per skattesats {actual}, försäljning {expected}, differens {diff} {cur}. Underlaget behöver kontrolleras.',
    FR_SETTLEMENT: 'dagsavslut nr',
    FR_ACCOUNTINGS_FROM: 'Konteringen kommer från',
    FR_ACCOUNTINGS_FROM_NOTE: 'Dagsavslutet görs i kassan och följer inte nödvändigtvis Z-dagrapportens affärsdag; jämför perioderna.',
    FR_ACCOUNTINGS_NONE: 'Inget dagsavslut i kassan börjar inom den här affärsdagen, så det finns ingen kontering att visa. Z-dagrapporten är komplett ändå.',
    FR_NOTE_FROM_JOURNAL: 'Ur journalminnet.',
    FR_NOTE_GRAND_FROM_JOURNAL: 'Ur journalminnets löpande summa, som den står just nu. Nollställs aldrig.',
    FR_NOTE_GRAND_NET: 'Grand total försäljning minus grand total retur (2 kap. 5 §).',
    FR_NOTE_COPIES_SINCE_JOURNAL_Z: 'Ur journalminnet: kopior sedan senaste Z-dagrapport, vilket kan vara en annan startpunkt än dagsavslutets.',
    FR_NOTE_CONTROL_UNIT: 'Ingen kontrollenhet är ansluten ännu. Tillverkningsnumret krävs på kvittot (7 kap. 1 § l), inte på dagrapporten.',
    FR_NOTE_CASHIER_SETTLEMENT: 'Rapporten tas fram i administrationen, inte av en kassör.',
    FR_NOTE_CASHIER_Z: 'Z-dagrapporten tas fram automatiskt av servern när dagen stängs.',
    FR_NOTE_NO_KASSABETECKNING_JOURNAL: 'Rapporthuvudet saknar kassabeteckning.',
    FR_NOTE_CLOSE_TIME: 'Enligt enhetens inställda stängningstid.',
    FR_NOTE_GROUPS_NOT_IN_JOURNAL: 'Journalminnets rader saknar varugrupp, så försäljningen kan inte delas upp per huvudgrupp.',
    FR_NOTE_CASH_FLOAT_CLIENT: 'Registrerad i kassan vid dagens början.',
    FR_NOTE_CASH_FLOAT_NOT_REGISTERED: 'Ingen växelkassa registrerades i kassan den här dagen.',
    FR_NOTE_RECEIPTS_SUM: 'Försäljnings- plus returkvitton, som journalminnet räknar var för sig.',
    FR_NOTE_OTHER_REDUCTIONS_JOURNAL: 'Journalminnet räknar rättade kvitton men särredovisar inte andra registreringar som minskat försäljningen eller deras belopp.',
    FR_NOTE_INTERRUPTED_AMOUNT: 'Journalminnet räknar ej avslutade försäljningar men sparar inte deras belopp.',
    FR_NOTE_EVENTS: 'Inget krav på dagrapporten, men händelserna ska finnas i journalminnet (SKVFS 2014:9 4 kap.). Antalet här är det en granskare stämmer av mot journalen.',
    FR_NOTE_COMPILATION: 'En sammanställning av flera dagsavslut har inget eget löpnummer och är ingen Z-dagrapport.',

    PRINT_TO_POS_PRINTER: 'Skriv ut på kassaskrivare',
    POS_LOG_MEMORY_TITLE: 'Kassalogg',
    POS_LOG_MEMORY_INTRO: 'Vad kassorna gjort: notor, artiklar, bokningar, bongningar och betalningar, nyast först.',
    POS_LOG_MEMORY_PERIOD: 'Period',
    POS_LOG_MEMORY_TILL: 'Kassa',
    POS_LOG_MEMORY_ALL_TILLS: 'Alla kassor',
    POS_LOG_MEMORY_UNKNOWN_TILL: 'Okänd kassa',
    POS_LOG_MEMORY_CASHIER: 'Kassör',
    POS_LOG_MEMORY_ALL_CASHIERS: 'Alla kassörer',
    POS_LOG_MEMORY_NO_CASHIER: 'Ingen kassör',
    POS_LOG_MEMORY_RELOAD: 'Uppdatera',
    POS_LOG_MEMORY_TIME: 'Tid',
    POS_LOG_MEMORY_TYPE: 'Händelse',
    POS_LOG_MEMORY_ORDER: 'Order',
    POS_LOG_MEMORY_DETAIL: 'Detalj',
    POS_LOG_MEMORY_LOADING: 'Hämtar kassaloggen…',
    POS_LOG_MEMORY_EMPTY: 'Inga kassahändelser loggade för enheten under den valda perioden.',
    POS_LOG_MEMORY_EMPTY_FILTER: 'Inga händelser matchar den valda kassan och kassören.',
    POS_LOG_MEMORY_CAPPED: 'Bara de nyaste händelserna i perioden lästes. Korta perioden för att se resten.',
    POS_LOG_MEMORY_COUNT_LOADED: 'visade av hämtade händelser',
    POS_LOG_MEMORY_LOAD_FAILED: 'Det gick inte att hämta kassaloggen.',
    POS_LOG_MEMORY_NO_PERMISSION: 'Du har inte behörighet att läsa kassaloggen.',
    POS_LOG_MEMORY_TYPE_CUSTOMER_TAB: 'Nota',
    POS_LOG_MEMORY_TYPE_TRANSACTION_FAILED: 'Betalning misslyckades',
    POS_LOG_MEMORY_TYPE_CREATE_RECEIPT: 'Kvitto skapat',
    POS_LOG_MEMORY_TYPE_CORRECT_RECEIPT: 'Kvitto rättat',
    POS_LOG_MEMORY_TYPE_REFUND_RECEIPT: 'Retur',
    POS_LOG_MEMORY_TYPE_MOVE_BOOKING: 'Bokning flyttad',
    POS_LOG_MEMORY_TYPE_COPY_BOOKING: 'Bokning kopierad',
    POS_LOG_MEMORY_TYPE_UPDATE_BOOKING: 'Bokning ändrad',
    POS_LOG_MEMORY_TYPE_UPDATE_TAB: 'Nota ändrad',
    POS_LOG_MEMORY_TYPE_ADD_ITEM: 'Artikel tillagd',
    POS_LOG_MEMORY_TYPE_REMOVE_ITEM: 'Artikel borttagen',
    POS_LOG_MEMORY_TYPE_UPDATE_ITEM: 'Artikel ändrad',
    POS_LOG_MEMORY_TYPE_TO_KITCHEN: 'Bongning',
    POS_DEVICES_SUBTITLE: 'Kassor som har registrerat sig för den här enheten. Sparade ändringar gäller direkt i kassan.',
    POS_DEVICES_TABLE_TITLE: 'Kassor',
    POS_DEVICES_EMPTY: 'Inga kassor registrerade för den här enheten',
    POS_DEVICES_EMPTY_HINT: 'Öppna POSv2 i kassan. Den frågar efter ett namn första gången den startar.',
    POS_DEVICES_NAME: 'Namn på kassan',
    POS_DEVICES_ID: 'Enhets-ID',
    POS_DEVICES_LAST_SEEN: 'Senast aktiv',
    POS_DEVICES_NEVER_SEEN: 'Aldrig',
    POS_DEVICES_EDIT: 'Redigera kassa',
    POS_DEVICES_FORM_HINT: 'Sparade inställningar skickas direkt till kassan.',
    POS_DEVICES_SECTION_IDENTITY: 'Identitet',
    POS_DEVICES_SECTION_HARDWARE: 'Hårdvara',
    POS_DEVICES_UNIT_HINT: 'Byter du rutt flyttas kassan till en annan enhet.',
    POS_DEVICES_NAME_REQUIRED: 'Ange ett namn på kassan',
    POS_DEVICES_ROUTE_REQUIRED: 'Ange en rutt',
    POS_DEVICES_SAVED: 'Kassans inställningar sparade',
    POS_DEVICES_NEW_STAFF_CODE: 'Ny engångskod för personalinloggning',
    POS_DEVICES_REMOVE: 'Ta bort kassa',
    POS_DEVICES_REMOVE_CONFIRM: 'Kassan tas bort från enheten och personalens inloggning på den spärras. En kassa som använder den får välja en annan kassa.',
    POS_DEVICES_REMOVED: 'Kassan är borttagen.',
    POS_DEVICES_REMOVE_FAILED: 'Det gick inte att ta bort kassan.',
    POS_DEVICES_ADD_TILL: 'Lägg till kassa',
    POS_DEVICES_ADD_WITHOUT_STAFF: 'Ny kassa: öppna kassan på den nya enheten och ge den ett namn, så dyker den upp här. Med personalmodulen aktiverad lägger du i stället till kassan här med en engångskod, så att personalen kan logga in med sin PIN.',
    POS_DEVICES_STAFF_SIGNIN: 'Personalinloggning',
    POS_DEVICES_STAFF_CONNECTED: 'Ansluten',
    POS_DEVICES_STAFF_REVOKED_TAG: 'Spärrad',
    POS_DEVICES_STAFF_REVOKE: 'Spärra personalinloggning',
    POS_DEVICES_STAFF_REVOKE_HINT: 'Personalen kan inte längre logga in på den här kassan förrän den registreras igen med en ny kod. Kassans inställningar (skrivare, terminal, språk) finns kvar.',
    POS_DEVICES_STAFF_REVOKE_REASON: 'Anledning',
    POS_DEVICES_STAFF_REVOKED: 'Personalinloggningen är spärrad för kassan.',
    POS_DEVICES_STAFF_REVOKE_FAILED: 'Det gick inte att spärra personalinloggningen.',
    POS_DEVICES_SAVE_ERROR: 'Kunde inte spara kassans inställningar',
    POS_DEVICES_LOAD_ERROR: 'Kunde inte hämta kassor',
    POS_DEVICES_SURFBOARD: 'Surfboard',
    POS_DEVICES_SECTION_SURFBOARD: 'Surfboard',
    POS_DEVICES_SURFBOARD_MODE: 'Betalsätt',
    POS_DEVICES_SURFBOARD_APPSWITCH: 'Appväxling (CheckoutX)',
    POS_DEVICES_SURFBOARD_TERMINAL_MODE: 'Extern terminal',
    POS_DEVICES_SURFBOARD_MODE_HINT: 'Inte valt: Surfboard-betalsättet som kassören väljer avgör.',
    POS_DEVICES_SURFBOARD_TERMINAL: 'Surfboard-terminal',
    POS_DEVICES_SURFBOARD_TERMINAL_HINT: 'Används med extern terminal. Appväxling betalar med CheckoutX som är registrerad i själva kassan.',
    POS_DEVICES_SURFBOARD_NOT_CONFIGURED: 'Surfboard är inte konfigurerat för den här enheten',
    POS_DEVICES_SURFBOARD_TERMINAL_NONE: 'Ingen (välj terminal vid varje betalning)',
    USERS_SUBTITLE: 'Hantera POS V2-användare, behörigheter och inloggning i kassan',
    USERS_ADD: 'Skapa användare',
    USERS_EDIT: 'Redigera användare',
    USERS_USE_LOGIN: 'Använd inloggning i kassan',
    USERS_USE_LOGIN_HINT: 'Kräver pinkod vid inloggning',
    USERS_TIMEOUT_MINUTES: 'Timeout (minuter)',
    USERS_LOGOUT_TYPE: 'Utloggningstyp',
    USERS_AUTO_LOGOUT: 'Automatisk utloggning vid inaktivitet',
    USERS_MANUAL_LOGOUT: 'Logga ut manuellt',
    USERS_SETTINGS_SAVED: 'Inloggningsinställningar sparade',
    USERS_SETTINGS_SAVE_ERROR: 'Kunde inte spara inloggningsinställningar',
    USERS_FIRST_NAME: 'Förnamn',
    USERS_LAST_NAME: 'Efternamn',
    USERS_EMPLOYEE_ID: 'Anställnings-ID',
    USERS_PIN: 'Pinkod',
    USERS_REFUND: 'Kan göra återköp',
    USERS_REMOVE_FROM_TAB: 'Kan ta bort artiklar från nota',
    USERS_MAX_DISCOUNT: 'Max % rabatt',
    USERS_EMPTY: 'Inga användare ännu',
    USERS_EMPTY_HINT: 'Skapa din första POS V2-användare',
    USERS_FORM_HINT: 'Fyll i användaruppgifter och behörigheter',
    USERS_FIRST_NAME_REQUIRED: 'Förnamn krävs',
    USERS_LAST_NAME_REQUIRED: 'Efternamn krävs',
    USERS_EMPLOYEE_ID_REQUIRED: 'Anställnings-ID krävs',
    USERS_EMAIL_REQUIRED: 'E-post krävs',
    USERS_PIN_REQUIRED: 'Pinkod krävs',
    USERS_PIN_INVALID: 'Pinkod måste vara 4–8 siffror',
    USERS_EMAIL_INVALID: 'Ogiltig e-postadress',
    USERS_CREATED: 'Användaren skapades',
    USERS_UPDATED: 'Användaren uppdaterades',
    USERS_DELETED: 'Användaren togs bort',
    USERS_LOAD_ERROR: 'Kunde inte hämta användare',
    USERS_SAVE_ERROR: 'Kunde inte spara användaren',
    USERS_DELETE_ERROR: 'Kunde inte ta bort användaren',
    USERS_DELETE_HEADER: 'Ta bort användare',
    USERS_DELETE_CONFIRM: 'Är du säker på att du vill ta bort denna användare?',
    USERS_TABLE_TITLE: 'Användare',
    USERS_SECTION_PERSONAL: 'Personuppgifter',
    USERS_SECTION_ACCESS: 'Åtkomst',
    USERS_SECTION_PERMISSIONS: 'Behörigheter',
    USERS_TOGGLE_PIN: 'Visa eller dölj pinkod',
    USERS_ACTIVE_HINT: 'Inaktiva användare kan inte logga in på POS',
    // Sidebar labels for the POS section (the screens keep their own titles)
    NAV_POS_BUTTON_LAYER: 'POS knapplager',
    NAV_POS_DEVICES: 'Enheter',
    NAV_POS_ACTIVITY_LOG: 'Aktivitetslogg',
    POS_SETTINGS: 'Inställningar',
    POS_SETTINGS_SUBTITLE: 'Konfigurera kassainställningar för denna enhet.',
    POS_QUICK_RAIL: 'Snabbmeny',
    POS_QUICK_RAIL_SUBTITLE: 'Konfigurera knappen för öppna produkter som visas bredvid varukorgen i POS V2.',
    POS_QUICK_RAIL_OPEN_PRODUCTS_ENABLED: 'Aktivera öppna produkter',
    POS_QUICK_RAIL_OPEN_PRODUCTS_ENABLED_HINT: 'Visa knappen för öppna produkter i snabbmenyn i kassan.',
    POS_QUICK_RAIL_OPEN_PRODUCTS: 'Öppna produkter',
    POS_QUICK_RAIL_OPEN_PRODUCTS_HINT: 'Välj produkter från produktregistret som personalen kan prissätta manuellt.',
    POS_QUICK_RAIL_OPEN_PRODUCTS_EMPTY: 'Inga öppna produkter valda ännu. Lägg till produkter ovan.',
    POS_QUICK_RAIL_ADD_PRODUCTS: 'Lägg till produkter',
    POS_QUICK_RAIL_DELETE_CONFIRM: 'Är du säker på att du vill ta bort "{name}"?',
    POS_QUICK_RAIL_SAVED: 'Snabbmeny-inställningar sparade.',
    POS_QUICK_RAIL_SAVE_ERROR: 'Kunde inte spara snabbmeny-inställningar. Försök igen.',
    POS_QUICK_RAIL_LOAD_ERROR: 'Kunde inte ladda snabbmeny-inställningar. Försök igen.',
    POS_QUICK_MESSAGES: 'Snabbmeddelanden',
    POS_QUICK_MESSAGES_SUBTITLE: 'Hantera snabbmeddelanden som visas i kassan.',
    POS_QUICK_MESSAGES_PLACEHOLDER: 'Ange ett snabbmeddelande',
    POS_QUICK_MESSAGES_EMPTY: 'Inga snabbmeddelanden ännu. Lägg till ett ovan.',
    POS_QUICK_MESSAGES_SAVED: 'Snabbmeddelanden sparade.',
    POS_QUICK_MESSAGES_SAVE_ERROR: 'Kunde inte spara snabbmeddelanden. Försök igen.',
    POS_QUICK_MESSAGES_LOAD_ERROR: 'Kunde inte ladda snabbmeddelanden. Försök igen.',
    POS_QUICK_MESSAGES_DELETE_CONFIRM: 'Är du säker på att du vill ta bort "{message}"?',
    POS_ORDER_MESSAGES: 'Orderkommentarer',
    POS_ORDER_MESSAGES_SUBTITLE: 'Färdiga meddelanden som personalen kan välja i kassans orderkommentar, för hela ordern.',
    POS_ORDER_MESSAGES_PLACEHOLDER: 'Skriv en orderkommentar',
    POS_ORDER_MESSAGES_EMPTY: 'Inga orderkommentarer än. Lägg till en ovan.',
    POS_ORDER_MESSAGES_SAVED: 'Orderkommentarer sparade.',
    POS_ORDER_MESSAGES_SAVE_ERROR: 'Det gick inte att spara orderkommentarerna. Försök igen.',
    POS_ORDER_MESSAGES_LOAD_ERROR: 'Det gick inte att hämta orderkommentarerna. Försök igen.',
    POS_SIGN_IN: 'Inloggning',
    POS_DAY_CLOSE: 'Dagsavslut',
    POS_Z_CLOSE_TIME: 'Z-rapport stängningstid',
    POS_Z_CLOSE_TIME_HINT: 'Klockslaget (svensk tid) då dagen stängs och varje kassa får sin Z-rapport.',
    POS_Z_CLOSE_TIME_DEFAULT: 'Inte inställt - dagen stängs kl. 00:00.',
    POS_Z_CLOSE_TIME_INVALID: 'Ange tiden som TT:MM, t.ex. 05:00.',
    POS_Z_CLOSE_TIME_SAVED: 'Z-rapportens stängningstid sparad',
    POS_Z_CLOSE_TIME_SAVE_ERROR: 'Kunde inte spara Z-rapportens stängningstid',
    POS_TIPPING: 'Dricks',
    POS_TIPPING_SUBTITLE: 'Konfigurera dricks för gästens självbetalning.',
    POS_TIPPING_ENABLED: 'Aktivera dricks',
    POS_TIPPING_ENABLED_HINT: 'Visa dricksalternativ i självbetalningsappen.',
    POS_TIPPING_THRESHOLD: 'Minimibelopp',
    POS_TIPPING_THRESHOLD_HINT: 'Dricks visas när beloppet att betala är minst detta värde.',
    POS_TIPPING_SAVED: 'Dricksinställningar sparade.',
    POS_TIPPING_SAVE_ERROR: 'Kunde inte spara dricksinställningar. Försök igen.',
    POS_TIPPING_LOAD_ERROR: 'Kunde inte ladda dricksinställningar. Försök igen.',
    TEAM: 'Team',
    ORDER_PRINTING: 'Orderregler',
    FINANCE: 'Finans',
    TOTALS: 'Total',
    RESTAURANT_INFO: 'Restauranginfo',
    WEBORDER_SETTINGS: 'Webborder',
    FAVICON: 'Favicon (ikon i webbläsarflik och sökresultat)',
    FAVICON_CHANGE: 'Byt favicon',
    FAVICON_REMOVE: 'Ta bort favicon',
    FAVICON_NOTE: 'Kvadratisk PNG, minst 48x48 px (192x192 eller större rekommenderas). Använd en enkel symbol, inte den breda logotypen. Visas i webbläsarflikar och bredvid restaurangen i Googles sökresultat.',
    FAVICON_TOO_SMALL: 'Bilden är {width}x{height} px. En favicon måste vara minst {min}x{min} px.',
    FAVICON_NOT_SQUARE: 'Bilden är {width}x{height} px och inte kvadratisk, så den blir hoptryckt som favicon. En kvadratisk version av symbolen fungerar bäst. Använd ändå?',
    FAVICON_LOAD_FAILED: 'Kunde inte läsa in den valda bilden.',
    APP_BUTTONS: 'App-knappar',
    POS_REPORTS: 'Dagsavslut',
    ORG_SALES: 'Försäljning',
    OPENING_HOURS: 'Öppettider',
    GUESTS: 'Gäster',
    BALANCE_ADJUSTED: 'Saldo justerat',
    ADJUST_BONUS_ERROR: 'Det gick inte att justera bonus. Försök igen senare.',
    ADJUST_BONUS: 'Justera bonus',
    ADJUST_WALLET_ERROR:
        'Det gick inte att justera plånboken. Försök igen senare.',
    AMOUNT_EXCEEDS_BALANCE: 'Belopp överstiger saldo',
    ERROR_FETCHING_TRANSACTIONS:
        'Det gick inte att hämta transaktionerna. Försök igen senare.',
    TOTALT: 'Total',
    TOP_UP: 'Påladdning',
    PAYMENT: 'Betalning',
    STAFF_CARD: 'Personalkort',
    MISC: 'Kategorier',
    SETTINGS: 'Inställningar',
    PRODUCT_SAVED: 'Produkt sparad',
    RESTURANT_INFO: 'Restauranginformation',
    USERS: 'Användare',
    SEE_ALL: 'Se alla...',
    STATISTICS: 'Statistik',
    DARK_MODE: 'Mörkt läge',
    SELECT_UNIT: 'Välj enhet',
    OPENING_H_SAVED: 'Öppettider sparade',
    OPENING_H: 'Öppettider',
    CLOSED: 'Stängt',
    OPEN: 'Öppet',
    OPENS: 'Öppnar',
    APP_OPEN: 'App öppen',
    APP_CLOSED: 'App stängd',
    CLOSES: 'Stänger',
    DEVIATIONS: 'Avvikelser',
    SELECT_LOGO: 'Välj logga..',
    ORG_NO: 'Org. nummer',
    ADRESS: 'Adress',
    ZIP_CODE: 'Postnummer',
    POST_ADR: 'Stad',
    PHONE: 'Telefon',
    EMAIL: 'E-mail',
    SELECT_UNITS: 'Välj enheter',
    APPLY_TO_SELECTED: 'Apply to selected',
    ABOUT_US: 'Om oss',
    ADD_USER: 'Lägg till användare',
    SELECT_ROLE: 'Välj roll',
    ADD_DOMAIN_AUTO:
        'Lägg till användardomäner som automatiskt läggs till i denna användargrupp vid registrering',
    DOMAIN_EXAMPLE: "(t.ex endast 'pubq.se' inte '@pubq.se' )",
    LOAD: 'Ladda',
    SELECT_BONG_CATEGORY: 'Välj bong',
    SELECT_PRODUCT_CATEGORY: 'Välj produkt',
    SELECT_TYPE: 'Välj typ',
    SELECT_TAGS: 'Välj taggar',
    DRINKS: 'Dryck',
    PRODUCT_NAME: 'Produktnamn',
    CONNECT_SOCIAL_MEDIA: 'Länka till dina sociala medier-profiler i appen',
    MANAGE_ADVANCED_SETTINGS: 'Hantera enhetens mer avancerade inställningar',
    QR_ON_TICKET_TEXT:
        'Lägg till en QR-kod på gästens orderbiljett för att möjliggöra ordervalidering med hjälp av scanner',
    CLOSE_ORDER_TICKET_CONFIRMATION_DESCRIPTION:
        'Ställ en kontrollfråga till gästen om orderbiljetten verkligen ska förbrukas',
    MENU_STYLE_DESCRIPTION: 'Välj layout för enhetens appmeny',
    SHOW_COMMENT_ON_ORDER_DESCRIPTION: 'Tillåt kommentar på hela beställningen',
    SHOW_COMMENT_ON_PRODUCT_DESCRIPTION: 'Tillåt kommentar på produktnivå',
    COUPON_CODE_DESCRIPTION:
        'Visa rabattkodfältet i appen så att gäster kan använda rabattkoder',
    COUPON_CODE_INPUT_FIELD: 'Visa rabattkodfältet',
    PRICE_KR_STUDENT: 'Studentpris',
    PRICE_KR_STUDENT_DEDUCTION: 'Studentpris - avdrag',
    OVERVIEW: 'Översikt',
    NEW_ORDER: 'Ny order',
    PERSONAL_BANK_DETAILS: 'Personliga och bankuppgifter',
    CART_ITEMS: 'Varukorgsartiklar',
    LATEST_ORDERS: 'Senaste beställningarna',
    LOGO_AND_IMAGES: 'Logotyper og billeder',
    FONTS: 'Teckensnitt',
    DANGER: 'Fara',
    SUCCESS: 'Framgång',
    SECONDARY: 'Sekundär',
    BASE: 'Bas',
    PRIMARY: 'Primär',
    COLORS: 'Färger',
    BACK: 'Tillbaka',
    ENVIRONMENT_IMAGES: 'Klicka här för att byta logotyp, miljöbilder',
    HIDE_ADVANCE_SETTINGS: 'Dölj förhandsinställningar',
    SHOW_ADVANCE_SETTINGS: 'Visa förhandsinställningar',
    NEW_THEME: 'Nytt tema',
    THEME_MAIN_TEXT: 'Ändra teckensnitt och färger för ditt skyltfönster',
    THEMING: 'Tema',
    CHOOSE: 'Välj...',
    TYPE_OF_OFFER: 'Typ av erbjudande',
    SELECTED_PRODUCTS: 'Valda produkter',
    LINK_TO_PRODUCT_OR_WEBSITE: 'Länka till produkt eller hemsida',
    LINK_TO_PRODUCT: 'Länka till produkt',
    START_WITH_HTTPS: 'måste börja med https://',
    WHERE_IS_PRODUCT: 'Var finns produkten?',
    OFFER_INFO_PLACEHODLER: 'Erbjudandets informationstext...',
    OPTION_DESCRIPTION: 'Beskrivning av erbjudandet',
    SELECT: 'Välj',
    SELECTED: 'Markerade',
    DESELECT: 'Avmarkera',
    DISCOUNT_PERCENTAGE_PLACEHOLDER: 'Rabatt i procent',
    WRITE: 'Skriv...',
    SEARCH_PRODUCT_OR_TAG: 'Sök produkt eller tagg',
    STEP_PLACEHOLDER: 'Steg i bygg din rätt-flödet',
    ABOUT_US_PLACEHOLDER: 'Om oss',
    DOMAIN_EX: 'Domän t.ex pubq.se',
    TIME_CONTROL_MENU: 'Tidsstyr meny',
    SET: 'Ställ in',
    SCHEDULE: 'Schema',
    ACTIVATION_TIME: 'Aktiveringstid',
    ACTIVATE_MENU: 'Aktivera meny',
    WEEK: 'Vecka',
    SELECT_Z_REPORT: 'Välj Z-rapporter',
    FROM_TO: 'Från - Till',
    SEND_END_TO_FORTNOX: 'Skicka detta dagsavslut till Fortnox?',
    IMPORT_SUCCESSFUL: 'Importen lyckades',
    IMPORT_FAILED: 'Importen misslyckades',
    WHICH_EMAIL: 'Vilken emailadress ska filen skickas till?',
    SUMD_Z_REPORTS: 'Summerade Z-rapporter',
    Z_REPORT: 'Z-Rapporter',
    MAIL: 'Maila',
    PREVIOUS_MONTH: 'Föregående månad',
    ADD_NEW_GROUP: 'Lägg till grupp',
    UNIT_SETTINGS: 'Enhetsinställningar',
    OPEN_AND_CLOSE_APP: 'Öppna & stänga app',
    APP_INFORMATION: 'Appinformation',
    NAME_IN_APP: 'Namn i appen',
    DESCRIPTION_IN_APP: 'Beskrivning i appen',
    MESSAGE_WHEN_TAB_CLOSED:
        'Meddelande som visas när den här tabben är stängd',
    MESSAGE: 'Meddelande',
    COMPILATION: 'Sammanställning',
    MEDIAN_RECEIPT: 'Mediankvitto',
    HIGHEST_PURCHASE_RECEIPT: 'Största kvitto',
    HIGHEST_DISCOUNT_RECEIPT: 'Högsta rabatt',
    PRODUCTS_SOLD: 'Produkter sålda',
    ADD_SUBCATEGORY: 'Lägg till underkategori',
    SUBCATEGORY: 'Underkategori',
    SERVING_OPTIONS_MENU: 'Serveringssätt',
    SERVING_OPTIONS_MENU_EXPLANATION:
        'Aktivera dessa serveringssätt när meny är aktiv',
    CREATE_MENU_SCHEDULE: 'Skapa tidsschema för meny',
    LARGEST_ORDER: 'Största order',
    LAST_30_DAY: '30 senaste dagarna',
    GENERAL_SETTINGS: 'Generella inställningar',
    NET: 'Netto',
    ORDER_PRINTING_TEXT:
        'Konfigurera hur beställningar ska hanteras efter bongkategori',
    MENUS_TEXT: 'Hantera menyer – skapa eller redigera',
    MFA: 'MFA',
    ADD_PRICE: 'Lägg till pris',
    DISCARD_ALL_CHANGES: 'Radera alla ändringar',
    DISCARD_ALL_CHANGES_QUESTION:
        'Är du säker på att du vill avbryta och radera dina ändringar?',
    PUBLISH_NEWS_TEXT:
        'Dela nyheter i appen och håll dina användare uppdaterade',
    AUTO_ROTATE_NEWS: 'Autoväxla nyheter',
    TOTAL_SALES_DAY_BY_DAY: 'Totalförsäljning dag för dag',
    FOOD_OPEN: 'Mat öppen',
    OFFER_DETAILS: 'Erbjudandedetaljer',
    ORDERS_AND_RECEIPTS: 'Se beställningar och administrera kvitton',
    ADDON_GROUPS_TEXT: 'Skapa tillvalsgrupper och koppla dem till produkter',
    CONFIRMATION: 'Bekräfta',
    REMOVE_ON_SEVERAL_UNITS: 'Vill du ta bort produkten på fler enheter?',
    FOOD_CLOSED: 'Mat stängd',
    DRINK_OPEN: 'Dryck öppen',
    DRINK_CLOSED: 'Dryck stängd',
    DELETE_PRODUCT: 'Ta bort produkt',
    ARE_YOU_SURE_DELETE_PRODUCT:
        'Är du säker på att du vill ta bort den här produkten?',
    CHECKBOX_OPTION: 'Checkbox',
    LINK_ADDON_TO_PRODUCT: 'Länka till produkt',
    NAME_ADDON: 'Namn på tillval',
    NAME_OF_APP: 'Ingår i app',
    ADD_OPTION: 'Lägg till tillval',
    SET_SCHEDULE: 'Sätt schema',
    SOURCES: 'Säljkanaler',
    JOURNALNR: 'Journalnr',
    CREATED: 'Skapat',
    CATEGORY_CREATED: 'Kategori skapad',
    RECEIPTNO_FROM_TO: 'Kvittonr från-till',
    SUM: 'Summa',
    INTEGRATIONS_HEADER: 'Integrationer',
    BUY_REBUY: 'Köp & återköp',
    WRONG_HIT: 'Felslag',
    CANCELD: 'Avbrutna',
    CONFIRM_BULK: 'Bekräfta',
    PROFORMA: 'Proforma',
    CREATING_ENDOFDAY: 'Skapar dagsavslut',
    NOT_ENOUGH: 'Du har inte omsatt tillräckligt mycket',
    END_OF_DAY_100: 'Dagsavslutet måste innehålla mer än 100',
    Z_ENDOFDAY: 'Z Dagsavslut',
    PREL_X_REPORT: 'Preliminär X rapport',
    PAID: 'Betalt',
    SUM_PAYMENTS: 'Summa alla betalsätt',
    CHANGE_IN: 'Växel IN',
    CHANGE_OUT: 'Växel UT',
    ACCOUNTING_REPORTS: 'Kontering till redovisningen',
    STARTED: 'Påbörjad',
    FINISHED: 'Avslutad',
    ACCOUNTS: 'Konton',
    ROWS: 'Rader',
    SALES: 'Försäljning',
    PAYMENTS: 'Betalsätt',
    RECEIPTS: 'Kvitton',
    ACCOUNTING_ACCOUNTS: 'Bokföringskonton',
    TODAY: 'Idag',
    YESTERDAY: 'Igår',
    LAST_WEEK: 'Förra veckan',
    THIS_MONTH: 'Denna månad',
    LAST_MONTH: 'Förra månaden',
    ORDERS: 'Ordrar',
    END_OF_DAY: 'Dagsavslut',
    HISTORY: 'Historik',
    NAME_AND_COUPON: 'Du måste fylla i namn och välja kupong',
    DELIVERY_SET_LOCATIONS: 'Utkörning till leveransplats',
    NEW_DELIVERY_LOCATION: 'Ny utkörningsplats',
    DELIVERY_LOCATIONS: 'Utkörningsplatser',
    NO_LOCATIONS_ADDED: 'Inga leveransplatser tillagda ännu',
    DISCOUNT_CODE: 'Rabattkod',
    MINIMUM_FEE: 'Minimiavgift',
    MINIMUM_FEE_OPTIONAL: 'Minimiavgift (valfri)',
    EDIT_LOCATIONS: 'Editera platser',
    MOBILE_WALLET: 'Mobile Wallet',
    ALLOW_USER_TO_TRANSFER_MONEY_TO_WALLET_IN_APP:
        'Tillåt användare att fylla på Mobile Wallet i appen',
    ALLOW_USER_TO_TRANSFER_ANY_AMOUNT_TO_MOBILE_WALLET:
        'Tillåt användare att fylla på valfritt belopp',
    ALLOW_USER_TO_ADD_ORGANIZATION_IN_APP:
        'Tillåt användare att ansluta till organisation i appen',
    INVITE_USER: 'Bjud in till team',
    TOTAL_SALES: 'Totalförsäljning',
    SALES_BY_HOUR: 'Försäljning per timme',
    SHORTCUTS: 'Genvägar',
    BAR_CHART_SHORT: 'Stapel',
    ALL: 'Alla',
    COPY_MENU_CONFIRMATION: 'Är du säker på att du vill kopiera menyn?',
    NO_ADDONS_IN_GROUP: 'Inga tillval är skapade för den här gruppen än',
    DELETE_ADDON: 'Radera tillval',
    PUBLISHED: 'Publicerat',
    EDIT_MENU_NAME: 'Ändra namn på meny',
    UNPUBLISHED: 'Opublicerat',
    LINE_CHART_SHORT: 'Linje',
    EDIT_GROUP: 'Ändra grupp',
    NEWS_POSTS: 'Nyhetsposter',
    ARTICLE: 'Artikel',
    SELECT_LOCATION: 'Välj enhet...',
    PRODUCT_LIST_DESCRIPTION:
        'Administrera, uppdatera och organisera dina produkter',
    SHOW_ALL: 'Visa alla',
    UNIT_SWITCHER_SEARCH_UNITS: 'Sök enheter på namn eller ID',
    UNIT_SWITCHER_SELECT: 'för att välja',
    UNIT_SWITCHER_OPEN: 'för att öppna',
    UNIT_SWITCHER_CLOSE: 'för att stänga',
    UNIT_SWITCHER_NO_RESULTS: 'Inga enheter hittades',
    SEND_AGAIN: 'Skicka igen',
    ARTICLE_TEXT: 'Artikelinnehåll',

    CREATE_NEW_GROUP: 'Lägg till ny grupp',
    MINIMUM_VALUE_REQUIRED: 'Minimi värde krävs',
    MAXIMUM_VALUE_REQUIRED: 'Maximalt värde krävs',
    MINIMUM_CANNOT_BE_GREATER_THAN_MAXIMUM:
        'Minsta antal kan inte överstiga Max antal',
    MAXIMUM_CANNOT_BE_LESS_THAN_MINIMUM:
        'Maximalt antal kan inte vara mindre än Minimi antal',
    BONUS_POINTS_UPDATED: 'Bonuspoäng uppdaterade',
    MINIMUM_BONUS_REQUIRED: 'Minimi bonus krävs',
    MENU_ACTIVATED: 'Meny aktiverad',
    ADDON_GROUP_NAME: 'Namn på tillvalsgrupp',
    VISIBLE_IF_MENU_ACTIVE: 'Synlig om meny är aktiv',
    PICK_ONE_OPTION: 'VÄLJ ETT',
    SINGLE_OPTION: 'VÄLJ FLERA',
    ADD_PRODUCTS_TO_GROUP: 'Lägg till produkter',
    DELETE_SUBCATEGORY: 'Ta bort underkategori',
    ADD_ADDON: 'Lägg till tillval',
    DAYS: 'Dagar',
    WEEKS: 'Veckor',
    RESET_PASSWORD: 'Återställ lösenord',
    ENTER_EMAIL_TO_RESET: 'Ange en e-mailadress för att återställa lösenordet.',
    REMOVE_USER_QUESTION: 'Vill du ta bort den här användaren från teamet?',
    REMOVE_USER: 'Ta bort användare',
    CHOOSE_ORGANIZATION_UNITS: 'Lägg till användaren på fler enheter',
    NO_FEATURED_PRODUCTS: 'Det finns inga framhävda produkter',
    MONTHS: 'Månader',
    EDIT: 'Ändra',
    DELETED: 'Raderad',
    ERROR: 'Fel',
    CATEGORY_DELETED: 'Kategori raderad',
    TIP_REPORT: 'Dricksrapport',
    DESC_GENERATE_REPORT:
        'Rapporten genereras till en pdf-fil som automatiskt kommer att laddas ner.',
    GENERATING_REPORT: 'Genererar rapporten',
    ERROR_TIP_REPORT:
        'Något gick fel vid genereringen av dricksrapporten! Prova igen.',
    COMPANY_NAME: 'Bolagsnamn',
    COMPANY_NUMBER: 'Bolagsnummer',
    IMAGE_SHARED: 'Bild delad',
    COST_CENTER: 'Kostnadsställe',
    OVERWRITE_POS_BUTTONS:
        'Du kommer att ta bort din gamla kassaknappar. Vill du fortsätta?',
    EMAIL_NOT_VALID: 'Emailadressen är inte giltig',
    THIS_YEAR: 'Detta år',
    THIS_WEEK: 'Denna vecka',
    FEATURED_PRODUCT: 'Framhävd produkt',
    FEATURED_PRODUCT_DESC:
        'Denna produkt kommer att framhävas på enhetens startsida i appen och kan endast köpas med serveringsmetoden "Äta här". Vill du fortsätta?',
    TEAM_MEMBERS: 'Team-medlemmar',
    RESTRICT_ITEM: 'Begränsa produkt till ett köp per dag',
    ADD_DESCRIPTION_SHORT: 'Lägg till kort beskrivning...',
    ADD_DESCRIPTION_LONG: 'Lägg till lång beskrivning...',
    SEARCH_NAME_OR_TAG: 'Sök på namn eller tagg',
    SELECT_ELLIPSES: 'Välj...',
    BONUS_SYSTEM: 'Bonussystem',
    FILTER_NAME_ID: 'Filtrera på namn eller ID',
    TAG: 'Taggar',
    FIELDS_MISSING_ERROR:
        'Vänligen fyll i alla obligatoriska fält innan du sparar.',
    MAXIMUM_AMOUNT_BONUS: 'Max antal bonuspoäng som får användas i ett köp',
    COLOR_HEADER: 'Färger',
    CANCEL_HEADER: 'Avbryt',
    PUBLISH_HEADER: 'Publish',
    WEB_ORDER_HEADER: 'Webborder',
    PRIMARY_COLOR_HEADER: 'Primärfärger',
    SECONDARY_COLOR_HEADER: 'Sekunderfärger',
    SUCCESS_COLOR_HEADER: 'Succéfärger',
    DANGER_COLOR_HEADER: 'Riskfärger',
    SWISH_NUMBER: 'Swishnummer',
    OPEN_CLOSE_AUTOMATICALLY: 'Öppna/stäng app automatiskt',
    OPEN_CLOSE_SETTINGS: 'Öppna/stäng appen för beställning',
    AUTO_OPENING_HOURS_TITLE: 'Automatiska öppettider',
    AUTO_OPENING_HOURS_DESCRIPTION:
        'Bocka i för att säljkanalerna ska öppna och stänga automatiskt enligt öppettiderna och avvikelserna nedan. Om rutan inte är ibockad visas öppettiderna endast som information.',
    AUTO_OPENING_HOURS_ON:
        'Aktivt – säljkanalerna öppnar och stänger automatiskt enligt tiderna nedan.',
    AUTO_OPENING_HOURS_OFF:
        'Inte aktivt – öppettiderna visas endast som information i säljkanalerna och styr inte när ni öppnar eller stänger.',
    AUTO_OPENING_HOURS_TAG_ON: 'Styr öppning/stängning',
    AUTO_OPENING_HOURS_TAG_OFF: 'Endast information',
    BANNER_IN_APP: 'Banner i appen',
    SOCIAL_MEDIA: 'Sociala medier',
    ALLERGEN_INFORMATION: 'Allergiinformation',
    ALLERGEN_INFORMATION_DESCRIPTION:
        'Fyll i enhetens kontaktuppgifter för att visa i appen vart gäster kan vända sig med allergifrågor',
    ADDON_LIST: 'Tillvalslista',
    ADDONS_HEADER: 'Hantera tillval',
    ADD_UNIQUE_ADDONS: 'Lägg till unikt tillval',
    PRODUCT_DETAILS: 'Produktdetaljer',
    UNIT_NAME: 'Namn',
    COMPANY: 'Bolag',
    ADJUST_WALLET: 'Justera saldo',
    TOTAL_SAVED_WALLETS: 'Totalt antal transaktioner',
    FILTER_RESULT: 'Filtrerat resultat',
    SHOW_MORE: 'Visa alla',
    START_DATE: 'Från',
    END_DATE: 'Till',
    SIGNED_IN: 'Loggade in',
    TOTAL_SAVED_BONUS_POINTS: 'Totalt antal transaktioner',
    APPLY_FILTER: 'Filtrera',
    AMOUNT_TO_ADJUST: 'Lägg till/ta bort',

    //Banking Info Translation
    BANKINFO_HEADER: 'Personliga och bankuppgifter',
    BANKINFO_FIRST_NAME: 'Förnamn',
    BANKINFO_LAST_NAME: 'Efternamn',
    BANKINFO_BUSINESS_NAME: 'Företagsnamn',
    BANKINFO_PHONE_NUMBER: 'Telefonnummer till VD',
    BANKINFO_EMAIL: 'Mejla till VD',
    BANKINFO_TAX_ID: 'Skatte ID',
    BANKINFO_LIST_OF_OWNERS: 'Förteckning över ägare',
    BANKINFO_UPLOAD_IDENTIFCATION: 'Uppladdningsidentifikation',
    BANKINFO_ADD_OWNER: 'Lägg till ägare',
    BANKINFO_BANK_NAME: 'Bank namn',
    BANKINFO_BANK_ACCOUNT_NUMBER: 'Bankkontonummer',
    BANKINFO_BANK_PROOF: 'Ladda upp Bank Screenshot',
    BANKINFO_SEND_VERIFICTION: 'Skicka för verifiering',
    MIN_LENGTH: 'min längd',
    ZERO_NOTIFICATION: 'Inga nya aviseringar',
    //************************************* Pdf translation ***********************
    PDF_HEADER: 'Pdf-vy',
    PDF_DOWNLOAD: 'Ladda ner pdf',
    PDF_FORMAT: 'Välj Sidstorlek',
    PDF_TEXT: 'Skriv text',
    PDF_TEXT_COLOR: 'Text färg',
    PDF_BACKGROUND_COLOR: 'Bakgrundsfärg',

    GRIN_HEADER: 'Återvinningsbar förpackning',
    GRIN_PACKAGES: 'Förpackning',
    GRIN_NONE: 'Ingen',
    LOAD_ALL_USERS: 'Ladda alla användare',
    CAN_ORDER: 'Går att beställa',
    SHOW_IN_APP: 'Visa i app',
    SHOW_IN_KIOSK: 'Visa i expresskassa',
    SHOW_IN_WEB: 'Visa i weborder',
    SHOW_IN_TAKEAWAY: 'Visa för takeaway',
    SHOW_IN_EATHERE: 'Visa för hämta vid disk',
    SHOW_IN_TABLEORDER: 'Visa för bordsbeställning',
    SHOW_IN_DRIVEDELIVERY: 'Visa för utkörning',
    SHOW_IN_FIXEDLOCATION: 'Visa för fast plats',
    DELIVERY_PRICE: 'Leveranspris',
    DELIVERY_TO_LOCATION_PRICE: 'Leverans till platspris',
    STANDARD: 'Standard',
    ADVANCED: 'Avancerat',
    EAT_IN: 'Äta här',
    VAT_ID: 'Momsreg. nr',
    INVALID_EMAIL_OR_PASSWORD: 'Invalid email or password',
    //MENU NAVIGATION
    MENU_NAV_HOME: 'Hem',
    MENU_NAV_APP: 'App',
    MENU_NAV_OPENCLOSE: 'Öppna & stäng',
    MENU_NAV_COMMUNICATION: 'Kommunikation',

    //ADVANCED SETTINGS FOR APP INFO
    CUSTOM_ORDER_TICKET_MESSAGE: 'Anpassat meddelande på orderbiljett',
    CUSTOM_ORDER_SHOW_TICKET_MESSAGE:
        'Den här texten kommer ersätta ordinarie meddelande på orderbiljetten för alla serveringssätt',
    QR_VALIDATION_MESSAGE: 'QR-kod på orderbiljett',
    CLOSE_ORDER_TICKET_CONFIRMATION_MESSAGE: 'Stäng orderbiljett-kontrollfråga',
    SHOW_COMMENT_ON_ORDER_MESSAGE: 'Tillåt kommentar på beställning',
    SHOW_COMMENT_ON_PRODUCT_MESSAGE: 'Tillåt kommentar på produkt',
    ADVANCE_SETTINGS_SAVED: 'Avancerade inställningar sparade',
    FINANCE_EXPORTS_API: 'Exportera finansdata',
    TCPOS_CREDENTIALS: 'Tcpos-inställningar',
    TOKEN: 'Token',
    UNIT_ID: 'Enhets-id',
    TOTAL_DISCOUNT: 'Total rabatt',

    SEARCH_MEMBER: 'Sök via e-post',
    ADD_USER_TO_USERGROUP: 'Lägg till ny medlem',
    ADD_MEMBER: 'Lägg till medlem',
    MEMBER_ADDED: 'Användare tillagd',

    SELF_SERVICE_KIOSK: 'Expresskassa',
    START_SCREEN_IMAGE: 'Startskärm',
    HEADER_IMAGE: 'Header-bild',
    DEFAULT_LANGUAGE: 'Förvalt språk',

    BANNER_IN_KIOSK: 'Notisbanner',
    SHOW_MEMBERSHIP_REGISTRATION_KIOSK: 'Medlemsregistrering',
    SHOW_MEMBERSHIP_REGISTRATION_KIOSK_DESCRIPTION: 'Visa knappen för medlemsregistrering på kiosk',
    SHOW_MEMBERSHIP_REGISTRATION_KIOSK_HELP: 'När aktiverad kan kunder registrera sitt medlemskap (stämpelkort) via QR-skanning på kiosken. Stäng av för att dölja alternativet.',
    KIOSK_FONTS: 'Typsnitt',
    KIOSK_FONTS_DESCRIPTION: 'Välj ett typsnitt för titlar och rubriker, och ett för brödtext. Båda laddas från Google Fonts.',
    FONT_HEADING: 'Titlar och rubriker',
    FONT_BODY: 'Brödtext',
    FONT_PREVIEW: 'Förhandsgranskning',
    FONT_PREVIEW_HEADING: 'Välkommen',
    FONT_PREVIEW_BODY: 'The quick brown fox jumps over the lazy dog.',
    FONT_PREVIEW_HEADING_LABEL: 'Rubrik',
    FONT_PREVIEW_BODY_LABEL: 'Brödtext',
    FONT_USE_SAME_AS_HEADING: 'Samma som rubrik',
    FONT_FILTER_PLACEHOLDER: 'Sök typsnitt...',
    SELECT_FONT: 'Välj typsnitt',
    SLIDER_INTERVAL: 'Bildspelsintervall (sekunder)',
    SLIDER_INTERVAL_PLACEHOLDER: 'Ange intervall i sekunder',
    SLIDER_INTERVAL_DESCRIPTION: 'Tid innan byte till nästa bild (1-60 sekunder)',
    ADD_IMAGE: 'Lägg till bild',
    IMAGE_NUMBER: 'Bild',
    MOVE_UP: 'Flytta upp',
    MOVE_DOWN: 'Flytta ner',
    PREVIEW_IMAGE: 'Förhandsgranska bild',
    SELECT_START_SCREEN_IMAGE: 'Välj startskärmsbild',
    SELECT_HEADER_IMAGE: 'Välj header-bild',
    SELECT_LANGUAGE: 'Välj språk',
    SELECT_TEXT_ALIGN: 'Välj textjustering',
    SELECT_COLOR: 'Välj färg',
    KIOSK_NOT_CONFIGURED: 'Du kan inte ändra startskärmsbilden för expresskassan på denna enhet',
    KIOSK_DEVICE_CONFIG: 'Kiosk-enhetskonfiguration',
    USE_CUSTOM_START_SCREEN_IMAGES: 'Använd anpassade startskärmsbilder för denna enhet',
    KIOSK_NO_DEVICE_REGISTERED: 'Ingen kioskenhet registrerad för denna enhet. Registrera enheten från kioskappen först (ange rutt och enhetsnamn).',
    ROUTE: 'Rutt',
    ROUTE_PLACEHOLDER: 'Ange ruttnamn',
    MULTIPLE_ROUTES: 'Flera rutter',
    MULTIPLE_ROUTES_PLACEHOLDER: 'Kommaseparerade rutter',
    NAME_PLACEHOLDER: 'Namn',
    MODEL: 'Modell',
    MODEL_PLACEHOLDER: 'Modell',
    MENU_CODE: 'Menykod',
    CODE_PLACEHOLDER: 'Kod',
    SOFTPOS: 'SoftPOS',
    SOFTPOS_CURRENCY: 'SoftPOS-valuta',
    SOFTPOS_INTEGRATION_ID: 'SoftPOS-integrations-ID',
    SOFTPOS_INTEGRATION_PASSWORD: 'SoftPOS-integrationslösenord',
    SAVE_DEVICE_CONFIG: 'Spara enhetskonfiguration',
    SELECT_DEVICE: 'Välj enhet',
    PRINTER: 'Skrivare',
    CARD_TERMINAL: 'Kortterminal',
    AVAILABLE_TERMINALS: 'Tillgängliga terminaler',
    NO_TERMINALS_FOUND: 'Inga terminaler hittades',
    LOADING: 'laddar',
    BANNER_TITLE: 'Titel',
    BANNER_MESSAGE: 'Meddelande',
    TEXT_ALIGN_TEXT: 'Textjustering',
    COLOR_THEME_TEXT: 'Färgtema',
    ROLE: 'Roll',
    RESETPASSWORD: 'Återställ lösenord',
    ADMINISTRATOR: 'Administratör',
    TCPOS_PORT: 'TCPOS-port',
    EMAIL_REPORT: 'Maila rapport',
    EDIT_ACCOUNT: 'Ändra kontering',
    EMPLOYEE_ID: 'Anställnings-ID',
    TAG_ID: 'Tag-ID',
    ENTER_EMPLOYEE_ID: 'Ange anställnings-ID',
    ENTER_TAG_ID: 'Ange tag-ID',
    MANUAL_ENTRY: 'Manuell inmatning',
    MANUAL_EMPLOYEE_ID: 'Anställnings-ID',
    MANUAL_TAG_ID: 'Tag-ID',
    ENTER_MANUAL_EMPLOYEE_ID: 'Ange anställnings-ID',
    ENTER_MANUAL_TAG_ID: 'Ange tag-ID',
    ADD_MANUAL_USER: 'Lägg till manuell användare',
    CUSTOMER_NAME: 'Namn',
    RECEIPT_NUMBER: 'Kvitto',
    RECEIPT_TYPE: 'Typ',
    SALES_CHANNEL: 'Säljkanal',
    ORDER_NUMBER: 'Order',
    EMAIL_RECEIPT: 'Maila kvitto',
    DOWNLOAD_AS_PDF: 'Ladda ner PDF',
    TRANSACTIONS_MENU: 'Transaktioner',
    PENDING_REFUNDS: 'Väntande återköp',
    RECEIPT_PURCHASE: 'Köp',
    RECEIPT_REFUND: 'Återköp',
    SEARCH_RECEIPT: 'Sök på kvittonummer',
    PURCHASE_AT: 'Köp hos',
    SUMMARY: 'Sammanfattning',
    EXTRA: 'Extra',
    REFUND: 'Återköp',
    REFUND_SELECTED_ROW: 'Återköp vald rad',
    REFUND_PAYMENT: 'Återbetalning',
    PRODUCTS_TO_REFUND: 'Produkter att återbetala',
    SELECT_REASON: 'Välj en anledning',
    NOTE: 'Anteckning',
    ADD_NOTE_DETAILS: 'Lägg till mer information om denna återbetalning.',
    REFUND_REASON_DUPLICATE: 'Dubbeldebitering',
    REFUND_REASON_FRAUDULENT: 'Otillåten transaktion',
    REFUND_REASON_CUSTOMER_REQUEST: 'Kundbegäran',
    REFUND_REASON_OTHER: 'Annat',
    REFUND_BONUS_POINTS: 'Återbetala bonuspoäng',
    BONUS_POINTS_REFUND: 'Bonuspoäng Återbetalning',
    BONUS_SUMMARY: 'Bonusöversikt',
    AMOUNT_TO_REFUND: 'Belopp att Återbetala',
    ENTER_BONUS_AMOUNT: 'Ange bonusbelopp att återbetala',
    BONUS_REFUND_AMOUNT: 'Bonusbelopp att återbetala',
    NO_BONUS_REMAINING: 'Inga bonuspoäng kvar att återbetala',
    ENTER_BONUS_POINTS_TO_REFUND:
        'Ange antalet bonuspoäng att återbetala (om tillämpligt).',
    REASON_MUST_BE_SELECTED: 'Vänligen välj en anledning för återbetalning',
    NOTE_REQUIRED_FOR_OTHER: 'Anteckning krävs när "Annat" väljs som anledning',
    REFUND_AMOUNT_INVALID: 'Återbetalningsbeloppet måste vara större än 0',
    REFUND_AMOUNT_EXCEEDS_TOTAL:
        'Återbetalningsbeloppet kan inte överstiga det ursprungliga kvittobeloppet',
    BONUS_REFUND_EXCEEDS_ORIGINAL:
        'Bonuspoäng återbetalning kan inte överstiga det ursprungliga bonusbetalningsbeloppet',
    BONUS_REFUND_EXCEEDS_REMAINING:
        'Bonuspoäng återbetalning kan inte överstiga kvarvarande bonusbelopp',
    ORIGINAL_BONUS: 'Ursprunglig Bonus',
    ALREADY_REFUNDED: 'Redan Återbetald',
    REMAINING: 'Kvarvarande',
    ENTER_VERIFICATION_CODE: 'Ange verifieringskod',
    SENT_6_DIGIT_VERIFICATION_CODE:
        'Vi har skickat en 6-siffrig verifieringskod till ditt telefonnummer',
    VERIFICATION_CODE: 'Verifieringskod',
    DIDNT_RECEIVE_THE_CODE: 'Fick du inte koden?',
    HAVING_TROUBLE: 'Har du problem?',
    SWITCH_TO: 'Byt till',
    REMEMBER_THIS_DEVICE_FOR_30_DAYS: 'Kom ihåg den här enheten i 30 dagar',
    VERIFYING_CODE: 'Verifierar kod...',
    VERIFY: 'Verifiera',
    ENTER_6_DIGIT_CODE_FROM_AUTHENTICATOR_APP:
        'Ange den 6-siffriga koden från din autentiseringsapp',
    TWO_FACTOR_AUTHENTICATION_MUST_BE_ENABLED_BY:
        'Tvåfaktorsautentisering (2FA) måste aktiveras av',
    SETUP_2FA: 'Aktivera 2FA',
    SETUP_AUTHENTICATOR: 'Konfigurera autentiseringsapp',
    ADD_PHONE: 'Lägg till telefon',
    RECONFIGURE: 'Konfigurera om',
    RESEND_CODE: 'Skicka igen',
    ADDED_TO_MENU: 'Ingår i meny',
    NOT_ADDED_TO_ANY_MENU: 'Ingår inte i någon meny',
    APP_MENUS: 'Appmenyer',
    NOT_IN_ANY_APP_MENU: 'Ingår inte i någon appmeny',
    NOT_IN_ANY_POS_MENU: 'Ingår inte i någon POS-meny',
    ADD_ADDONS_GROUP_TO_PRODUCT: 'Lägg till tillval',
    CHOOSE_UNIT: 'Välj enhet',
    TITLE_REQUIRED: 'En titel krävs',
    MIN_3_CHARS: 'Minst 3 tecken krävs',
    MESSAGE_REQUIRED: 'Meddelande krävs',
    NO_ADDONS_YET: 'Inga grupper skapade',
    PRINT_ONE_BY_ONE: 'Printa en artikel per bong',

    //Printers Translation
    PRINTERS: 'Skrivare',
    PRINTER_MANAGEMENT: 'Skrivarhantering',
    UPDATE_PRINTER_LIST: 'Uppdatera skrivarlistan',
    TOTAL_PRINTERS: 'Totalt antal skrivare',
    DEFAULT_PRINTER: 'Standardskrivare',
    NETWORK_STATUS: 'Nätverksstatus',
    CONNECTED: 'Ansluten',
    LOADING_PRINTERS: 'Laddar skrivare...',
    AVAILABLE_PRINTERS: 'Tillgängliga skrivare',
    DEFAULT: 'Standard',
    ONLINE: 'Online',
    SHOW_OPTIONS: 'Visa alternativ',
    NO_PRINTERS_FOUND: 'Inga skrivare hittades',
    ADD_FIRST_PRINTER_MESSAGE:
        'Lägg till din första skrivare för att komma igång.',
    ADD_PRINTER: 'Lägg till skrivare',
    ADD_NEW_PRINTER: 'Lägg till ny skrivare',
    SET_AS_DEFAULT: 'Ange som standard',
    DEACTIVATE: 'Inaktivera',
    PRINTER_ADDED: 'Skrivare tillagd',
    PRINTER_NAME: 'Skrivarnamn',
    ENTER_PRINTER_NAME: 'Ange skrivarnamn',
    MAC_ADDRESS: 'MAC-adress',
    ENTER_MAC_ADDRESS: 'Ange MAC-adress',
    DELETE_PRINTER: 'Radera skrivare',
    DELETE_PRINTER_QUESTION:
        'Är du säker på att du vill ta bort den här skrivaren?',
    PRINTER_TEXT: 'Konfigurera och administrera bongskrivare',
    DISCOUNT_TYPE: 'Rabatt-typ',
    ADD_CRITERIA: 'Lägg till kriterium',
    LAST_EDITED: 'Senast redigerad',
    DISCOUNT_PERCENT_REQUIRED: 'Rabattprocent krävs',
    DISCOUNT_AMOUNT_REQUIRED: 'Rabattbelopp krävs',
    DESCRIPTION_REQUIRED: 'Beskrivning krävs',
    AT_LEAST_ONE_SERVING_METHOD_REQUIRED: 'Minst en serveringsmetod krävs',
    AT_LEAST_ONE_CRITERIA_REQUIRED: 'Minst ett kriterium krävs',
    INVALID_EMAIL: 'Ogiltig e-postadress',
    INVALID_DOMAIN_FORM: 'Ogiltigt domänformat',
    DOMAIN_ALREADY_ADDED: 'Domänen är redan tillagd',
    DO_YOU_REALLY_WANT_TO_DELETE_USER_GROUP:
        'Vill du verkligen ta bort den här användargruppen?',
    USER_ALREADY_INVITED_INVITE_AGAIN:
        'Användaren är redan inbjuden. Vill du bjuda in igen?',
    ALREADY_MEMBER: 'Redan medlem',
    DELETE_ADDON_QUESTION: 'Är du säker på att du vill ta bort tillvalsgruppen',
    ONE_CATEGORY_MINIMUM: 'Du måste ha minst en kategori',
    ALERT: 'Varning',
    CLOSE: 'Stäng',
    CATEGORIES_DESCRIPTION:
        'Skapa produkt- och bongkategorier för dina produkter.',
    CATEGORY: 'Kategori',
    //MFA
    TWO_FACTOR_AUTHENTICATION: 'Tvåfaktorsautentisering',
    TWO_FACTOR_AUTHENTICATION_ACTIVE: '2FA aktiv',
    TWO_FACTOR_AUTHENTICATION_INACTIVE: '2FA inaktiv',
    TWO_FACTOR_AUTHENTICATION_SETUP: 'Ställ in TOTP 2FA',
    TWO_FACTOR_AUTHENTICATION_REMOVE: 'Ta bort 2FA',
    SECURE_YOUR_ACCOUNT: 'Säkra ditt konto',
    ENABLE_TWO_FACTOR_AUTHENTICATION:
        'Aktivera tvåfaktorsautentisering för att lägga till ett extra lager av säkerhet till ditt konto',
    PROTECT_YOUR_ACCOUNT: 'Skydda ditt konto även om ditt lösenord äventyras',
    ENHANCED_SECURITY: 'Förbättrad säkerhet',
    MULTIPLE_OPTIONS: 'Flera alternativ',
    QUICK_SETUP: 'Snabb installation',
    GET_STARTED_IN_JUST_A_FEW_MINUTES_WITH_OUR_GUIDED_SETUP:
        'Kom igång på bara några minuter med vår guidade installation',
    CHOOSE_YOUR_SETUP_METHOD: 'Välj din installationsmetod',
    RECOMMENDED: 'Rekommenderas',
    SMS_AUTHENTICATION: 'SMS-autentisering',
    AUTHENTICATOR_APP: 'Authenticator-app',
    CURRENT_STATUS: 'Aktuell status',
    ACTIVE_METHODS: 'Aktiva metoder',
    PRIMARY_METHOD: 'Primär metod',
    RECEIVE_VERIFICATION_CODES_VIA_TEXT_MESSAGE:
        'Ta emot verifieringskoder via SMS. Snabbt och bekvämt för de flesta användare.',
    USE_APPS_LIKE_GOOGLE_AUTHENTICATOR_OR_AUTHY_FOR_ENHANCED_SECURITY:
        'Använd appar som Google Authenticator eller Authy för ökad säkerhet.',
    WORKS_OFFLINE: 'Fungerar offline',
    INDUSTRY_STANDARD: 'Branschstandard',
    SETUP_SMS_2FA: 'Ställ in SMS 2FA',
    SETUP_TOTP_2FA: 'Ställ in TOTP 2FA',
    SET_AS_PRIMARY: 'Ange som primär',
    NOTICE: 'Meddelande',
    SECURITY_NOTICE_DESCRIPTION:
        'Du måste alltid ha minst en 2FA-metod aktiverad. Om du endast har en metod aktiv kan du inte inaktivera den förrän du lägger till en annan metod.',
    SECURITY_NOTICE_DESCRIPTION2:
        'För att kunna hantera eller inaktivera en alternativ 2FA-metod måste du först återautentisera genom att logga in med den specifika metoden.',
    ADD_CHANGE_PHONE_NUMBER: 'Lägg till/ändra telefonnummer',
    ENTER_PHONE_NUMBER_WITH_COUNTRY_CODE:
        'Ange ditt telefonnummer med landskod (t.ex. +46 för Sverige, +1 för USA/Kanada)',
    SENDING_VERIFICATION_CODE: 'Skickar verifieringskod...',
    SET_UP_AUTHENTICATOR_APP: 'Ställ in Authenticator-app',
    SCAN_QR_CODE_WITH_GOOGLE_AUTHENTICATOR_OR_ANOTHER_TOTP_APP:
        'Skanna denna QR-kod med Google Authenticator eller en annan TOTP-app:',
    MISSING_2FA_TEXT: 'Du saknar en 2FA-kod. Ange en kod för att fortsätta.',
    MANAGE_YOUR_2FA_METHODS: 'Hantera dina 2FA-metoder',
    REMOVE_2FA: 'Ta bort 2FA',
    ENABLED: 'Aktiverad',
    DISABLED: 'Inaktiverad',
    RECEIVE_VERIFICATION_CODES_VIA_TEXT_MESSAGE_FAST_AND_CONVENIENT_FOR_MOST_USERS:
        'Ta emot verifieringskoder via SMS. Snabbt och bekvämt för de flesta användare.',
    CHOOSE_FROM_SMS_AUTHENTICATOR_APPS_OR_EMAIL_VERIFICATION:
        'Välj mellan SMS, Authenticator-app eller e-postverifiering',
    HIGHEST_SECURITY: 'Högsta säkerhet',
    NO_APP_INSTALLATION: 'Ingen appinstallation',
    WORKS_ON_ANY_PHONE: 'Fungerar på alla telefoner',
    AUTHENTICATION: 'Autentisering',
    TABLE: 'Table',
    SERVING_OPTIONS_DESCRIPTION:
        'Välj vilka serveringssätt som ska vara tillgängliga i säljkanalerna',
    ENABLE_SERVING_METHOD: 'Hantera serveringssätt',
    ENABLE_SERVING_METHOD_DESCRIPTION:
        'När ett serveringssätt är aktiverat kan gästerna i dina säljkanaler välja det som alternativ vid beställning.',
    SERVING_OPTIONS: 'Serveringssätt',
    EATIN_DESCRIPTION: 'Erbjud gäster att beställa för att äta på plats',
    TAKEAWAY_DESCRIPTION:
        'Erbjud gäster att beställa för att hämta upp i restaurangen',
    TABLE_SERVING_DESCRIPTION: 'Erbjud gäster att beställa direkt till bordet',
    SEAT_SERVING_DESCRIPTION: 'Erbjud gäster att beställa direkt till platsen',
    WORKPLACE_DELIVERY_DESCRIPTION:
        'Utkörning till fasta platser, t ex. byggnader eller kontorsavdelningar',
    HOME_DELIVERY_DESCRIPTION: 'Utkörning till gästens adress',
    UNABLE_TO_SAVE: 'Kunde inte spara ändringar',
    PRODUCT_DELETED: 'Produkt raderad',
    THIS_MENU_DELETED: 'Den här menyn har blivit raderad',
    COPY_MENU: 'Kopera meny',
    MANAGE_GENERAL_SETTINGS: 'Hantera generella appinställningar',
    APP_SETTINGS: 'Appinställningar',
    MANUALLY_TOGGLE_TEXT:
        'Slå på eller av försäljning manuellt i appen, webborder och expresskassan',
    PUBLISH_BANNER_TEXT:
        'Publicera ett meddelande på enhetens startsida i appen för att nå ut med information till gäster.',
    TYPE_MESSAGE: 'Skriv ett meddelande',
    TEAM_MEMBERS_DESCRIPTION:
        'Hantera teammedlemmars roller och användarbehörigheter',
    RECEIPT: 'Kvitto',
    CONTROL_UNIT: 'Kontrollenhet',
    MARK_AS_WRONG_HIT: 'Vill du markera det här kvittot som felslag?',
    RECEIPT_DOWNLOADED: 'Kvittot laddades ner',
    RECEIPT_DOWNLOAD_FAIL: 'Misslyckades med att ladda ner kvitto',
    EMAIL_ADDRESS_DESCRIPTION:
        'Till vilken e-postadress vill du maila kvittot?',
    EMAIL_ADDRESS: 'E-postadress',
    RECEIPT_UPDATED: 'Kvitto uppdaterat',
    FAILED_TO_EMAIL_RECEIPT: 'Misslyckades med att skicka email till ',
    RECEIPT_EMAILED_TO: 'Kvittot skickades till ',
    PREPARING_EXPORT: 'Förbereder export',
    HOW_MANY: 'Hur många?',
    HOW_MANY_REFUND: 'Hur många vill du göra återköp på?',
    REFUND_IN_PROGRESS: 'Återköp genomförs',
    ENTER_PIN: 'Fyll i pinkod',
    DOWNLOAD_QR: 'Ladda ner QR-kod',
    INVITATION_SENT: 'Inbjudan skickad',
    SENT: 'Skickad',
    SENT_AT: 'Skickad kl',
    TOTAL_SEND: 'Totalt skickade',
    READERS_LIST: 'Läsarlista',
    READ: 'Läsa',
    ANONYMOUS_READERS: 'Anonyma läsare',
    TOTAL_READS: 'Totalt lästa',
    PIN_CODE: 'PIN-kod',
    ADD_PIN_CODE: 'Lägg till PIN-kod',
    ARE_YOU_SURE_DELETE_SELECTED_PRODUCTS:
        'Är du säker att du vill radera markerade produkter?',
    ARE_YOU_SURE_DELETE_OFFER:
        'Är du säker på att du vill ta bort erbjudandet?',
    IMAGE_REQUIRED: 'Bild krävs',
    DELETE_OFFER: 'Ta bort erbjudande',
    PRODUCTS_REMOVED: 'Produkter borttagna',
    INVITE_USER_ERROR: 'Något gick fel när användaren skulle bjudas in.',
    NO_DRINK_CATEGORIES: 'Inga dryckeskategorier har skapats än',
    NO_FOOD_CATEGORIES: 'Inga matkategorier har skapats än',
    DO_YOU_WANT_TO_REMOVE: 'Vill du ta bort',
    PRODUCT_REGISTER: 'Produktregister',
    NO_PRODUCTS_FOUND: 'Inga produkter hittades',
    NAME_AND_TAGS: 'Namn & taggar',
    IMAGE: 'Bild',
    SUBCATEGORIES: 'Underkategorier',
    TIME_SCHEDULED: 'Tidsstyrd',
    EDIT_NAME: 'Ändra namn',
    RENAME: 'Ändra namn',
    DELIVERY_OPTIONS_MENU: 'Serveringssätt',
    DELIVERY_OPTIONS_MENU_EXPLANATION:
        'Ställ in om menyn ska ha specifika serveringssätt påslagna när den är aktiv i appen',
    PRODUCT_ADDED_TITLE: 'Tillagd',
    PRODUCT_REMOVED_TITLE: 'Borttagen',
    HANDLE_MENUS: 'Menyhantering',
    HANDLE_MENUS_TEXT:
        'Hantera dina menyer och underkategorier här - skapa nya eller ändra befintliga',
    MENU_LIST: 'Menylista',
    MENU_LIST_TEXT: 'Skapa och justera dina menyer',
    ADD_TO_MENUS: 'Lägg till i menyer',
    EDIT_PRODUCT: 'Ändra produkter',
    EDIT_SELECTED_PRODUCTS: 'Ändra markerade produkter',
    DELETE_SUBCATEGORY_Q: 'Om du tar bort den globala underkategorin tas den bort från alla menyer den ingår i. Är du säker på att du vill ta bort underkategorin?',
    MANAGE_SUBCATEGORIES: 'Hantera underkategorier',
    CREATE_DRINK_CATEGORY: 'Skapa en underkategori för dryck',
    CREATE_FOOD_CATEGORY: 'Skapa en underkategori för mat',
    ADD_DRINK_CATEGORY: 'Lägg till underkategori till dryck',
    ADD_FOOD_CATEGORY: 'Lägg till underkategori till mat',
    CATEGORY_TYPE: 'Kategori',
    SELECT_SUBCATEGORY: 'Välj underkategori',
    CREATE_NEW: 'Skapa ny',
    ADD_EXISTING: 'Lägg till befintlig',
    EDIT_SUBCATEGORY: 'Ändra underkategori',
    VISIBLE_IN_KIOSK: '(synlig i kiosk)',
    WRONG_PIN: 'Fel pin, försök igen',
    USERS_NOT_ALLOWED_TO_REPURCHASE:
        'Användare har ej tillåtelse att göra återköp',
    CONTACT_SUPPORT: 'Kontakta supporten med detta kvittonummer',
    USERS_NOT_ALLOWED_TO_MARK_AS_CORRECTION: 'Användare har ej tillåtelse att markera felslag',
    REPURCHASE: 'Återköp gjort på kvitto ',
    RECEIPT_NOT_FOUND: 'Kunde inte hitta kvitto med nummer',
    REFUNDS: 'Återköp',
    REFUNDED: 'Återköpt',
    REFUNDED_RECEIPT: 'Återköpskvitto',
    COLLECTIVE_DISCOUNT: 'Samlad rabatt',
    SMOOTHING: 'Öresutjämning',
    REFUNDED_BY: 'Återköpt av',
    ERROR_RECEIPT:
        'Något gick fel när dina kvitton hämtades. Försök igen senare.',
    INVALID_EAN:
        'EAN-koden får bara innehålla siffror och måste vara mellan 8-14 tecken lång',
    NO_PRODUCT_EXTERNAL_ID:
        'Du måste lägga till ett externt ID till den här produkten innan du kan lägga till den i en meny. Gå till produktlistan och uppdatera din produkt.',
    NO_EXTERNAL_ID_HEADER: 'Externt ID saknas',
    LIST_VIEW_TEXT:
        'Listvy är standardläget och visar tillvalen i en organiserad lista på produktsidan.',
    STEP_BY_STEP_VIEW_TEXT:
        'Steg-för-steg-läge visar tillvalen på produktsidan i flera steg.',
    DISABLE_NAME_PRODUCT: 'Inaktivera "Namnge din produkt"-steget',
    DISABLE_NAME_PRODUCT_TEXT: 'Det sista namngivningssteget hoppas över för den här produkten i alla kanaler.',
    ADD_TITLE: 'Lägg till titel',
    SERVING_METHODS: 'Serveringssätt',
    SERVING_METHOD_EAT_IN: 'Äta här',
    SERVING_METHOD_TAKEAWAY: 'Takeaway',
    SERVING_METHOD_TABLE: 'Bordsservering',
    SERVING_METHOD_HOME_DELIVERY: 'Hemkörning',
    SERVING_METHOD_FIXED_LOCATION: 'Fast leveransplats',
    ADD_DESCRIPTION: 'Lägg till beskrivning',
    NO_ADDONS_IN_STEP: 'Det här steget har inga tillval.',
    DELETE_STEP: 'Ta bort steg',
    ASSIGN_TO_STEP: 'Assign to step',
    ENABLE_STEP_BY_STEP_FLOW: "Tillagda tillval kommer att tas bort. Vill du ändå aktivera steg-för-steg-flödet?",
    DISABLE_STEP_BY_STEP_FLOW: "Tillagda tillval kommer att tas bort. Vill du ändå avaktivera steg-för-steg-flödet?",
    STEP_HEADER: 'Titel',
    STEP_SUB_HEADER: 'Beskrivning',
    ADD_STEP: 'Lägg till steg',
    NO_ADDONS: 'Inga tillval tillagda.',
    UNASSIGN: 'Ta bort',
    NO_REFUND_RECEIPT_FOUND: 'Inga Återköp kvitton hittade',
    NO_RECEIPT_FOUND: 'Inga kvitton hittade',
    REASON_FOR_REFUND: 'Anledning till återköp',
    REFUND_REASON_LABEL: 'Skriv anledningen till återköpet, max 200 tecken',
    RECEIPT_ALREADY_REFUNDED: 'Köpet är återbetalt',
    RECEIPT_ALREADY_PARTIALLY_REFUNDED: 'Köpet är delvis återbetalt',
    CATERING: 'Catering',
    CATERING_PRODUCT_LIST: 'Cateringproduktlista',
    CATERING_PRODUCT_LIST_DESCRIPTION: "Hantera, uppdatera och organisera dina cateringprodukter.",
    CATERING_SETTINGS_TITLE: 'Cateringinställningar',
    CATERING_SETTINGS_SUBTITLE: 'Hantera enhetens cateringinställningar',
    CATERING_PICKUP_TAB: 'Pickup',
    CATERING_DELIVERY_TAB: 'Leverans',
    CATERING_ADDITIONAL_SETTINGS_TAB: 'Ytterligare inställningar',
    CATERING_PICKUP_INSTRUCTIONS_TITLE: 'Avhämtningsinstruktioner',
    CATERING_PICKUP_INSTRUCTIONS_DESCRIPTION:
        'Detta är instruktionerna som kunderna ska följa när de hämtar sin cateringbeställning. De visas både på cateringsidan och i bekräftelsemejlet.',
    CATERING_PICKUP_INSTRUCTIONS_PLACEHOLDER: 'Hämta vid huvudentrén',
    CATERING_PICKUP_INSTRUCTIONS_MAX_LENGTH: 'Avhämtningsinstruktionerna får vara högst 100 tecken.',
    CATERING_PICKUP_INSTRUCTIONS_SAVED: 'Avhämtningsdata har sparats.',
    CATERING_PICKUP_INSTRUCTIONS_SAVE_ERROR: 'Misslyckades med att spara avhämtningsdata.',
    CATERING_PICKUP_INSTRUCTIONS_LOAD_ERROR: 'Misslyckades med att läsa in avhämtningsinstruktionerna.',
    CATERING_SETTINGS_TAB_PLACEHOLDER: 'Ytterligare cateringinställningar visas här inom kort.',
    PRODUCT_CREATED: "Produkt skapad.",
    // Catering Orders
    CATERING_ORDERS_DESCRIPTION: "Hantera och spåra alla cateringbeställningar från cateringwebbappen",
    PRINT_EXPORT: "Skriv ut/Exportera",
    DELIVERY_METHOD: "Leveransmetod",
    SELECT_DATE_RANGE: "Välj datumintervall",
    SELECT_DATE_TIME: "Välj datum och tid",
    SEARCH_ORDERS: "Sök beställningar...",
    CATERING_CUSTOMER_NAME: "Kundnamn",
    COMPLETION_DATE: "Slutdatum",
    PICKUP: "Hämtning",
    COMMENT: "Kommentar",
    CREATION_DATE: "Skapelsedatum",
    VIEW_DETAILS: "Visa detaljer",
    CHOOSE_COLUMNS: "Välj kolumner",
    // COLUMNS_SELECTED: "{0} kolumner valda",
    ORDER_INFORMATION: "Orderinformation",
    ORDER_DATE: "Orderdatum",
    METHOD: "Metod",
    DELIVERY_TIME: "Leveranstid",
    PICKUP_TIME: "Hämttid",
    FULL_NAME: "Fullständigt namn",
    PAYMENT_STATUS: "Betalningsstatus",
    DELIVERY_STATUS: "Leveransstatus",
    CATERING_UNPAID: "Obetald",
    CATERING_PENDING: "Väntande",
    CATERING_DELIVERED: "Levererad",
    APPROVE_ORDER: "Godkänn order",
    DECLINE_ORDER: "Avvisa order",
    MARK_AS_DONE: "Markera som klar",
    MARK_AS_PENDING: "Markera som väntande",
    PRINT_EXPORT_ORDERS: "Skriv ut/Exportera beställningar",
    DATE_RANGE_ORDER_CREATION: "Datumintervall (baserat på orderskapelsedatum)",
    DATE_RANGE_COMPLETION: "Datumintervall (baserat på slutförandedatum)",
    SELECT_DELIVERY_METHOD: "Välj leveransmetod",
    ONLY_APPROVED_ORDERS: "Endast godkända beställningar kommer att inkluderas i utskrift/export.",
    PRINT: "Skriv ut",
    EXPORT_PDF: "Exportera pdf",
    EXPORT_PRODUCTION_TASKS: "Exportera produktionsuppgifter",
    PRODUCTION_TASKS_INFO: "Denna rapport kommer att inkludera alla godkända beställningar schemalagda för slutförande i det valda datumintervallet. Produkter kommer att grupperas per dag med summerade kvantiteter.",
    DATE_RANGE: "Datumintervall",
    CONTACT_CUSTOMER: "Kontakta kund",
    DOWNLOAD_PDF: "Ladda ner PDF",
    APPROVED: "Godkänd",
    DONE: "Klar",
    DECLINED: "Avvisad",
    QUANTITY: "Kvantitet",
    EACH: "styck",
    MOBILE_PAY: "Mobile Pay",
    REGISTERED: "Registrerad",
    // Catering Main Component
    TAGS_CATEGORIES: 'Taggar & Kategorier',
    // Catering Menu Component
    CATERING_MENUS: "Cateringmenyer",
    MANAGE_PRIORITIZE_MENUS: "Hantera och prioritera dina cateringmenyer",
    CREATE_MENU: "Skapa meny",
    TOTAL_MENUS: "Totalt antal menyer",
    MENU_STATUS: "Menystatus",
    NO_ACTIVE_MENU: "Ingen aktiv meny",
    INACTIVE_MENUS: "Inaktiva menyer",
    VIEW_MANAGE_MENUS: "Visa och hantera alla dina cateringmenyer",
    DEACTIVATE_MENU: "Inaktivera meny",
    EDIT_MENU: "Redigera meny",
    NO_MENUS_FOUND: "Inga menyer hittades",
    CREATE_FIRST_MENU_DESC: "Skapa din första cateringmeny för att komma igång. Organisera dina erbjudanden och gör dem tillgängliga för kunder.",
    CREATE_FIRST_MENU: "Skapa första meny",
    EDIT_MENU_DIALOG: "Redigera meny",
    MENU_NAME: "Menyens namn",
    MENU_NAME_PLACEHOLDER: "t.ex., Bröllopsmeny, Företagslunch",
    CREATE_CAMPAIGN_MENU: "Skapa kampanjmeny?",
    USE_FIXED_DATES: "Använd fasta leverans/hämtningsdatum",
    CAMPAIGN_TYPE: "Kampanjtyp",
    SELECTED_TYPE: "Vald typ",
    ADD_PICKUP_DATE: "Lägg till hämtningsdatum",
    ADD_DELIVERY_DATE: "Lägg till leveransdatum",
    PICKUP_DATES: "Hämtningsdatum",
    DELIVERY_DATES: "Leveransdatum",
    PICKUP_TIME_SLOTS: "Hämtningstidsluckor",
    DELIVERY_TIME_SLOTS: "Leveranstidsluckor",
    ADD_TIME_SLOT: "Lägg till tidslucka",
    START_TIME_MUST_BE_LESS_THAN_END_TIME: "Starttid måste vara mindre än sluttid",
    START_AND_END_TIME_CANNOT_BE_SAME: "Starttid och sluttid kan inte vara samma",
    TIME_SLOT_OVERLAPS_WITH_ANOTHER: "Denna tidslucka överlappar med en annan tidslucka",
    ACTIVE_MENUS_VISIBLE: "Aktiva menyer är synliga för kunder",
    UPDATE_MENU: "Uppdatera meny",
    NO_ACTIVE_MENU_WARNING: "Ingen aktiv meny: Kunder kan inte lägga beställningar förrän en meny aktiveras.",
    // Catering Products Component
    LONG_DESCRIPTION: 'Lång beskrivning',
    SERVINGS_PER_PRODUCT: 'Portioner per produkt',
    MINIMUM_ORDER_QUANTITY: 'Minsta beställningskvantitet',
    CATERING_DIETARY_TAGS: 'Diettaggar',
    CATERING_ECO_TAGS: 'Ekotaggar',
    FULFILLMENT_OPTIONS: 'Uppfyllnadsalternativ',
    PICK_UP: 'Hämtning',
    DELIVERY_OPTION: 'Leverans',
    BOTH: 'Båda',
    SERVING: 'Servering',
    ECONOMICS: 'Ekonomi',
    MINIMUM_ORDER_LEAD_DAYS: 'Minsta beställningsledtid',
    MAXIMUM_ORDER_QUANTITY: 'Maximal beställningskvantitet',
    SELECT_UP_TO_4: 'Välj upp till 4',
    DETAILS: 'Detaljer',
    // Catering Menu Details
    BACK_TO_MENUS: "Tillbaka till menyer",
    ADD_CATEGORY: "Lägg till kategori",
    TOTAL_CATEGORIES: "Totalt antal kategorier",
    TOTAL_PRODUCTS: "Totalt antal produkter",
    WITH_PRODUCTS: "Med produkter",
    NO_CATEGORIES_FOUND: "Inga kategorier hittades",
    CREATE_FIRST_CATEGORY_DESC: "Skapa din första kategori för att organisera produkter i denna meny.",
    CREATE_FIRST_CATEGORY: "Skapa första kategori",
    HERO_IMAGE_TEXT_COLOR_CAMPAIGN: "Textfärg för hero-bild",
    HERO_IMAGE_TEXT_COLOR_CAMPAIGN_PLACEHOLDER: "e.g., #000000 or #FFFFFF",
    HERO_IMAGE_TEXT_COLOR_REGULAR: "Textfärg",
    HERO_IMAGE_TEXT_COLOR_REGULAR_PLACEHOLDER: "e.g., #000000 or #FFFFFF",
    // Tags & Categories
    CATEGORIES_MANAGEMENT: 'Kategorihantering',
    ORGANIZE_PRODUCTS_CATEGORIES:
        'Organisera dina produkter med anpassade kategorier',
    CATEGORIES_WITH_PRODUCTS: 'Kategorier med produkter',
    DIETARY_TAGS_MANAGEMENT: 'Diettaggarhantering',
    ORGANIZE_DIETARY_TAGS: 'Hantera diettaggar för dina produkter',
    ECO_TAGS_MANAGEMENT: 'Ekotaggarhantering',
    ORGANIZE_ECO_TAGS: 'Hantera miljövänliga taggar för dina produkter',
    ADD_DIETARY_TAG: 'Lägg till diettagg',
    ADD_ECO_TAG: 'Lägg till ekotagg',
    TOTAL_DIETARY_TAGS: 'Totalt antal diettaggar',
    TOTAL_ECO_TAGS: 'Totalt antal ekotaggar',
    DIETARY_TAGS_WITH_PRODUCTS: 'Diettaggar med produkter',
    ECO_TAGS_WITH_PRODUCTS: 'Ekotaggar med produkter',
    // Menu Category Product
    LINKED_PRODUCTS: 'Länkade produkter',
    AVAILABLE_PRODUCTS: 'Tillgängliga produkter',
    PRODUCTS_LINKED: 'produkter länkade',
    PRODUCT_LINKED: 'produkt länkad',
    SEARCH_LINKED_PRODUCTS: 'Sök länkade produkter...',
    NO_PRODUCTS_LINKED: 'Inga produkter länkade',
    TRY_DIFFERENT_SEARCH: 'Prova en annan sökterm',
    ADD_PRODUCTS_FROM_AVAILABLE:
        'Lägg till produkter från fliken "Tillgängliga produkter"',
    NO_DESCRIPTION: 'Ingen beskrivning',
    SEARCH_AVAILABLE_PRODUCTS: 'Sök tillgängliga produkter...',
    NO_AVAILABLE_PRODUCTS: 'Inga tillgängliga produkter',
    ALL_PRODUCTS_ADDED: 'Alla produkter har lagts till i denna kategori',
    ADD_TO_CATEGORY: 'Lägg till i kategori',
    ENABLE_STOCK_BALANCE_TRACKING: 'Aktivera lagersaldospårning',
    STOCK_BALANCE_DISABLED: '(Inaktiverad)',
    SERVINGS: 'Portioner',
    MIN_ORDER: 'Min beställning',
    ON: 'den',
    ORGANIZE_MENU_CATEGORIES: 'Organisera dina menyalternativ i kategorier',
    NO_DESCRIPTION_PROVIDED: 'Ingen beskrivning angiven',
    LAST_MODIFIED_DATE: 'Senast ändrad',
    MANAGE_PRODUCTS: 'Hantera produkter',
    NO_CATEGORIES_YET: 'Inga kategorier ännu',
    CREATE_FIRST_CATEGORY_TEXT:
        'Skapa din första kategori för att börja organisera menyalternativ. Kategorier hjälper till att strukturera din meny och gör det enklare för kunder att bläddra.',
    CATEGORY_NAME: 'Kategorinamn',
    CATEGORY_DESCRIPTION: 'Kategoribeskrivning',
    CATEGORY_NAME_PLACEHOLDER: 't.ex., Förrätter, Huvudrätt, Efterrätter',
    CATEGORY_DESCRIPTION_PLACEHOLDER:
        'Ange en kort beskrivning av denna kategori...',
    OPTIONAL_CATEGORY_DETAILS:
        'Valfritt: Lägg till detaljer för att hjälpa kunder att förstå denna kategori',
    UPDATE_CATEGORY: 'Uppdatera kategori',
    DELETE_CATEGORY: 'Ta bort kategori',
    CREATE_NEW_CATEGORY: 'Skapa ny kategori',
    SEARCH_CATEGORIES: 'Sök kategorier...',
    SEARCH_DIETARY_TAGS: 'Sök diettaggar...',
    SEARCH_ECO_TAGS: 'Sök ekotaggar...',
    SORT_BY: 'Sortera efter',
    TAGS_WITH_PRODUCTS: 'Taggar med produkter',
    TRY_ADJUSTING_SEARCH:
        'Försök justera dina sökkriterier eller skapa en ny kategori.',
    NO_DIETARY_TAGS_FOUND: 'Inga diettaggar hittades',
    NO_ECO_TAGS_FOUND: 'Inga ekotaggar hittades',
    ORGANIZE_DIETARY_INFO: 'Organisera dina produkter med diettagginformation',
    ORGANIZE_ECO_INFO:
        'Organisera dina produkter med miljövänlig tagginformation',
    CREATE_FIRST_DIETARY_TAG: 'Skapa första diettagg',
    CREATE_FIRST_ECO_TAG: 'Skapa första ekotagg',
    ADD_NEW_CATEGORY: 'Lägg till ny kategori',
    ENTER_CATEGORY_NAME: 'Ange kategorinamn',
    DESCRIPTION_OPTIONAL: 'Beskrivning (Valfritt)',
    ENTER_CATEGORY_DESCRIPTION: 'Ange kategoribeskrivning',
    ENTER_DIETARY_TAG_NAME: 'Ange diettaggnamn',
    ENTER_DIETARY_TAG_DESCRIPTION: 'Ange diettaggbeskrivning',
    DIETARY_TAG_NAME: 'Diettaggnamn',
    ECO_TAG_NAME: 'Ekotaggnamn',
    ENTER_ECO_TAG_NAME: 'Ange ekotaggnamn',
    ENTER_ECO_TAG_DESCRIPTION: 'Ange ekotaggbeskrivning',
    ADD_NEW_DIETARY_TAG: 'Lägg till ny diettagg',
    ADD_NEW_ECO_TAG: 'Lägg till ny ekotagg',
    EDIT_DIETARY_TAG: 'Redigera diettagg',
    EDIT_ECO_TAG: 'Redigera ekotagg',
    CREATE_DIETARY_TAG: 'Skapa diettagg',
    UPDATE_DIETARY_TAG: 'Uppdatera diettagg',
    CREATE_ECO_TAG: 'Skapa ekotagg',
    UPDATE_ECO_TAG: 'Uppdatera ekotagg',
    LINKED: 'länkade',
    SELECT_CATEGORY: 'Välj kategori',
    ALL_NEWS: 'Alla nyheter',
    SEARCH_TITLE_OR_TEXT: 'Sök...',
    DATE_CREATED: 'Skapad',
    PUSH_NOTIFICATIONS_INTRO:
        'Du kan skapa och skicka en ny notifiering, eller skicka om en tidigare från din historik',
    PUSH_NOTIFICATION: 'Pushnotiser',
    CREATE_NEW_NOTIFICATION: 'Skapa notis',
    NO_PUSH_NOTIFICATIONS_FOUND: 'Inga pushnotiser hittades',
    NO_NEWS_FOUND: 'Inga nyhetskaruseller hittades',
    RECIPIENT: "Mottagare",
    SEND_TO_ALL: "Skicka till alla",
    SEND_TO_GROUP: "Skicka till användargrupp",
    SELECT_GROUP: "Denna anmälan kommer att skickas till",
    USER: "användare",
    REACH_STATMENT: "Notifikationen kommer nå:",
    GROUPS: "Grupp(er)",
    NO_GROUPS: "Inga grupper",
    ALL_USERS: "Alla användare",
    SELECT_USER_GROUPS: 'Välj användargrupper',
    PRODUCT_NOT_FOUND: 'Produkt hittades inte',
    NOT_FOUND: 'Hittades inte',
    FAILED_TO_DELETE_PRODUCT: 'Misslyckades med att ta bort produkt',
    FAILED_TO_BULK_UPDATE_PRODUCTS: 'Misslyckades med att uppdatera produkter',
    SHARED: 'Delad',
    PRODUCTS_BULK_UPDATED: 'Produkter bulk uppdaterad',
    UPDATED: 'Uppdaterad',
    DISCARDED: 'Avbruten',
    CHANGES_DISCARDED: 'Ändringar avbrutna',
    PRODUCT_UPDATED: 'Produkt uppdaterad',
    FAILED_TO_SAVE_PRODUCT: 'Misslyckades med att spara produkt',
    // ORDER_STATUS_UPDATED: 'Orderstatus uppdaterad till {0}',
    PRODUCTION_TASKS_REPORT_GENERATED_SUCCESSFULLY:
        'Produktionsuppgifter rapporter genererad',
    FAILED_TO_LOAD_ORDERS: 'Misslyckades med att ladda beställningar',
    FAILED_TO_UPDATE_ORDER_STATUS:
        'Misslyckades med att uppdatera beställningsstatus',
    INVALID_MENU_IDENTIFIER: 'Ogiltlig menyidentifierare',
    MENU_NOT_FOUND: 'Meny hittades inte',
    FAILED_TO_LOAD_MENU_DETAILS: 'Misslyckades med att ladda menydetaljer',
    FAILED_TO_LOAD_CATEGORIES: 'Misslyckades med att ladda kategorier',
    CATEGORY_NAME_REQUIRED: 'Kategorinamn krävs',
    CATEGORY_CREATED_SUCCESSFULLY: 'Kategori skapad',
    FAILED_TO_CREATE_CATEGORY: 'Misslyckades med att skapa kategori',
    CATEGORY_UPDATED_SUCCESSFULLY: 'Kategori uppdaterad',
    FAILED_TO_UPDATE_CATEGORY: 'Misslyckades med att uppdatera kategori',
    CATEGORY_DELETED_SUCCESSFULLY: 'Kategori borttagen',
    FAILED_TO_DELETE_CATEGORY: 'Misslyckades med att ta bort kategori',
    FAILED_TO_UPDATE_PRODUCT_ORDER:
        'Misslyckades med att uppdatera produktordning',
    FAILED_TO_LOAD_PRODUCTS: 'Misslyckades med att ladda produkter',
    // PRODUCT_ADDED_TO_CATEGORY: 'Produkt {0} läggs till i kategori {1}',
    FAILED_TO_ADD_PRODUCT_TO_CATEGORY:
        'Misslyckades med att lägga till produkt i kategori',
    // PRODUCT_REMOVED_FROM_CATEGORY: 'Produkt {0} borttagen från kategori {1}',
    FAILED_TO_REMOVE_PRODUCT_FROM_CATEGORY:
        'Misslyckades med att ta bort produkt från kategori',
    PRODUCT_ORDER_UPDATED: 'Produktordning uppdaterad',
    FAILED_TO_LOAD_CATERING_MENUS: 'Misslyckades med att ladda cateringmenyer',
    MENU_CREATED_SUCCESSFULLY: 'Meny skapad',
    FAILED_TO_CREATE_MENU: 'Misslyckades med att skapa meny',
    MENU_UPDATED_SUCCESSFULLY: 'Meny uppdaterad',
    FAILED_TO_UPDATE_MENU: 'Misslyckades med att uppdatera meny',
    MENU_DELETED_SUCCESSFULLY: 'Meny borttagen',
    FAILED_TO_DELETE_MENU: 'Misslyckades med att ta bort meny',
    // MENU_ACTIVATED_DETAIL: 'Meny {0} är nu aktiv. Alla andra menyer har blivit avaktiverade.',
    MENU_DEACTIVATED: 'Meny avaktiverad',
    // MENU_DEACTIVATED_DETAIL: 'Meny {0} har blivit avaktiverad.',
    FAILED_TO_UPDATE_MENU_STATUS: 'Misslyckades med att uppdatera menystatus',
    NAME_ASC: 'Namn (A-Z)',
    NAME_DESC: 'Namn (Z-A)',
    DATE_CREATED_NEWEST: 'Skapad (nyaste)',
    DATE_CREATED_OLDEST: 'Skapad (äldaste)',
    // ARE_YOU_SURE_YOU_WANT_TO_DELETE: 'Är du säker på att du vill ta bort "{0}"? Denna åtgärd kan inte ångras.',
    DELETE_ECO_TAG: 'Ta bort ekotagg',
    DELETE_DIETARY_TAG: 'Ta bort diettagg',
    // ARE_YOU_SURE_YOU_WANT_TO_MARK_THIS_ORDER_AS: 'Är du säker på att du vill markera den här beställningen som {0}?',
    CONFIRM_STATUS_UPDATE: 'Bekräfta statusuppdatering',
    REMOVE_PRODUCT: 'Ta bort produkt',
    // ARE_YOU_SURE_YOU_WANT_TO_REMOVE: 'Är du säker på att du vill ta bort "{0}" från "{1}"?',
    COMPLETED: 'Klar',
    BASIC_INFORMATION: 'Grundläggande information',
    CAMPAIGN_SETTINGS: 'Kampanjinställningar',
    ENABLE_PICKUP_DELIVERY_DATES: 'Aktivera för att ställa in specifika upphämtnings-/leveransdatum och tider',
    REMOVE_DATE: 'Ta bort datum',
    START_DATE_REQUIRED_FOR_CAMPAIGN_MENU: "Startdatum krävs för kampanjmeny",
    START_DATE_REQUIRED: "Startdatum krävs för att lägga till upphämtnings-/leveransdatum",
    DATE_ALREADY_EXISTS: "Detta datum är redan tillagt. Välj ett annat datum.",
    END_DATE_AFTER_START_DATE: "Slutdatum måste vara efter startdatum",
    BOTH_DATES_PASSED_WARNING: "Både start- och slutdatum har passerat. Uppdatera datumen innan du aktiverar menyn.",
    PAST_DATE_RANGE_EDIT_WARNING: "Både start- och slutdatum ligger i det förflutna. Uppdatera slutdatum till idag eller senare för att kunna redigera startdatum.",
    PAST_SCHEDULE_DATES_WARNING: "Ett eller flera upphämtnings-/leveransdatum ligger i det förflutna. Uppdatera eller ta bort gamla datum för att spara ändringar.",
    AT_LEAST_ONE_PICKUP_SCHEDULE_REQUIRED: "Minst ett upphämtningsschema krävs",
    AT_LEAST_ONE_DELIVERY_SCHEDULE_REQUIRED: "Minst ett leveransschema krävs",
    AT_LEAST_ONE_PICKUP_OR_DELIVERY_SCHEDULE_REQUIRED: "Minst ett upphämtnings- eller leveransschema krävs",
    MENU_NAME_REQUIRED: "Meny namn krävs",
    ALLERGEN_CATEGORIES: 'Allergener',
    MILK: '🥛 Mjölk',
    MILK_PROTEIN: '🥛 Mjölkprotein',
    GLUTEN: '🌾 Gluten',
    NUTS: '🥜 Nötter',
    CRUSTACEANS: '🦞 Kräftdjur',
    EGG: '🥚 Ägg',
    MOLLUSCS: '🦪 Blötdjur',
    FISH: '🐟 Fisk',
    PORK: '🥓 Fläskkött',
    PEANUTS: '🥜 Jordnötter',
    SESAME_SEEDS: 'Sesamfrön',
    SULPHUR: 'Svaveldioxid och sulfiter',
    SOYBEANS: '🫘 Sojabönor',
    CELERY: '🥬 Selleri',
    MUSTARD: 'Senap',
    LUPIN: 'Lupin',
    GARLIC: '🧄 Vitlök',
    MUSHROOM: '🍄‍🟫 Svamp',
    ALMOND: '🥜 Mandel',
    HAZELNUT: '🥜 Hasselnötter',
    WALNUT: '🥜 Valnötter',
    CASHEW: '🥜 Cashewnötter',
    PECAN: '🥜 Pecannötter',
    BRAZIL_NUT: '🥜 Paranötter',
    PISTACHIO: '🥜 Pistaschnötter',
    MACADAMIA: '🥜 Macadamianötter',
    CATERING_DELIVERY_AVAILABILITY_DESC: 'Konfigurera vilka dagar och tidsluckor kunder kan välja för utkörning. Aktivera/inaktivera varje dag och lägg till specifika tidsintervall.',
    CATERING_DELIVERY_AVAILABILITY: 'Tillgänglighet för utkörning',
    //Signage
    MENUDISPLAY_SETTINGS_TITLE: 'Inställningar för menydisplay',
    MENUDISPLAY_SETTINGS_SUBTITLE: 'Konfigurera din menydisplay',
    MENUDISPLAY_GENERAL_SETTINGS_TAB: 'Allmänna inställningar',
    MENUDISPLAY_GENERAL_SETTINGS_SUBTITLE: 'Enhetsövergripande menydisplayinställningar som gäller för alla skärmar och bilder.',
    MENUDISPLAY_DEFAULT_LANGUAGE_SUBTITLE: 'Standardspråk som visas på menydisplayer för den här enheten.',
    MENUDISPLAY_MENU_DISPLAY_CONFIG_SUBTITLE: 'Konfigurera logotyp, bakgrund, textfärg och synlighet för produktbild.',
    MENUDISPLAY_PRODUCT_IMAGE: 'Produktbild',
    MENUDISPLAY_PRODUCT_IMAGE_SUBTITLE: 'Visa miniatyrbild av produkt',
    MENUDISPLAY_TOGGLE_ON: 'På',
    MENUDISPLAY_TOGGLE_OFF: 'Av',
    MENUDISPLAY_FONT_COLOR: 'Textfärg',
    MENUDISPLAY_FONT_FAMILY_TITLE: 'Typsnitt',
    MENUDISPLAY_FONT_FAMILY_SUBTITLE: 'Välj ett Google Font för menytexter på skylten.',
    MENUDISPLAY_FONT_PREVIEW_SAMPLE: 'Exempel: Aa Bb Cc 0123456789',
    MENUDISPLAY_FONT_COLOR_SUBTITLE: 'Välj textfärg',
    MENUDISPLAY_FONT_COLOR_HEX_PLACEHOLDER: '#000000',
    MENUDISPLAY_LOGO_SUBTITLE: 'Logotypen måste vara xxx px',
    MENUDISPLAY_LOGO_TITLE: 'Logo',
    CHANGE_LOGO: 'Byt logotyp',
    MENUDISPLAY_UPLOADED: 'Uppladdad',
    MENUDISPLAY_NOT_SET: 'Inte inställd',
    MENUDISPLAY_LOGO_PREVIEW_ALT: 'Logo-förhandsvisning',
    MENUDISPLAY_REPLACE_IMAGE: 'Ersätt bild',
    MENUDISPLAY_CLICK_TO_UPLOAD_LOGO: 'Klicka för att ladda upp',
    MENUDISPLAY_LOGO_UPLOAD_HINT: 'PNG, JPG, SVG · Rekommenderas 400×400px',
    MENUDISPLAY_CUSTOM_MENU_DISPLAY_TITLE: 'Anpassad menydisplay',
    MENUDISPLAY_CUSTOM_MENU_DISPLAY_SUBTITLE: 'Skapa och hantera återanvändbara produktgrupper för skyltbilder.',
    MENUDISPLAY_BACKGROUND_TITLE: 'Bakgrund',
    MENUDISPLAY_BACKGROUND_SUBTITLE: 'Bakgrunden måste ha upplösningen 1080x1920',
    MENUDISPLAY_BACKGROUND_PREVIEW_ALT: 'Bakgrundsförhandsvisning',
    MENUDISPLAY_CLICK_TO_UPLOAD_BACKGROUND: 'Klicka för att ladda upp bakgrund',
    MENUDISPLAY_BACKGROUND_UPLOAD_HINT: 'PNG, JPG · Rekommenderas 1920×1080px',
    MENUDISPLAY_CHANGE_IMAGE: 'Byt bild',
    MENUDISPLAY_REMOVE_LOGO_WARN: 'Att ta bort logotypen påverkar layouten för menydisplayen',
    MENUDISPLAY_DELETE: 'Ta bort',
    MENUDISPLAY_ABORT: 'Avbryt',
    MENUDISPLAY_FAILED_UPDATE: 'Misslyckades att uppdatera',
    MENUDISPLAY_THEME_SAVED: 'Tema sparat',
    MENUDISPLAY_NO_LOGO: 'Ingen logotyp att ta bort',
    MENUDISPLAY_SELECT_FILE: 'Välj en fil',
    MENUDISPLAY_REMOVE_LOGO_HEADER: 'Ta bort logotypen?',
    MENUDISPLAY_UNSAVED_CHANGES_HINT: 'Du har osparade ändringar',
    MENUDISPLAY_LOADING_ARIA_LABEL: 'laddar',
    MENUDISPLAY_LOADING_THEME_SETTINGS_TEXT: 'Laddar temainställningar…',
    SCREEN_SETTINGS_TITLE: 'Inställningar för signage skärm',
    SCREEN_SETTINGS_SUBTITLE: 'Konfigurera signage skärm',
    SCREEN_ADD_SCREEN: 'Skapa en skärm',
    SCREEN_ADD_FIRST_SCREEN: 'Skapa din första skärm',
    SCREEN_SCREEN_STATUS: 'Skärmstatus',
    SCREEN_EDIT_SCREEN: 'Editera skärm',
    SCREEN_SCREEN_NAME: 'Skärmnamn',
    SCREEN_SELECT_COLLECTION: 'Välj slidekolletion',
    SCREEN_REMOVE_SCREEN: 'Radera skärm',
    SCREEN_REMOVE_SCREEN_HEADER: 'Radera skärm',
    SCREEN_REMOVE_SCREEN_WARN: 'Är du säker på att du vill ta bort skärmen',
    SCREEN_SCREENS: 'Skärmar',
    SCREEN_PUBLISH_ACTIVATED: 'Skärmen "{name}" är aktiverad.',
    SCREEN_PUBLISH_DEACTIVATED: 'Skärmen "{name}" är inaktiverad.',
    SCREEN_STATUS_UPDATE_ERROR: 'Det gick inte att spara skärmstatus. Försök igen.',
    SCREEN_SCHEDULES: 'Schema',
    SCREEN_SCHEDULE: 'Schema',
    SCREEN_ADD_SCHEDULE: 'Lägg till schema',
    SCREEN_SCHEDULES_HINT: 'Koppla slidekollektioner till dagar och tidsintervall. Skärmen visar kollektionen som matchar aktuell tid.',
    SCREEN_SCHEDULE_DAYS: 'Dagar',
    SCREEN_SCHEDULE_DAYS_PLACEHOLDER: 'Välj dagar',
    SCREEN_SCHEDULE_START: 'Starttid',
    SCREEN_SCHEDULE_END: 'Sluttid',
    SCREEN_SCHEDULE_COUNT: '{count} scheman',
    SCREEN_SCHEDULE_REQUIRED: 'Lägg till minst ett schema.',
    SCREEN_SCHEDULE_COLLECTION_REQUIRED: 'Välj en slidekollektion för varje schema.',
    SCREEN_SCHEDULE_DAYS_REQUIRED: 'Välj minst en dag för varje schema.',
    SCREEN_SCHEDULE_INVALID_TIME: 'Sluttid måste vara efter starttid för varje schema.',
    COLLECTION_SETTINGS_TITLE: 'Slidekollektioner',
    COLLECTION_SETTINGS_SUBTITLE: 'Konfigurera dina slidekollektioner',
    COLLECTION_COLLECTIONS: 'Kollektioner',
    COLLECTION_ADD_FIRST_COLLECTION: 'Lägg till din första kollektion',
    COLLECTION_CREATED: 'Kollektion skapad:',
    COLLECTION_CREATE_COLLECTION: 'Skapa kollektion',
    COLLECTION_EDIT_COLLECTION: 'Redigera kollektion',
    COLLECTION_NAME: 'Kollektionens namn',
    SLIDE_COLLECTION: 'Slidekollektion',
    SLIDE_CREATE_FIRST: 'Skapa din första slide för att komma igång',
    SLIDE_CREATE_SLIDE: 'Skapa slide',
    SLIDE_CREATE_SUBTITLE: 'Lägg till en ny slide i din skyltning',
    SLIDE_DELETE_SLIDE: 'Radera slide',
    SLIDE_DELETE_COLLECTION: 'Radera kollektion',
    SLIDE_DELAY_SECONDS: 'Fördröjning i sekunder',
    SLIDE_DELAY_HINT: 'Hur länge denna slide ska visas',
    SLIDE_DELAY_WARNING: 'Fördröjningen måste vara minst 5 sekunder',
    SLIDE_NAME: 'Slidens namn',
    SLIDE_NAME_WARNING: 'Namn krävs',
    SLIDE_IMAGE: 'Slide-bild',
    SLIDE_IMAGE_ALT: 'slide image',
    SLIDE_TYPE_SELECT: 'Välj typ av slide',
    SLIDE_ACTIVE_MENU: 'Aktiv meny',
    SLIDE_IMAGE_TYPE: 'Bild',
    SLIDE_VIDEO_TYPE: 'Video',
    SLIDE_VIDEO: 'Slide-video',
    SLIDE_VIDEO_FILE: 'Videofil',
    SLIDE_VIDEO_ALT: 'slide video',
    SLIDE_FILE_UPLOADED: 'Fil uppladdad',
    SLIDE_VIDEO_FORMATS_HINT: 'Format som stöds: MP4. Maxstorlek: 50 MB.',
    SLIDE_VIDEO_DURATION_HINT: 'Hämtad från den uppladdade videofilen',
    SLIDE_DELAY_REQUIRED: 'Fördröjning är obligatorisk',
    UPLOAD_VIDEO: 'Ladda upp video',
    VIDEO_GALLERY: 'Video Galleri',
    VIDEO_URL: 'Video URL',
    VIDEO_DURATION: 'Varaktighet (sekunder)',
    SLIDE_EDIT_SLIDE: 'Editera slide',
    SLIDE_EDIT_SUBTITLE: 'Uppdatera denna slide i din skyltning',
    SLIDE_NAME_MINLENGTH: 'Namnet behöver vara minst 3 bokstäver',
    SLIDE_DELAY_SECONDS_SUFFIX: 'sek',
    SIGNAGE_MIN_3_CHARACTERS: 'Minst 3 tecken',
    SLIDE_CREATED: 'Slide skapad',
    SLIDE_UPDATED: 'Slide uppdaterad',
    SLIDE_PUBLISHED: 'Slide publicerad',
    SLIDE_UNPUBLISHED: 'Slide avpublicerad',
    SLIDE_DELETED: 'Slide borttagen',
    REMOVE_SLIDE_HEADER: 'Ta bort slide',
    REMOVE_SLIDE_MESSAGE: 'Är du säker på att du vill ta bort sliden?',
    REMOVE_SLIDE: 'Ta bort slide',
    REMOVE_COLLECTION_HEADER: 'Ta bort samling',
    REMOVE_COLLECTION_MESSAGE: 'Att ta bort denna samling kan påverka skärmar som använder den.',
    REMOVE_COLLECTION: 'Ta bort samling',
    COLLECTION_DELETED: 'Samling borttagen',
    COLLECTION_CREATED_SUCCESS: 'Kollektionen har skapats',
    COLLECTION_UPDATED_SUCCESS: 'Kollektionen har uppdaterats',
    ACTIVE_MENU_SLIDE: 'Aktiv meny-slide',
    CUSTOM_MENU_SLIDE: 'Anpassad meny-slide',
    IMAGE_SLIDE: 'Bild-slide',
    VIDEO_SLIDE: 'Video-slide',
    VIDEO_TOO_LARGE: 'Videofil får vara högst 50MB',
    VIDEO_TOO_LONG: 'Video får vara högst 60 sekunder',
    VIDEO_INVALID_FORMAT: 'Endast MP4-filer stöds',
    VIDEO_PROBE_FAILED: 'Kan inte läsa videometadata',
    VIDEO_UPLOAD_FAILED: 'Videouppladdning misslyckades',
    SLIDE_CUSTOM_MENU: 'Anpassad',
    CUSTOM_MENU_DISPLAYS_TITLE: 'Anpassad menydisplay',
    CUSTOM_MENU_DISPLAY_CREATE: 'Skapa menydisplay',
    SELECT_CUSTOM_MENU: 'Välj anpassad meny-display',
    NO_CUSTOM_MENU_DISPLAYS: 'Inga anpassade meny-displays hittade',
    CUSTOM_MENU_DISPLAY: 'Anpassad menydisplay',
    CUSTOM_ACTION: 'Hantera',
    CONFIRM_DELETE_CUSTOM_MENU_MESSAGE: 'Är du säker att du vill ta bort anpassad-meny-display? Vissa slides kan påverkas',
    CONFIRM_DELETE_CUSTOM_MENU_HEADER: 'Ta bort anpassad meny-display',
    CUSTOM_MENU_SUBTITLE: 'Hantera dina anpassade skyltvisningar',
    CUSTOM_MENU_TOTAL_DISPLAYS: 'Totalt antal visningar',
    CUSTOM_MENU_TOTAL_PRODUCTS: 'Totalt antal produkter',
    CUSTOM_MENU_THEMED_DISPLAYS: 'Temastylade visningar',
    CUSTOM_MENU_THEME: 'Tema',
    CUSTOM_MENU_PRODUCT: 'produkt',
    CUSTOM_MENU_BACKGROUND_IMAGE: 'Bakgrundsbild',
    CUSTOM_MENU_LOGO: 'Logotyp',
    CUSTOM_MENU_PRODUCT_IMAGES_ON: 'Produktbilder på',
    CUSTOM_MENU_EMPTY_DESCRIPTION: 'Skapa din första anpassade visning för att visa utvalda produkter på dina skyltar.',
    CUSTOM_MENU_EDIT_DISPLAY: 'Redigera visning',
    CUSTOM_MENU_NEW_DISPLAY: 'Ny anpassad visning',
    CUSTOM_MENU_OF_5_SELECTED: 'av 5 valda',
    CUSTOM_MENU_NO_PRODUCTS_SELECTED: 'Inga produkter valda ännu.',
    CUSTOM_MENU_SWITCH_AVAILABLE_PRODUCTS: 'Byt till Tillgängliga produkter för att lägga till.',
    CUSTOM_MENU_NO_SEARCH_MATCH: 'Inga produkter matchar din sökning.',
    CUSTOM_MENU_FONT_COLOR: 'Textfärg',
    CUSTOM_MENU_SHOW_PRODUCT_IMAGES: 'Visa produktbilder',
    CUSTOM_MENU_DISPLAY_THUMBNAILS: 'Visa miniatyrer på skyltvisningen',
    CUSTOM_MENU_SELECT_LOGO: 'Välj logotyp från galleriet',
    CUSTOM_MENU_LOGO_SELECTED: 'Logotyp vald',
    CUSTOM_MENU_SELECT_BACKGROUND: 'Välj bakgrund från galleriet',
    CUSTOM_MENU_BACKGROUND_SELECTED: 'Bakgrund vald',
    CUSTOM_MENU_THEME_SAVE_NOTE: 'Temaändringar tillämpas på dina skyltar efter att du sparar.',
    CUSTOM_MENU_DISPLAY_SAVE_SUCCESS: '"{name}" har sparats.',
    CUSTOM_MENU_DISPLAY_SAVE_ERROR: 'Det gick inte att spara den anpassade visningen. Försök igen.',

    CATERING_PICKUP_AVAILABILITY_DESC: 'Konfigurera vilka dagar och tidsluckor kunder kan välja för upphämtning. Aktivera/inaktivera varje dag och lägg till specifika tidsintervall.',
    CATERING_PICKUP_AVAILABILITY: 'Tillgänglighet för upphämtning',
    CATERING_SLOTS: 'Tidsluckor',
    CATERING_DISABLED: 'Inaktiverad',
    CATERING_START_TIME: 'Starttid',
    CATERING_END_TIME: 'Sluttid',
    CATERING_DELIVERY_TIME: 'Leveranstid',
    CATERING_ADD_TIME_SLOT: 'Lägg till tidslucka',
    CATERING_PRODUCTION_DAYS_HEADER: 'Produktionsdagar',
    CATERING_PRODUCTION_DAYS_DESCRIPTION: 'Konfigurera vilka veckodagar som räknas som produktionsdagar vid beräkning av minsta upphämtningsdatum. Dagar som inte är produktionsdagar kommer att hoppas över vid beräkning av ledtid.',
    CATERING_PRODUCTION_DAYS_LABEL: 'Dagar som räknas som produktionsdagar',
    DAYS_MONDAY: 'Måndag',
    DAYS_TUESDAY: 'Tisdag',
    DAYS_WEDNESDAY: 'Onsdag',
    DAYS_THURSDAY: 'Torsdag',
    DAYS_FRIDAY: 'Fredag',
    DAYS_SATURDAY: 'Lördag',
    DAYS_SUNDAY: 'Söndag',
    CONFIRMATION_REQUIRED: 'Bekräftelse krävs',
    DO_YOU_WANT_TO_PROCEED: 'Vill du fortsätta?',
    REMOVING_LAST_TIMESLOT: 'Att ta bort den sista tidsluckan kommer att inaktivera',
    NO_DAYS_AVAILABLE: 'Inga dagar är tillgängliga för upphämtning',
    CREATE_CAMPAIGN_MENU_TITLE: 'Skapa kampanjmeny',
    EVENT_SETTINGS: 'Evenemangsinställningar',
    CREATE_EVENT_MENU: 'Skapa evenemangsmeny',
    UPLOAD_HERO_IMAGE: 'Ladda upp hero-bild',
    CAMPAIGN_BUTTON_TEXT: 'Kampanjknapptext',
    CAMPAIGN_BUTTON_PLACEHOLDER: 'Ange texten för kampanjknappen',
    CAMPAIGN_MENU_LIST: 'Lista över kampanjmenyer',
    VIEW_CAMPAIGN_MENUS: 'Visa och hantera alla dina kampanjmenyer',
    STARTS: 'Startar',
    ENDS: 'Slutar',
    SAVE_CHANGES: 'Spara ändringar',
    EVENT: 'Evenemang',
    ACTIVATE_EVENT_MENU: 'Aktivera evenemangsmeny',
    ACTIVATE_EVENT_MENU_WARNING_MESSAGE: 'Alla kampanjmenyer kommer att inaktiveras när du aktiverar en evenemangsmeny. Du måste bekräfta denna åtgärd för att fortsätta.',
    CONTINUE: 'Jag förstår, fortsätt',
    NO_REGULAR_MENU_WARNING: 'Vänligen aktivera en vanlig meny innan du fortsätter',
    MENU_ACTIVATION_REQUIRES_CATEGORY_WITH_PRODUCT: 'En meny måste ha minst en kategori med minst en produkt innan den kan aktiveras.',
    EVENT_MENU_WARNING: 'Vänligen inaktivera evenemangsmenyn och aktivera en vanlig meny först',
    DEACTIVATE_MENU_WARNING_MESSAGE: 'Att inaktivera denna meny kommer också att inaktivera den aktuellt aktiva kampanjmenyn. Vill du fortsätta?',
    DELETE_MENU_WARNING_MESSAGE: 'Att ta bort denna meny kommer också att inaktivera den aktuellt aktiva kampanjmenyn. Vill du fortsätta?',
    HERO_IMAGE_TEXT: 'Hero-bildtext',
    HERO_IMAGE_TEXT_PLACEHOLDER: 'Lägg till en text på kampanjens hero-bild',
    EVENT_MENU_FIXED_DATE_WARNING: 'Evenemangsmenyer bör ha fasta datum',


    // catering hero image text settings
    CATERING_COMMUNICATION_TAB: 'Kommunikation',
    CATERING_THEME_TAB: 'Tema',
    CATERING_ALERT_BANNER_HEADER: 'Catering Informationsbanner',
    CATERING_ALERT_BANNER_DESCRIPTION: 'Lägg till ett meddelande för att informera gäster om aktuella problem eller störningar. När detta är aktiverat visas texten som en varningsbanner i webbappen.',
    CATERING_ALERT_BANNER_TEXT_HEADER: 'Bannertext',
    CATERING_ALERT_BANNER_TEXT_COLOR: 'Textfärg för banner',
    CATERING_ALERT_BANNER_TEXT_COLOR_PLACEHOLDER: 't.ex. #000000 eller #FFFFFF',
    CATERING_ALERT_BANNER_BACKGROUND_COLOR: 'Bakgrundsfärg för banner',
    CATERING_ALERT_BANNER_BACKGROUND_COLOR_PLACEHOLDER: 't.ex. #FFF3CD eller #FFFFFF',
    CATERING_ALERT_BANNER_TEXT_PLACEHOLDER: 'Ange meddelande för banner',
    CATERING_ALERT_BANNER_TEXT_MAX_LENGTH: 'Maximalt antal tecken för banner har uppnåtts.',
    CATERING_HERO_IMAGE_AND_LOGO_HEADER: 'Hero-bild och logotyp',
    CATERING_HERO_IMAGE_AND_LOGO_DESCRIPTION: 'Konfigurera hero-bild och logotyp.',
    CATERING_BUTTON_COLORS_HEADER: 'Knappfärger',
    CATERING_BUTTON_COLORS_DESCRIPTION: 'Anpassa den primära knappfärgen och textfärgen som används i Catering-webbappen.',
    CATERING_BUTTON_PRIMARY_COLOR: 'Primär knappfärg',
    CATERING_BUTTON_TEXT_COLOR: 'Textfärg för knapp',
    CATERING_FONTS_HEADER: 'Tema-typsnitt',
    CATERING_FONTS_DESCRIPTION: 'Konfigurera rubrik- och brödtexttypsnitt.',
    CATERING_TITLE_FONT_LABEL: 'Rubriktypsnitt',
    CATERING_BODY_FONT_LABEL: 'Brödtexttypsnitt',
    CATERING_THEME_LOGO_HEADER: 'Logotyp',
    CATERING_THEME_HERO_IMAGE_HEADER: 'Hero-bild',
    CATERING_THEME_PREVIEW_HEADER: 'Förhandsgranskning',
    CATERING_THEME_PREVIEW_BTN_SOLID: 'Knapp',
    CATERING_THEME_PREVIEW_BTN_OUTLINED: 'Kontur',
    CATERING_THEME_PREVIEW_BTN_TEXT: 'Text',
    CATERING_THEME_REPLACE: 'Ersätt',
    CATERING_HERO_IMAGE_HEADER: 'Hero-bildtext',
    CATERING_HERO_IMAGE_DESCRIPTION: 'Konfigurera texten för hero-bilden',
    CATERING_HERO_IMAGE_TITLE_HEADER: 'Titel',
    CATERING_HERO_IMAGE_TITLE_PLACEHOLDER: 'Ange titel för hero-bild',
    CATERING_HERO_IMAGE_TITLE_MAX_LENGTH: 'Maximalt antal tecken för hero-bildens titel har uppnåtts.',
    CATERING_HERO_IMAGE_BODY_HEADER: 'Brödtext',
    CATERING_HERO_IMAGE_BODY_PLACEHOLDER: 'Ange beskrivning för hero-bild',
    CATERING_HERO_IMAGE_BODY_MAX_LENGTH: 'Maximalt antal tecken för hero-bildens beskrivning har uppnåtts.',
    CATERING_HERO_IMAGE_TEXT_CONFIGURATION_SAVED: 'Hero-bildens text har sparats.',
    CATERING_HERO_IMAGE_TEXT_CONFIGURATION_SAVE_ERROR: 'Det gick inte att spara hero-bildens text. Försök igen.',
    CATERING_HERO_IMAGE_TITLE_REQUIRED: 'Titel för hero-bild krävs.',
    CATERING_HERO_IMAGE_BODY_REQUIRED: 'Beskrivning för hero-bild krävs.',
    CATERING_ALERT_BANNER_TEXT_REQUIRED: 'Bannertext krävs.',
    CATERING_ALERT_BANNER_SWITCH_MESSAGE: 'Du måste ange ett meddelande för banner innan du kan aktivera bannern.',
    SETTINGS_UPDATED: 'Inställningar uppdaterade.',
    SETTINGS_COULDNT_UPDATE: 'Något gick fel. Kunde inte uppdatera inställningar.',
    CATERING_CUTOFF_TIME_UPDATED: "Orderavgränsningstid uppdaterad",
    CATERING_CUTOFF_TIME_COULDNT_UPDATE: "Något gick fel. Kunde inte uppdatera avgränsningstid.",
    ORDER_CUTOFF_CONFIGURATION: 'Orderavgränsningsinställning',
    ORDER_CUTOFF_DESCRIPTION: 'Ange senaste tid för att produktionen ska påbörjas samma dag som beställningen',
    SELECT_TIME: 'Välj tid',
    ADJUST_CUTOFF_TIME: 'Justera orderavgränsningstid',
    ALLERGEN_DESCRIPTION: 'Allergenbeskrivning',
    ENTER_ALLERGEN_DESCRIPTION: 'Ange allergenbeskrivning',
    NO_ACTIVE_CAMPAIGN_MENU: 'Ingen aktiv kampanjmeny',
    CAMPAIGN_MENU_STATUS: 'Kampanjmenystatus',
    AUTO_APPROVE_ORDERS_HEADER: 'Godkänn beställningar automatiskt',
    AUTO_APPROVE_ORDERS_DESCRIPTION: 'Godkänn inkommande cateringbeställningar automatiskt utan manuell granskning.',
    SHOW_MANDATORY_POPUP_FOR_DATE_HEADER: 'Obligatorisk popup för datumval',
    SHOW_MANDATORY_POPUP_FOR_DATE_DESCRIPTION: 'Visa en popup i cateringwebbappen som kräver att kunden väljer ett datum innan menyn visas.',
    NOTIFICATION_EMAILS_HEADER: 'E-postmeddelanden för beställningar',
    NOTIFICATION_EMAILS_DESCRIPTION: 'Lägg till e-postadresser för att ta emot meddelanden om nya cateringbeställningar. Flera e-postadresser kan läggas till.',
    NOTIFICATION_EMAIL_LANGUAGE: 'Språk för notifieringsmail',
    ADD_EMAIL: 'Lägg till e-post',
    ENTER_EMAIL_ADDRESS: 'Ange e-postadress',
    ADDED_EMAILS: 'Tillagda e-postadresser',
    NO_EMAILS_ADDED: 'Inga e-postadresser tillagda',
    INVALID_EMAIL_FORMAT: 'Ogiltigt e-postformat',
    EMAIL_ALREADY_EXISTS: 'E-postadressen finns redan',
    CATERING_MENU_PREFERENCE_HEADER: 'Produktmenutyp',
    CATERING_MENU_PREFERENCE_DESCRIPTION: 'Välj vilken menutyp som ska visa en produkt om den finns i både Normal- och Kampanjemenyer. När en produkt läggs till i båda menutyperna kommer den endast att visas i den menutyp som väljs här i inställningarna.',
    IMPORTANT: 'Viktigt',
    MENU_PREFERENCE_NOTE: 'En produkt kan endast tillhöra en menutyp. Om den förekommer i både Kampanj- och Normalmenyer kommer den att visas enligt din valda menupreferens.',
    CATERING_SELECT_MENU_TYPE: 'Välj menutyp',
    CATERING_MENU_PREFERENCE_NOTE: 'Om en produkt läggs till i båda menutyperna kommer den endast att visas i den föredragna menutypen.',
    CATERING_CAMPAIGN_MENU: 'Kampanj',
    CATERING_REGULAR_MENU: 'Normal',

    // Catering addon groups
    CATERING_ADDONS_SUBTITLE: 'Hantera cateringtillvalsgrupper och deras alternativ',
    CATERING_ADDON_CREATE_GROUP: 'Skapa tillvalsgrupp',
    CATERING_ADDON_SEARCH_GROUPS: 'Sök tillvalsgrupper...',
    CATERING_ADDON_AVAILABILITY: 'Tillgänglighet',
    CATERING_ADDON_OPTIONS_LABEL: 'Alternativ',
    CATERING_ADDON_OPTION_SINGULAR: 'alternativ',
    CATERING_ADDON_OPTION_PLURAL: 'alternativ',
    CATERING_ADDON_PRODUCT_SINGULAR: 'produkt',
    CATERING_ADDON_PRODUCT_PLURAL: 'produkter',
    CATERING_ADDON_LOADING: 'Laddar…',
    CATERING_ADDON_NO_GROUPS: 'Inga tillvalsgrupper hittades',
    CATERING_ADDON_NO_GROUPS_HINT: 'Skapa din första tillvalsgrupp för att komma igång',
    CATERING_ADDON_LOAD_ERROR: 'Kunde inte ladda tillvalsgrupper.',
    CATERING_ADDON_SAVED: 'Sparat',
    CATERING_ADDON_UPDATED: 'Tillvalsgruppen har uppdaterats.',
    CATERING_ADDON_CREATED: 'Tillvalsgruppen har skapats.',
    CATERING_ADDON_SAVE_FAILED: 'Kunde inte spara',
    CATERING_ADDON_UPDATE_ERROR: 'Kunde inte uppdatera tillvalsgruppen. Försök igen.',
    CATERING_ADDON_CREATE_ERROR: 'Kunde inte skapa tillvalsgruppen. Försök igen.',
    CATERING_ADDON_DELETE_FAILED: 'Kunde inte ta bort',
    CATERING_ADDON_DELETE_ERROR: 'Kunde inte ta bort tillvalsgruppen. Försök igen.',
    CATERING_ADDON_TYPE_SINGLE: 'Enkel',
    CATERING_ADDON_TYPE_MULTIPLE: 'Flera',
    CATERING_ADDON_EDIT_GROUP: 'Redigera tillvalsgrupp',
    CATERING_ADDON_NEW_GROUP: 'Ny tillvalsgrupp',
    CATERING_ADDON_EDIT_SUBTITLE: 'Uppdatera detaljerna för denna tillvalsgrupp',
    CATERING_ADDON_NEW_SUBTITLE: 'Fyll i uppgifterna för att skapa en ny tillvalsgrupp',
    CATERING_ADDON_STEP_ADD_OPTIONS: 'Lägg till alternativ',
    CATERING_ADDON_NAME_PLACEHOLDER: 't.ex. Välj en sås',
    CATERING_ADDON_DESCRIPTION_PLACEHOLDER: 'Kort beskrivning som visas för kunden',
    CATERING_ADDON_TYPE_LABEL: 'Tillvalstyp',
    CATERING_ADDON_TYPE_SINGLE_DESC: 'Kunden väljer exakt ett alternativ',
    CATERING_ADDON_TYPE_MULTIPLE_DESC: 'Kunden väljer ett eller flera alternativ',
    CATERING_ADDON_DELIVERY_METHOD_AVAILABILITY: 'Tillgänglighet per leveranssätt',
    CATERING_ADDON_PICKUP_HINT: 'Visa för upphämtningsbeställningar',
    CATERING_ADDON_DELIVERY_HINT: 'Visa för leveransbeställningar',
    CATERING_ADDON_ADD_PRODUCT: 'Lägg till produkt',
    CATERING_ADDON_SEARCH_PRODUCT_PLACEHOLDER: 'Sök produkt…',
    CATERING_ADDON_ADD: 'Lägg till',
    CATERING_ADDON_NOT_FOUND: 'Hittades inte',
    CATERING_ADDON_REMOVE: 'Ta bort',
    CATERING_ADDON_NO_PRODUCTS_LINKED: 'Inga produkter är länkade till denna grupp ännu.',
    CATERING_ADDON_LINKS_APPLIED_ON_SAVE: 'Produktlänkar tillämpas vid Spara.',
    CATERING_ADDON_SELECTION_RULES: 'Valregler',
    CATERING_ADDON_PRESELECT: 'Förval',
    CATERING_ADDON_PRESELECT_HINT: 'Standardalternativ när kunden öppnar denna grupp.',
    CATERING_ADDON_PRESELECTED_OPTION: 'Förvalt alternativ',
    CATERING_ADDON_CHOOSE_OPTION: 'Välj ett alternativ',
    CATERING_ADDON_MIN_SELECTED: 'Min antal valda',
    CATERING_ADDON_MIN_SELECTED_HINT: 'Minsta antal alternativ kunden måste välja.',
    CATERING_ADDON_MAX_SELECTED: 'Max antal valda',
    CATERING_ADDON_NO_LIMIT: 'Ingen gräns',
    CATERING_ADDON_MAX_SELECTED_HINT: 'Lämna tomt för ingen övre gräns.',
    CATERING_ADDON_OPTIONS_REQUIRED: 'Tillvalsalternativ',
    CATERING_ADDON_DRAG_REORDER: 'Dra för att ändra ordning',
    CATERING_ADDON_OPTION_NAME: 'Alternativnamn',
    CATERING_ADDON_OPTION_NAME_PLACEHOLDER: 't.ex. Vitlöksaioli',
    CATERING_ADDON_LINK: 'Länka',
    CATERING_ADDON_REMOVE_LINK: 'Ta bort länk',
    CATERING_ADDON_DELETE_OPTION: 'Ta bort alternativ',
    CATERING_ADDON_NO_OPTIONS_YET: 'Inga alternativ ännu. Klicka på "Lägg till alternativ" för att börja.',
    CATERING_ADDON_PRESELECT_NONE: 'Ingen',
    CATERING_ADDON_PRESELECT_FIRST: 'Första alternativet',
    CATERING_ADDON_PRESELECT_SPECIFIC: 'Specifikt alternativ',
    CATERING_ADDON_ERR_FIRST_OPTION: 'Lägg till minst ett alternativ innan du använder "Första alternativet".',
    CATERING_ADDON_ERR_CHOOSE_PRESELECT: 'Välj vilket alternativ som ska förvalas.',
    CATERING_ADDON_ERR_PRESELECT_INVALID: 'Förvalt alternativ måste vara ett av alternativen nedan.',
    CATERING_ADDON_ERR_MIN_ZERO: 'Min antal valda måste vara 0 eller högre.',
    CATERING_ADDON_ERR_MAX_ZERO: 'Max antal valda måste vara 0 eller högre, eller lämnas tomt.',
    CATERING_ADDON_ERR_MAX_LESS_MIN: 'Max antal valda kan inte vara mindre än min antal valda.',

    // Catering products editor
    CATERING_PRODUCT_LOADING_ADDONS: 'Laddar...',
    CATERING_PRODUCT_NO_ADDON_GROUPS_AVAILABLE: 'Inga tillvalsgrupper tillgängliga',
    CATERING_PRODUCT_HIDE_OPTIONS: 'Dölj alternativ',
    CATERING_PRODUCT_NO_OPTIONS_IN_GROUP: 'Inga alternativ i denna grupp.',
    CATERING_PRODUCT_NO_ADDON_GROUPS_LINKED: 'Inga tillvalsgrupper länkade.',
    CATERING_PRODUCT_SET_SELLING_PRICE_HINT: 'Ange försäljningspris för denna produkt',
    CATERING_PRODUCT_SELECT_TAB: 'Välj en flik.',
    CATERING_PRODUCT_PREVIEW: 'Produktförhandsvisning',
    CATERING_PRODUCT_NO_IMAGE: 'Ingen bild',
    CATERING_PRODUCT_UNTITLED: 'Namnlös produkt',
    CATERING_PRODUCT_NO_CATEGORY_SELECTED: 'Ingen kategori vald',
    CATERING_PRODUCT_NO_SHORT_DESCRIPTION: 'Ingen kort beskrivning angiven.',
    CATERING_PRODUCT_NO_LONG_DESCRIPTION: 'Ingen lång beskrivning angiven.',
    CATERING_PRODUCT_MIN_LEAD_DAYS_LABEL: 'Min ledtid (dagar)',
    CATERING_PRODUCT_MODIFIED_AT: 'Ändrad:',
    CATERING_PRODUCT_ID_LABEL: 'Produkt-ID:',
    CATERING_PRODUCT_ERR_MIN_EXCEEDS_MAX: 'Minsta beställningsantal kan inte överstiga högsta beställningsantal',
    CATERING_PRODUCT_ERR_STOCK_LT_MAX: 'Lagersaldo kan inte vara lägre än högsta beställningsantal',
    CATERING_PRODUCT_ERR_STOCK_LT_MIN: 'Lagersaldo kan inte vara lägre än minsta beställningsantal',
    CATERING_PRODUCT_DAYS_SUFFIX: 'dagar',

    // Catering orders UI
    CATERING_ORDER_UPDATE_DATE_TIME: 'Uppdatera datum och tid',
    CATERING_ORDER_CUSTOMER_EMAIL_UNAVAILABLE: 'Kundens e-postadress är inte tillgänglig',
    CATERING_ORDER_SELECT_DATE_RANGE: 'Välj ett datumintervall',
    CATERING_ORDER_SELECT_VALID_DATE_RANGE: 'Välj ett giltigt datumintervall',
    CATERING_ORDER_NO_APPROVED_ORDERS: 'Inga godkända beställningar hittades för valda kriterier',
    CATERING_ORDER_NO_APPROVED_IN_RANGE: 'Inga godkända beställningar hittades inom valt datumintervall',
    CATERING_ORDER_SELECT_DATE_AND_TIME: 'Välj datum och tid',
    CATERING_ORDER_DATE_CANNOT_BE_PAST: 'Datumet kan inte ligga i det förflutna',
    CATERING_ORDER_EXPORT_PDF_SUCCESS: 'Beställningar exporterade till PDF',
    CATERING_ORDER_EXPORT_LOAD_FAILED: 'Kunde inte ladda beställningar för export',
    CATERING_ORDER_EXPORT_FAILED: 'Kunde inte exportera beställningar',
    CATERING_ORDER_PRINT_LOAD_FAILED: 'Kunde inte ladda beställningar för utskrift',
    CATERING_ORDER_PRINT_FAILED: 'Kunde inte skriva ut beställningar',
    CATERING_ORDER_PRODUCTION_LOAD_FAILED: 'Kunde inte ladda beställningar för produktionsuppgifter',
    CATERING_ORDER_PRODUCTION_EXPORT_FAILED: 'Kunde inte exportera produktionsuppgifter',

    //KDS
    KDS_TITLE: 'KDS',
    KDS_ORDERS_TITLE: 'Köksbeställningar',
    KDS_ORDERS_DESC: 'Övervaka servering, avhämtning och leveransbeställningar när de rör sig genom kökets arbetsflöde.',
    PENDING_TAG: 'Väntande',
    INPROGRESS_TAG: 'Pågående',
    COMPLETED_TAG: 'Slutförd',
    ORDER_STATUS_PLACEHOLDER: 'Inga beställningar valda',
    ORDER_TYPE_PLACEHOLDER: 'Alla typer',
    ORDER_SEARCH_PLACEHOLDER: 'Sök...',
    TABLE_COLUMNS_PLACEHOLDER: 'Välj kolumner',
    ORDER_NUMBER_HEADER: 'Ordernummer',
    ORDER_CREATED_DATETIME_HEADER: 'Skapad datum/tid',
    STATUS_HEADER: 'Status',
    ORDER: 'Beställning',
    REQUEST_REFUND_BTN: 'Begär återbetalning',
    REJECT_ORDER_BTN: 'Avvisa beställning',
    PRINT_BTN: 'Skriv ut',
    SET_COMPLETION_TIME: 'Ange sluttid:',
    MINUTES_ABBR: 'min',
    CUSTOM: 'Annan',
    ORDER_INFORMATION_HEADER: 'Beställningsinformation',
    ORDER_DATE_LABEL: 'Beställningsdatum:',
    ORDER_TIME_LABEL: 'Beställningstid:',
    ORDER_METHOD_LABEL: 'Metod:',
    DELIVERY_METHOD_D: 'Leverans',
    DELIVERY_METHOD_FD: 'Fast leverans',
    EATIN_METHOD: 'Äta här',
    TABLE_SERVING_METHOD: 'Bordsservering',
    TAKEAWAY_METHOD: 'Avhämtning',
    TAKEAWAY_FOOD: 'Takeaway mat',
    TAKEAWAY_DRINKS: 'Takeaway dryck',
    NO_ORDERS: 'Inga beställningar',
    PRINT_ORDERS_DIALOG_HEADER: 'Skriv ut beställningar',
    FILTER_BY_STATUS_LABEL: 'Filtrera efter status:',
    SELECT_STATUS_PLACEHOLDER: 'Välj status',
    SELECT_PRINT_ORDERS_LABEL: 'Välj beställningar att skriva ut:',
    SELECTED_ORDERS_LABEL: '{0} beställningar valda',
    CHOOSE_ORDERS_PLACEHOLDER: 'Välj beställningar',
    NO_ORDERS_WITH_STATUS: 'Inga beställningar hittades med statusen',
    CANCEL_BTN: 'Avbryt',
    PRINT_SELECTED_BTN: 'Skriv ut valda',
    RECEIPT_NUMBER_HEADER: 'Kvittonummer',
    ORDER_USER_NAME_HEADER: 'Namn',
    ORDER_TYPE_HEADER: 'Beställningstyp',
    EMAIL_HEADER: 'E-post',
    DELIVERY_LOCATION_HEADER: 'Leveransplats',
    PHONE_NUMBER_HEADER: 'Telefonnummer',
    PAYMENT_METHOD_HEADER: 'Betalningsmetod',
    DELIVERY_ADDRESS_LABEL: 'Leveransadress:',
    DELIVERY_LOCATION_LABEL: 'Leveransplats:',
    TABLE_LABEL: 'Bord:',
    RESERVATION_LABEL: 'Bordsbokning:',
    SCHEDULED_TIME_LABEL: 'Schemalagd tid:',
    DISCOUNT_CODE_LABEL: 'Rabattkod',
    OFF: 'rabatt',
    CUSTOMER_NOTE_LABEL: 'Kundens meddelande:',
    DELIVERY_INSTRUCTIONS_LABEL: 'Leveransinstruktion:',
    PRODUCTS_HEADER: 'Produkter',
    FOOD_HEADER: 'Mat',
    DRINKS_HEADER: 'Dryck',
    UNKNOWN_PRODUCT: 'Okänd produkt',
    QUANTITY_LABEL: 'Antal',
    ITEM_COMMENT_LABEL: 'Produktens kommentar',
    NO_ITEMS: 'Inga produkter',
    TOTAL_HEADER: 'Totalt:',
    CUSTOMER_INFO_HEADER: 'Kundinformation',
    FULL_NAME_LABEL: 'Fullständigt namn:',
    EMAIL_LABEL: 'E-post:',
    PHONE_LABEL: 'Telefon:',
    ADDRESS_LABEL: 'Adress:',
    PAYMENT_INFO_HEADER: 'Betalningsinformation',
    DETAILS_LABEL: 'Detaljer:',
    DELIVERY_FEE_LABEL: 'Leveransavgift',
    DISCOUNT_LABEL: 'Rabatt',
    COUPON_DISCOUNT_LABEL: 'Kupongrabatt',
    BONUS_VOUCHER_LABEL: 'Bonuskupong',
    TOTAL_LABEL: 'Summa',
    COMPLETE_SELECTED_ITEMS: 'Slutför valda artiklar',
    SET_ORDER_COMPLETED_HEADER: 'Ange beställning slutförd',
    SET_ORDER_COMPLETED_MESSAGE: 'Är du säker på att du vill markera hela beställningen som slutförd? Detta kan inte ångras.',
    REJECT_ORDER_CONFIRM_MESSAGE: 'Är du säker på att du vill avvisa denna beställning? Detta kan inte ångras.',
    REJECT_ORDER_HEADER: 'Avvisa beställning',
    REJECTED_ORDER_SUMMARY: 'Beställning avvisad',
    REJECTED_ORDER_DETAIL: 'Beställningen har blivit avvisad.',
    REJECT_ORDER_ERROR_SUMMARY: 'Fel',
    REJECT_ORDER_ERROR_DETAIL: 'Misslyckades med att avvisa beställning.',
    REQUEST_REFUND_CONFIRM_MESSAGE: 'Är du säker på att du vill begära återbetalning? Detta kan inte ångras.',
    REQUEST_REFUND_HEADER: 'Begär återbetalning',
    REFUND_REQUESTED_SUMMARY: 'Återbetalning begärd',
    REFUND_REQUESTED_DETAIL: 'Din begäran om återbetalning har skickats.',
    REQUEST_REFUND_ERROR_SUMMARY: 'Fel',
    REQUEST_REFUND_ERROR_DETAIL: 'Misslyckades med att begära återbetalning.',
    ORDER_STATUS_UPDATED: 'Beställningsstatus uppdaterad',
    FOOD_ITEM_COMPLETED_HEADER: 'Matartikel slutförd',
    DRINK_ITEM_COMPLETED_HEADER: 'Dryck slutförd',
    ITEMS_COMPLETED_HEADER: 'Artiklar slutförda',
    GENERAL_ERROR: 'Något gick fel, försök igen senare',
    COMMENT_ENABLED: 'Kommentar aktiverad',
    REMOVE_ADDON_OPTIONS_APPROVAL: 'Vill du ta bort det här tillvalet?',
    DEL_CONFIRMATION: 'Bekräfta borttagning',
    SELECT_MORE_UNITS: 'Välj fler enheter',
    OVERLAPPING_TIME_SLOT: 'Överlappar med befintlig tid',
    DUPLICATE_DELIVERY_TIME: 'Dubbla leveranstider',
    END_TIME_BEFORE_START_TIME: 'Sluttid måste vara efter starttid',
    RECEIPT_DETAILS: 'Kvittoinformation',
    ORDER_TEXT: 'Order',
    INVOICE_TEXT: 'Faktura',
    INVOICE_DATE: 'Fakturadatum',
    RECEIPT_NO: 'Kvittonummer',
    PHONE_NO: 'Telefonnummer',
    QTY: 'Antal',
    RATE: 'Pris',
    LINE_TOTAL: 'Radbelopp',
    CODE_TEXT: 'Kod',
    KUNIT_TEXT: 'K.enhet',
    PASSWORD_MANAGEMENT: 'Lösenordshantering',
    SEND_PASSWORD_RESET_LINK: 'Skicka länk för återställning av lösenord',
    PASSWORD_RESET_DESCRIPTION: 'Skicka en säker länk för återställning av lösenord till användarens e-postadress.',
    SEND_RESET_LINK: 'Skicka återställningslänk',
    SET_NEW_PASSWORD: 'Ange nytt lösenord',
    SET_PASSWORD_DESCRIPTION: 'Ange ett nytt lösenord direkt för användaren. Användaren kommer att loggas ut omedelbart.',
    NEW_PASSWORD: 'Nytt lösenord',
    UPDATE_PASSWORD: 'Uppdatera lösenord',
    PASSWORD_MIN_LENGTH: 'Lösenordet måste vara minst 6 tecken långt',
    INFORMATION: 'Information',
    SUBTOTAL: 'Delsumma',
    DISCOUNT: 'Rabatt',
    GROSS: 'Brutto', FILTER_ALL_WARING: 'Vänligen filtrera beställningar med samma status',
    SELECT_ORDER_WARING: 'Du kan bara markera beställningar med samma status',
    SUCCESSFULLY_UPDATED_DATE_TIME: 'Datum och tid uppdaterade',
    FAILED_TO_UPDATE_DATE_TIME: 'Misslyckades med att uppdatera datum och tid',
    KIOSK_INFORMATION: 'Kioskplatser',
    ORDER_LIST_APP_HINT: 'Dra för att ändra visningsordning i appen. Klicka på Spara ovan för att tillämpa.',
    ORDER_LIST_KIOSK_HINT: 'Dra för att ändra visningsordning för kioskplatser. Klicka på Spara ovan för att tillämpa.',
    CORPORATE_CUSTOMERS: 'Företagskunder',
    INVOICE_MENU: 'Faktura',
    INVOICES: 'Fakturor',
    INVOICE_LIST_SUBTITLE: 'Fakturor från POS och cateringbeställningar som väntar på manuell vidarebefordran till redovisning.',
    INVOICE_LIST_SEARCH: 'Sök företag, org.nr eller faktura…',
    INVOICE_LIST_EMPTY: 'Inga fakturor ännu',
    INVOICE_LIST_EMPTY_DESCRIPTION: 'Fakturor från POS-fakturabetalningar och slutförda cateringbeställningar på faktura visas här. Prova att justera datumintervall eller filter.',
    INVOICE_LIST_LOAD_FAILED: 'Kunde inte ladda fakturor',
    INVOICE_LIST_DATE_RANGE: 'Välj datumintervall',
    INVOICE_LIST_TEXT_SEARCH_HINT: 'Sökningen matchar företag, org.nr, fakturanummer, kvittonummer och cateringordernummer inom valt datumintervall (upp till 100 senaste fakturor).',
    INVOICE_SOURCE: 'Källa',
    INVOICE_SOURCE_ALL: 'Alla källor',
    INVOICE_SOURCE_POS: 'POS',
    INVOICE_SOURCE_CATERING: 'Catering',
    INVOICE_CATERING_ORDER: 'Cateringorder',
    INVOICE_OPEN_CATERING_ORDERS: 'Öppna Catering → Beställningar',
    INVOICE_LIST_PREVIOUS: 'Föregående',
    INVOICE_LIST_NEXT: 'Nästa',
    INVOICE_LIST_PAGE: 'Sida',
    INVOICE_STATUS_CREATED: 'Skapad',
    INVOICE_STATUS_SENT: 'Skickad',
    INVOICE_MARK_SENT: 'Markera som skickad',
    INVOICE_MARKED_SENT: 'Faktura markerad som skickad',
    INVOICE_MARK_SENT_FAILED: 'Kunde inte uppdatera fakturastatus',
    INVOICE_PDF_FAILED: 'Kunde inte skapa faktura-PDF',
    OPEN_INVOICE: 'Öppna faktura',
    INVOICE_DOWNLOAD_SELECTED: 'Ladda ner valda',
    INVOICE_LOADING_DETAILS: 'Laddar fakturadetaljer...',
    INVOICE_TITLE: 'Faktura',
    INVOICE_BILL_FROM: 'Fakturautställare',
    INVOICE_BILL_TO: 'Fakturakund',
    INVOICE_ISSUED_ON: 'Utfärdad',
    INVOICE_DETAIL: 'Fakturadetaljer',
    INVOICE_GRAND_TOTAL: 'Totalsumma',
    INVOICE_RECEIPT_LINES_UNAVAILABLE: 'Kvittorader är inte tillgängliga.',
    INVOICE_RECEIPT_DATA_UNAVAILABLE: 'Kvittodata är inte tillgängliga',
    INVOICE_NOT_AVAILABLE: 'Inte tillgängligt',
    INVOICE_CORPORATE_CUSTOMER: 'Företagskund',
    INVOICE_PAYMENT_METHOD: 'Betalningsmetod',
    INVOICE_GENERATED_ON: 'Skapad',
    INVOICE_PAGE_OF: 'Sida {0} av {1}',
    INVOICE_DESCRIPTION: 'Beskrivning',
    INVOICE_UNIT_PRICE: 'Styckpris',
    INVOICE_QTY: 'Antal',
    INVOICE_VAT: 'Moms',
    INVOICE_DISCOUNT: 'Rabatt',
    INVOICE_TOTAL: 'Totalt',
    CORPORATE_CUSTOMERS_SUBTITLE: 'Hantera företag och deras leveransplatser för cateringtjänster.',
    CREATE_CORPORATE_CUSTOMER: 'Skapa företagskund',
    COMPANY_EMAIL: 'Företagets e-post',
    CORPORATE_DELIVERY_LOCATIONS: 'Leveransplatser',
    LOCATIONS: 'Platser',
    CORPORATE_BILLING_INFO: 'Faktureringsinfo',
    NO_CORPORATE_CUSTOMERS_TITLE: 'Inga företagskunder ännu',
    NO_CORPORATE_CUSTOMERS_DESCRIPTION: 'Skapa din första företagskund för att hantera faktureringskontakter och leveransplatser.',
    CREATE_FIRST_CORPORATE_CUSTOMER: 'Skapa första företagskunden',
    ORGANIZATION_NUMBER: 'Organisationsnummer',
    ORGANIZATION_ID: 'Organisations-ID',
    EDIT_CORPORATE_CUSTOMER: 'Redigera företagskund',
    LEGAL_ENTITY_INFORMATION: 'Juridisk enhetsinformation',
    LEGAL_NAME: 'Juridiskt namn',
    VAT_NUMBER: 'Momsnummer',
    BILLING_ADDRESS: 'Faktureringsadress',
    STREET_ADDRESS: 'Gatuadress',
    POSTAL_CODE: 'Postnummer',
    INVOICE_SETTINGS: 'Faktureringsinställningar',
    INVOICE_EMAIL: 'Faktura-e-post',
    PAYMENT_TERMS_DAYS: 'Betalningsvillkor (dagar)',
    BILLING_CONTACT: 'Kontakt',
    CONTACT_NAME: 'Kontaktnamn',
    ADDED_LOCATIONS: 'Tillagda platser',
    ADD_DELIVERY_LOCATION: 'Lägg till leveransplats',
    FLOOR: 'Våning',
    ENTRANCE_CODE: 'Portkod',
    DEFAULT_REFERENCE: 'Standardreferens',
    REVIEW_INFORMATION: 'Granska information',
    LEGAL_ENTITY: 'Juridisk enhet',
    PAYMENT_TERMS: 'Betalningsvillkor',
    SUB_LOCATIONS: 'Underplatser',
    ADD_SUB_LOCATION: 'Lägg till underlokation',
    ROOM_CODE: 'Rumskod',
    SUB_LOCATION_NAME: 'Underlokationsnamn',
    STEP_COMPANY_INFO: 'Företagsinfo',
    STEP_BILLING_AND_INVOICE: 'Fakturering',
    NO_DELIVERY_LOCATIONS: 'Inga leveransplatser ännu',
    CORPORATE_CUSTOMER_CREATED: 'Företagskund skapad.',
    CORPORATE_CUSTOMER_UPDATED: 'Företagskund uppdaterad.',
    CORPORATE_CUSTOMER_DELETED: 'Företagskund borttagen.',
    CORPORATE_CUSTOMER_SAVE_FAILED: 'Kunde inte spara företagskund.',
    CORPORATE_CUSTOMER_DELETE_FAILED: 'Kunde inte ta bort företagskund.',
    CORPORATE_GROUP_ERR_FORBIDDEN: 'Du är inte admin för någon restaurang i den här gruppen.',
    CORPORATE_GROUP_ERR_INVALID: 'Företaget sparades inte:',
    CORPORATE_CUSTOMER_DELETE_CONFIRM: 'Är du säker på att du vill ta bort denna företagskund?',
    DELETE_CONFIRMATION: 'Bekräfta borttagning',
    DELIVERY_LOCATIONS_SUBTITLE: 'Leveransplatser och underlokationer för detta företag',
    BILLING_INFO_SUBTITLE: 'Fakturerings- och fakturainformation för denna företagskund',

    // Catering Orders – leverans- och fakturadetaljer
    DELIVERY_INFORMATION: 'Leveransinformation',
    CORPORATE_COMPANY: 'Företagskund',
    COMPANY_PHONE: 'Företagets telefon',
    DELIVERY_LOCATION: 'Leveransplats',
    DELIVERY_ROOM: 'Leveransrum',
    DOOR_CODE: 'Dörrkod',
    INVOICE_NUMBER: 'Fakturanummer',
    LOCATION_NAME: 'Lokationsnamn',
    EDIT_LOCATION_AND_SUBLOCATIONS: 'Redigera lokation och underlokationer',
    SUCCEEDED: 'Lyckades',
    DELIVERY_ROOM_FLOOR: 'Våning',
    DELIVERY_ROOM_DOOR_CODE: 'Rumkod',
    YES_DELETE: 'Ja, ta bort',
    TABLE_QR_CODE: 'Bordets QR-kod',
    TABLE_DETAILS: 'Bordsdetaljer',
    TABLE_MANAGMENT: 'Bordshantering',
    TABLE_MANAGMENT_DESCRIPTION: 'Hantera bordsgrupper. Varje grupp definierar ett intervall av bord (t.ex. 70–100). Borden genereras dynamiskt — inget lagras individuellt.',
    SERVING_METHOD_NAME: 'Namn på serveringsmetod',
    SERVING_METHOD_NAME_DESC: 'Konfigurera hur denna serveringsmetod ska visas i försäljningskanalerna.',
    TABLE_SERVING_OPTION: 'Bordsservering',
    SEAT_SERVING_OPTION: 'Platsservering',
    NEW_GROUP: 'Nytt grupp',
    WEB_ORDER_URL: 'Webbord URL',
    GENERAL_: 'Allmänt',
    ROUTE_NAME: 'Routens namn',
    WEB_ORDER_URL_NOTE: 'Om ingen anpassad URL anges kommer systemet automatiskt att använda standard-URL:en.',
    SEO_SETTINGS: 'SEO-inställningar',
    SEO_SETTINGS_DESC: 'Konfigurera metadata för sökmotoroptimering för att förbättra hur restaurangen visas på Google.',
    SEO_TITLE: 'SEO-titel',
    SEO_TITLE_NOTE: 'Titel som visas i Googles sökresultat och webbläsarfliken. Lämna tomt för att använda standardtitel.',
    SEO_DESCRIPTION: 'SEO-beskrivning (Metabeskrivning)',
    SEO_DESCRIPTION_NOTE: 'Kort sammanfattning som visas under titeln i Googles sökresultat. Rekommenderad längd: 120-160 tecken.',
    DOWNLOAD_ALL_QR: 'Ladda ner alla QR-koder',
    WEB_ORDER_BASE_URL: 'Webborder bas-URL',
    CREATE_TABLE_GROUP: 'Skapa bordgrupp',
    EDIT_TABLE_GROUP: ' Redigera bordgrupp',
    CREATE_SEAT_GROUP: 'Skapa platsgrupp',
    EDIT_SEAT_GROUP: 'Redigera platsgrupp',
    TABLE_RANGE: 'Bordintervall',
    SEAT_RANGE: 'Platsintervall',
    TABLES_WILL_GENERATE: 'Detta kommer att generera {count} bord',
    SEATS_WILL_GENERATE: 'Detta kommer att generera {count} platser',
    END_MUST_BE_GREATER_EQUAL_START: 'Slut måste vara ≥ Start',
    SELECT_ALL: 'Välj alla',
    DOWNLOAD_RANGE: 'Ladda ner intervall',
    QR_CODE: 'QR kod',
    FORMAT: 'Format',
    DOWNLOAD_AS: 'Ladda ner som',
    TABLES: 'Bord',
    SEATS: 'Platser',
    SEAT: 'Plats',
    SEAT_GROUPS: 'Platsgrupper',
    SEAT_MANAGEMENT_DESCRIPTION: 'Hantera platsgrupper. Varje grupp definierar ett intervall av platser (t.ex. 70–100). Platser genereras dynamiskt — ingenting lagras individuellt.',
    VIEW_TABLES: 'Visa bord',
    VIEW_SEATS: 'Visa platser',
    NO_TABLE_GROUPS_YET: 'Inga bordgrupper ännu',
    NO_SEAT_GROUPS_YET: 'Inga platsgrupper ännu',
    GROUP_NAME_REQUIRED: 'Gruppnamn krävs',
    UNIT_NAME_REQUIRED: 'Enhetsnamn krävs',
    WEB_ORDER_URL_REQUIRED: 'Webbordnings-URL krävs',
    TABLE_RANGE_REQUIRED: 'Bordintervall krävs',
    SEAT_RANGE_REQUIRED: 'Platsintervall krävs',
    START_MUST_BE_LESS_EQUAL_END: 'Start måste vara ≤ Slut',
    MAX_1000_TABLES_ALLOWED: 'Intervallet får inte överstiga 1000 bord per grupp',
    MAX_1000_SEATS_ALLOWED: 'Intervallet får inte överstiga 1000 platser per grupp',
    DELETE_GROUP_CONFIRM: 'Ta bort "{group}" ({tables} {start}–{end})? Detta kan inte ångras.',
    GROUP_DELETED: 'Gruppen har tagits bort',
    FAILED_DELETE_GROUP: 'Misslyckades att ta bort gruppen',
    SEARCH_GROUPS: 'Sök grupper...',
    DOWNLOADED: 'Nerladdad',
    DOWNLOADING_QR_CODES: 'Laddar ner QR-koder',
    NO_PRINTERS_SELECTED: 'Inga skrivare valda',
    SELECT_PRINTERS_IN_SETTINGS: 'Välj skrivare från Inställningar -> Skrivare',
    PRINT_SUCCESS: 'Lyckades',
    ORDER_PRINTED_SUCCESSFULLY: 'Beställningen har skrivits ut framgångsrikt',
    ADDON_SERVING_METHODS: 'Serveringssätt',
    ADDON_SERVING_METHODS_HINT: 'Alla serveringssätt är aktiverade som standard. Avmarkera ett serveringssätt för att dölja detta tillval där.',
    ADDONS_V2_RULES_SECTION: 'Urvalsregler',
    ADDON_WIZARD_RULES: 'Regler',
    ADDON_LABEL_SELECTION_TYPE: 'Typ av tillval',
    ADDON_LABEL_PRESELECT_MODE: 'Förvalt läge',
    ADDON_LABEL_MIN_SELECTIONS: 'Minsta antal val',
    ADDON_LABEL_MAX_SELECTIONS: 'Högsta antal val',
    ADDON_REQUIRED_BEFORE_PROCEED: 'Obligatoriskt innan gästen kan fortsätta',
    ADDON_LABEL_PRESELECTED_OPTION: 'Förvalt alternativ',
    SHOW_WHEN_RULES: 'När ska det visas',
    SHOW_WHEN_HINT: 'Denna grupp visas bara när specifika villkor uppfylls från en annan grupps val.',
    ACTIVE_DEPENDENCIES: 'Aktiva beroenden',
    DEPENDS_ON_GROUP: 'Beror på grupp',
    OPTIONS_TO_TRIGGER: 'Alternativ som utlöser',
    ADD_DEPENDENCY: 'Lägg till beroende',
    SHOW_WHEN_GROUP_PREFIX: 'Visa när gruppen',
    SHOW_WHEN_INCLUDES_VERB: 'innehåller',
    ADDON_VALIDATE_INVALID_PAYLOAD: 'Ogiltiga tillvalsregler',
    ADDON_VALIDATE_MAX_SELECTIONS_RADIO: 'Grupper med ett val måste ha max antal val = 1',
    ADDON_VALIDATE_PRESELECT_SPECIFIC: 'Välj ett förvalt alternativ eller ändra förvalt läge',
    ADDON_VALIDATE_MAX_LT_MIN: 'Max antal val kan inte vara lägre än min antal val',
    ADDON_SELECT_ONE_RADIO: 'Ett val (radioknappar)',
    ADDON_SELECT_MULTIPLE_CHECKBOX: 'Flera val (kryssrutor)',
    ADDON_PRESELECT_NONE: 'Inget',
    ADDON_PRESELECT_FIRST: 'Första alternativet',
    ADDON_PRESELECT_SPECIFIC: 'Specifikt alternativ',
    SUBTITLE_LABEL: 'Underrubrik',
    ALWAYS_VISIBLE: 'Alltid synlig',
    VISIBLE_IN_DELIVERY_MENU: 'Synlig i leveransmeny',
    VISIBLE_IN_TAKEAWAY_MENU: 'Synlig i takeaway-meny',
    VISIBLE_IN_EATIN_MENU: 'Synlig i äta-här-meny',
    VISIBLE_IN_TABLEORDER_MENU: 'Synlig i bordsbeställningsmeny',
    VISIBLE_IN_DELIVERYSETLOCATION_MENU: 'Synlig i leveransplatsmeny',
    COMMENT_FIELD_ON_ORDER: 'Kommentarsfält på beställning',
    COMMENT_FIELD_DESCRIPTION: 'Aktivera eller inaktivera kommentarsfältet i kassan',
    CURRENT_WEEK: 'Aktuell vecka',
    NEXT_WEEK: 'Nästa vecka',
    ROLLOVER_SETTINGS: 'Rollover-inställningar',
    ROLLOVER_DESCRIPTION: 'Styr när beställningsappen ska erbjuda nästa vecka för förbeställningar.',
    ROLLOVER_ENABLED: 'Automatiskt veckobyte',
    ROLLOVER_ENABLED_HINT: 'När aktiverat flyttas nästa vecka till aktuell vid inställd dag/tid.',
    ROLLOVER_CUTOFF_DAY: 'Brytdag',
    ROLLOVER_CUTOFF_TIME: 'Brytningstid',
    ROLLOVER_NOW: 'Byt vecka nu',
    ROLLOVER_CONFIRM_MESSAGE: 'Detta flyttar nästa vecka till aktuell vecka. Nästa vecka behålls som den är — använd "Återställ nästa vecka" om du vill tömma den. Fortsätta?',
    ROLLOVER_PERFORMED: 'Veckobyte utfört',
    ROLLOVER_FAILED: 'Veckobyte misslyckades',
    ROLLOVER_SETTINGS_SAVED: 'Veckobyte-inställningar sparade',
    NEXT_ROLLOVER_IN: 'Kunder börjar beställa för nästa vecka från',
    MANUAL_ACTIONS: 'Manuella åtgärder',
    MANUAL_ROLLOVER_DESCRIPTION: 'Veckor sparas per veckonummer, så det finns inget databyte att köra. Använd dessa åtgärder för att fylla eller rensa nästa vecka manuellt.',
    CLONE_CURRENT_TO_NEXT: 'Kopiera aktuell till nästa',
    CLONE_CURRENT_TO_NEXT_CONFIRM: 'Detta skriver över nästa vecka med en kopia av aktuell vecka. Fortsätta?',
    CLONE_CURRENT_TO_NEXT_DONE: 'Aktuell vecka kopierad till nästa',
    CLONE_CURRENT_TO_NEXT_FAILED: 'Kunde inte kopiera aktuell till nästa',
    RESET_NEXT_WEEK: 'Återställ nästa vecka',
    RESET_NEXT_WEEK_CONFIRM: 'Detta rensar nästa vecka till en tom mall (inga produkter, stängda helger). Fortsätta?',
    RESET_NEXT_WEEK_DONE: 'Nästa vecka återställd till tom mall',
    RESET_NEXT_WEEK_FAILED: 'Kunde inte återställa nästa vecka',
    REMOVE_ORPHAN_WEEKLY_MENUS: 'Ta bort {{count}} gamla veckomenyveckor',
    REMOVE_ALL_PAST_WEEKS_CONFIRM: 'Ta bort {{count}} tidigare vecka(or) från databasen? Aktuell och nästa vecka behålls. Detta kan inte ångras.',
    REMOVE_ALL_PAST_WEEKS_DONE: 'Tog bort {{count}} tidigare vecka(or)',
    REMOVE_ALL_PAST_WEEKS_FAILED: 'Kunde inte ta bort tidigare veckor',
    TIME_SETTINGS: 'Tidsinställningar',
    NO_PRODUCTS_YET: 'Inga produkter ännu',
    ALL_PRODUCTS_ALREADY_ADDED: 'Alla produkter redan tillagda',
    NO_WEEKLY_MENU_PRODUCTS_ENABLED: 'Inga produkter är aktiverade för veckomeny. Aktivera produkter under produktens avancerade inställningar för att lägga till dem i veckomenyn.',
    ENABLE_MORE_PRODUCTS_HINT: 'För att lägga till fler produkter, aktivera dem under Produkt > Avancerade inställningar.',
    ADD_PRODUCTS: 'Lägg till produkter',
    ADD_MORE_PRODUCTS: 'Lägg till fler produkter',
    NO_PRODUCTS_SELECTED_FOR_DAY: 'Inga produkter har lagts till för denna dag ännu',
    SCHEDULED_TAG: 'Schemalagd',
    ACTIVE_TAG: 'Aktiv',
    TODAY_LABEL: 'Idag',
    ALL_DAYS: 'Alla dagar',
    WEEKLY_MENU_ORDERING: 'Veckomenybeställning',
    SELECT_CODE: 'Välj kod',
    DAYS_SELECTED_LABEL: '{0} dagar valda',
    ALL_WEEKS_LABEL: 'Alla veckor',
    CURRENT_WEEK_LABEL: 'Aktuell vecka',
    UPCOMING_WEEK_LABEL: 'Kommande vecka',
    WEEK_SCOPE_PLACEHOLDER: 'Vecka',
    DAYS_LABEL: 'Dagar',
    WEEKLY_TIMELINE_HEADER: 'Veckotidslinje',
    WEEKLY_SCOPED_READONLY_BANNER: 'Denna veckobeställning kan endast slutföras på den schemalagda dagen.',
    WEEKLY_SCOPED_START_PREPARING_BTN: 'Starta tillagning',
    WEEKLY_SCOPED_STARTED_SUCCESS_SUMMARY: 'Tillagning startad',
    WEEKLY_SCOPED_STARTED_SUCCESS_DETAIL: 'Veckoscopad beställning är nu pågående.',
    WEEKLY_SCOPED_MISSING_ETA_SUMMARY: 'Ingen klar tid för denna dag',
    WEEKLY_SCOPED_MISSING_ETA_DETAIL: 'Sätt en timer när du startar tillagning om du vill se nedräkning här.',
    WEEKLY_SCOPED_PENDING_SELECTION_HINT: 'Starta tillagning för att låsa upp val av rader för denna dag.',
    WELCOME: 'Välkommen',
    HELLO: 'God dag',
    GOOD_MORNING: 'God morgon',
    GOOD_EVENING: 'God kväll',
    GOOD_NIGHT: 'God natt',
    OPTIONAL: 'Valfritt',
    EAT_IN_PRICE_WARNING: 'Priset för "Äta här" kan inte vara lägre än ditt ordinarie pris.',
    NO_LOWER_PRICE: 'Priset för "Äta här" eller "Takeaway" kan inte vara 0. Vänligen sätt ett högre pris eller ta bort fältet.',
    UNLINK: 'Koppla från',
    CAROUSEL: 'Samlingar',
    SLIDE_PLAYBACK_FAILED: 'Uppspelning misslyckades',
    MENU_DISPLAY: 'Menydisplay',

    INGREDIENTS: 'Ingredienser',
    INGREDIENTS_DESCRIPTION: 'Välj ingredienser som ingår i denna produkt som standard.',
    SELECT_FROM_LIBRARY: 'Välj från bibliotek',
    CHOOSE_INGREDIENTS: 'Välj ingredienser...',
    NO_INGREDIENTS_LIBRARY: 'Inga ingredienser i biblioteket.',
    CREATE_NEW_INGREDIENT: 'Skapa ny ingrediens',
    INGREDIENT_PLACEHOLDER: 'T.ex. Lök',
    INGREDIENT_HINT: 'Tryck Enter eller klicka + för att lägga till.',
    SELECTED_INGREDIENTS: 'Valda ingredienser',
    NO_INGREDIENTS_SELECTED: 'Inga ingredienser valda ännu.',
    FAILED_LOAD_INGREDIENTS: 'Misslyckades med att ladda ingredienser. Försök igen.',
    FAILED_CREATE_INGREDIENT: 'Misslyckades med att skapa ingrediens. Försök igen.',
    CONFIRM_DELETE_INGREDIENT: 'Är du säker på att du vill ta bort den här ingrediensen från biblioteket permanent?',
    DELETE_INGREDIENT: 'Ta bort ingrediens',
    INGREDIENT_DELETED_LIBRARY: 'Ingrediens borttagen från biblioteket.',
    FAILED_DELETE_INGREDIENT: 'Misslyckades med att ta bort ingrediens. Försök igen.',
    WITHOUT: 'Utan',
    CATERING_ADDON_ERR_DELIVERY_METHOD_REQUIRED: 'Minst ett leveranssätt måste väljas.',
    CATERING_ADDON_ERR_PRICE_NEGATIVE: 'Alternativets pris kan inte vara negativt.',
    NO_DATA: 'Ingen data tillgängliga',
    NO_DATA_HINT: 'Det finns inget att visa just nu.',

    // Catering: no-login order-by-invoice checkout
    GUEST_INVOICE_ORDERING: "Gästbeställning mot faktura",
    GUEST_INVOICE_ORDERING_DESC: "Aktiverar beställning mot faktura utan inloggning för denna restaurang. Gästen anger företags- och faktureringsuppgifter i kassan i stället för att betala.",
    CATERING_SHOW_PRICES_EX_VAT: "Visa priser exkl. moms",
    CATERING_SHOW_PRICES_EX_VAT_DESC: "Visar cateringpriser exklusive moms i webbshoppen, med moms och totalbelopp inkl. moms i kassan. Endast visning: det debiterade beloppet ändras inte.",
    TABLE_BOOKING_SETTINGS: 'Bordsbokning',
    TABLE_BOOKING_SETTINGS_DESC: 'Hantera gästantal, bokningstider och passkonfigurationer för bordsbokning.',
    RESTAURANT_LOGO_URL: 'Restaurangens logotyp-URL (logoUrl)',
    RESTAURANT_LOGO_URL_HINT: 'Logotypen visas längst upp över restaurangnamnet på bokningssidan.',
    MIN_NR_OF_GUESTS: 'Minsta antal gäster (minNrOfGuests)',
    MIN_NR_OF_GUESTS_HINT: 'Minsta antal personer en gäst kan välja vid bokning.',
    MAX_NR_OF_GUESTS: 'Största antal gäster (maxNrOfGuests)',
    MAX_NR_OF_GUESTS_HINT: 'Största antal personer en gäst kan välja vid bokning.',
    DEFAULT_BOOK_DURATION_HOURS: 'Standard bokningstid i timmar (bookDurationHours)',
    DEFAULT_BOOK_DURATION_HOURS_HINT: 'Standard sitstid per bordsbokning (t.ex. 2 timmar).',
    DEFAULT_SLOT_INTERVAL_HOURS: 'Standard bokningsintervall i timmar (slotIntervalHours)',
    DEFAULT_SLOT_INTERVAL_HOURS_HINT: 'Intervall mellan bokningsbara tider (t.ex. 0.25 = 15 minuter).',
    BOOK_DURATIONS_TITLE: 'Pass- & skiftkonfiguration (bookDurations)',
    BOOK_DURATIONS_DESC: 'Anpassa sitstider och tidsintervall för olika tider på dygnet (t.ex. lunch vs middag).',
    ADD_SHIFT: 'Lägg till pass',
    START_TIME: 'Starttid (startTime)',
    DURATION_HOURS: 'Sitstid i timmar (durationHours)',
    SLOT_HOURS: 'Tidsintervall i timmar (slotHours)',
    NO_SHIFTS_CONFIGURED: 'Inga särskilda passkonfigurationer tillagda. Standardinställningarna ovan gäller för hela dygnet.',
    SETTINGS_SAVE_ERROR: 'Kunde inte spara inställningarna.',
    POS_V2_FREE_TEXT_BUTTON_LABEL: 'Knapptext',
    POS_V2_FREE_TEXT_BUTTON_LABEL_HELP: 'Text som visas på knappen i kassan.',
    POS_V2_FREE_TEXT_PRESET_LABEL: 'Förifylld kvitto-text',
    POS_V2_FREE_TEXT_PRESET_HELP: 'Om ifyllt läggs texten till direkt med ett klick. Om tomt öppnas ett tangentbord i kassan så att personalen kan skriva en egen anteckning.',
    POS_V2_BUTTON_STOCK: 'Button Stock',
    POS_V2_BUTTON_STOCK_DESC: 'Sekundärt popupraster i kassan',
    POS_V2_FREE_TEXT_DESC: 'Kvittoanteckning eller eget meddelande',
    POS_V2_FREE_TEXT_LABEL_PLACEHOLDER: 't.ex. Notering',
    POS_V2_FREE_TEXT_PRESET_PLACEHOLDER: 't.ex. Utan lök',
    POS_V2_STOCK_LABEL_PLACEHOLDER: 't.ex. Såser',
    POS_V2_STOCK_BUTTON_LABEL: 'Namn på underlager',
    POS_V2_ADD_STOCK_BUTTON: 'Lägg till Button Stock',
    CLEAR_SEARCH: 'Rensa sökning',
    BUTTONS: 'Knappar',
    ITEM: 'artikel',
    ITEMS: 'artiklar',
    BACKGROUND: 'Bakgrund:',
    POS_V2_CUSTOM_NAME: 'Anpassat namn',
    POS_V2_EDIT_CUSTOM_NAME: 'Redigera anpassat namn',
    POS_V2_RESET_TO_MENU_NAME: 'Återställ till menynamn',
    POS_V2_SOLID_COLOR: 'Enfärgad',
    POS_V2_PRODUCT_PHOTO: 'Produktbild',

    // --- Order validation devices ---------------------------------------------
    ORDER_VALIDATION_MENU: 'Ordervalidering',
    ORDER_VALIDATION_DEVICES: 'Enheter',
    ORDER_VALIDATION_DEVICES_SUBTITLE: 'QR-terminalerna där gäster scannar sin order. Ändringar här slår igenom på terminalen av sig själva.',
    ORDER_VALIDATION_DEVICES_TABLE_TITLE: 'Terminaler',
    ORDER_VALIDATION_DEVICES_ADD: 'Lägg till terminal',
    ORDER_VALIDATION_DEVICES_CREATE: 'Skapa',
    ORDER_VALIDATION_DEVICES_EDIT: 'Terminalinställningar',
    ORDER_VALIDATION_DEVICES_NAME: 'Namn',
    ORDER_VALIDATION_DEVICES_NAME_PLACEHOLDER: 't.ex. Entréterminal',
    ORDER_VALIDATION_DEVICES_NAME_REQUIRED: 'Ge terminalen ett namn',
    ORDER_VALIDATION_DEVICES_ID: 'Enhets-ID',
    ORDER_VALIDATION_DEVICES_ROUTE: 'Restaurang',
    ORDER_VALIDATION_DEVICES_ROUTE_HELP: 'Enheten som terminalen validerar för. Ordrar från andra ställen nekas.',
    ORDER_VALIDATION_DEVICES_ROUTE_REQUIRED: 'Välj en restaurang',
    ORDER_VALIDATION_DEVICES_LANGUAGE: 'Språk',
    ORDER_VALIDATION_DEVICES_LANGUAGE_UNSET: 'Låt terminalen bestämma',
    ORDER_VALIDATION_DEVICES_LANGUAGE_HELP: 'Lämnas det tomt behåller terminalen det språk som valts på den.',
    ORDER_VALIDATION_DEVICES_SOUNDS: 'Ljud',
    ORDER_VALIDATION_DEVICES_SOUND_SUCCESS: 'Ljud vid godkänd scanning',
    ORDER_VALIDATION_DEVICES_SOUND_FAILURE: 'Ljud vid nekad scanning',
    ORDER_VALIDATION_DEVICES_VERSION: 'Version',
    ORDER_VALIDATION_DEVICES_LAST_SEEN: 'Senast sedd',
    ORDER_VALIDATION_DEVICES_ONLINE: 'Online',
    ORDER_VALIDATION_DEVICES_EMPTY: 'Inga terminaler än. Lägg till en och ange dess ID på terminalen.',
    ORDER_VALIDATION_DEVICES_CREATED_HELP: 'Ange detta ID på terminalen, under PubQ-loggan, för att koppla den.',
    ORDER_VALIDATION_DEVICES_ID_COPIED: 'Enhets-ID kopierat',
    ORDER_VALIDATION_DEVICES_CREATE_FAILED: 'Kunde inte skapa terminalen',
    ORDER_VALIDATION_DEVICES_SAVED: 'Terminalinställningar sparade',
    ORDER_VALIDATION_DEVICES_SAVE_ERROR: 'Kunde inte spara terminalinställningarna',
    ORDER_VALIDATION_DEVICES_LOAD_ERROR: 'Kunde inte hämta terminalerna',
    ORDER_VALIDATION_DEVICES_REMOVE: 'Ta bort',
    ORDER_VALIDATION_DEVICES_REMOVE_CONFIRM: 'Ta bort terminalen från enheten?',
    ORDER_VALIDATION_DEVICES_REMOVE_WARNING: 'Terminalen fortsätter validera med de inställningar den redan har. Att ta bort den här tar bara bort den ur listan.',
    ORDER_VALIDATION_DEVICES_REMOVED: 'Terminalen borttagen',
    ORDER_VALIDATION_DEVICES_REMOVE_FAILED: 'Kunde inte ta bort terminalen',
    AUTOMATIC_ACTIVATION_HINT: 'När detta är aktiverat aktiveras erbjudandet för användaren utan att någon åtgärd krävs.',
    // Integrations + Fortnox (Z): source
    INTEG_TITLE: "Integrationer",
    INTEG_OVERVIEW: "Översikt",
    INTEG_THIS_RESTAURANT: "restaurangen",
    INTEG_LOADING_STATUS: "Hämtar status…",
    INTEG_COMING_SOON: "Kommer snart",
    INTEG_REAUTH: "Kopplingen måste godkännas igen",
    INTEG_NOT_CONNECTED: "Inte kopplat",
    INTEG_NO_ACCESS: "Ingen behörighet",
    INTEG_MANAGE: "Hantera",
    INTEG_ACTIVATE: "Aktivera",
    INTEG_DESC_FORTNOX: "Bokför varje stängd Z-rapport som en verifikation i företagets Fortnox. Kostnadsställe och kontomappning per restaurang.",
    INTEG_DESC_PERSONALKOLLEN: "Schemaläggning och tidrapportering: personal, pass och lönekostnad synkas med PubQ.",
    INTEG_DESC_TCPOS: "Försäljningsexport till TCPOS (SOAP / REST) för kedjor som redovisar i TCPOS.",
    FZ_TITLE: "Fortnox – Z-rapporter",
    FZ_INTRO: "Varje stängd Z-rapport kan bokföras som en verifikation i företagets Fortnox.",
    FZ_MODE_MOCK: "TESTLÄGE (mock): inget skickas till Fortnox, verifikationsnummer är påhittade.",
    FZ_MODE_READONLY: "LÄSLÄGE: kopplingen och kontrollerna mot Fortnox fungerar, men inga verifikationer skapas.",
    FZ_NO_UNIT: "Ingen restaurang är vald. Välj en restaurang i menyn.",
    FZ_NOTICE_CONNECTED: "Fortnox är kopplat för företaget.",
    FZ_CONNECTION_HEADER: "Koppling (företaget)",
    FZ_RETRY: "Försök igen",
    FZ_CONNECTED_TO: "Kopplat till",
    FZ_DISCONNECT_COMPANY: "Koppla från företaget…",
    FZ_BELONGS_TO: "Restaurangen tillhör",
    FZ_ORG_MISSING: "org.nr saknas",
    FZ_CONNECT_HELP: "Du loggar in i företagets Fortnox som administratör och godkänner. Fortnox-kontot måste ha samma organisationsnummer.",
    FZ_CONNECT: "Koppla Fortnox",
    FZ_DISCONNECTED_OK: "Fortnox frånkopplat för företaget",
    FZ_LISTS_STILL_SAVE: "du kan fortfarande spara inställningarna.",
    FZ_AUTO_EXPORT: "Automatisk export",
    FZ_COST_CENTER: "Kostnadsställe",
    FZ_NONE: "– ingen –",
    FZ_LOADING_COST_CENTERS: "Hämtar kostnadsställen…",
    FZ_NO_COSTCENTER_SCOPE: "Kopplingen saknar behörigheten \"kostnadsställen\" – Fortnox kontrollerar koden vid bokföring.",
    FZ_VOUCHER_SERIES: "Verifikationsserie",
    FZ_COMPANY_DEFAULT: "– företagets standard –",
    FZ_ROUNDING_ACCOUNT: "Konto för öresavrundning",
    FZ_REVIEW_FIRST: "Granska manuellt de första",
    FZ_ACCOUNT_MAPPING: "Kontomappning",
    FZ_ACCOUNT_MAPPING_HELP: "Byter ett konto från kassan mot ett annat konto i Fortnox (eller \"drop\" för rader utan belopp).",
    FZ_POS_ACCOUNT: "Kassans konto",
    FZ_FORTNOX_ACCOUNT: "Fortnox-konto",
    FZ_ADD_MAPPING: "Lägg till mappning",
    FZ_SAVE: "Spara",
    FZ_SETTINGS_SAVED: "Inställningarna sparades",
    FZ_ZREPORTS: "Z-rapporter",
    FZ_COL_BUSINESS_DATE: "Affärsdag",
    FZ_COL_TOTAL: "Totalt",
    FZ_COL_STATUS: "Status",
    FZ_TEST: "test",
    FZ_STATUS_NOT_SENT: "Ej skickad",
    FZ_STATUS_PENDING: "I kö",
    FZ_STATUS_HELD: "Väntar på granskning",
    FZ_STATUS_SENDING: "Skickas",
    FZ_STATUS_SENT: "Skickad",
    FZ_STATUS_FAILED: "Misslyckades",
    FZ_STATUS_LEGACY: "Bokförd (gamla flödet)",
    FZ_PREVIEW: "Förhandsgranska",
    FZ_APPROVE_SEND: "Godkänn & skicka",
    FZ_SEND: "Skicka",
    FZ_RESEND_ELLIPSIS: "Skicka igen…",
    FZ_EMPTY: "Inga stängda Z-rapporter ännu.",
    FZ_BACKFILL_LABEL: "Efterskicka Z",
    FZ_FROM: "från",
    FZ_TO: "till",
    FZ_BACKFILL: "Efterskicka",
    FZ_BACKFILL_HELP: "Äldsta först. Redan bokförda hoppas över. Stannar vid första fel.",
    FZ_NOT_SENT_BECAUSE: "Skickas inte:",
    FZ_COL_ACCOUNT: "Konto",
    FZ_COL_TEXT: "Text",
    FZ_COL_DEBIT: "Debet",
    FZ_COL_CREDIT: "Kredit",
    FZ_COL_COST_CENTER_SHORT: "KS",
    FZ_SUM: "Summa",
    FZ_CLOSE: "Stäng",
    FZ_RESEND_SECOND: "Att skicka igen skapar en andra verifikation för samma dag.",
    FZ_RESEND_VOID_HINT: "Makulera den första i Fortnox om den är fel.",
    FZ_TYPE_TO_CONFIRM: "Skriv följande för att bekräfta:",
    FZ_TYPE_ORGNO_TO_CONFIRM: "Skriv organisationsnumret för att bekräfta:",
    FZ_CANCEL: "Avbryt",
    FZ_RESEND: "Skicka igen",
    FZ_DISCONNECT_TITLE: "Koppla från Fortnox?",
    FZ_DISCONNECT_EFFECT: "Automatisk export slutar fungera tills någon kopplar igen.",
    FZ_DISCONNECT: "Koppla från",
    FZ_ERROR: "Fel",
    FZ_REFUSED_ALREADY_SENT: "redan bokförd",
    FZ_REFUSED_IN_PROGRESS: "skickas redan",
    FZ_REFUSED_HELD: "väntar på granskning",
    FZ_TOAST_MOCK: "TEST – mock",
    FZ_ERR_FORBIDDEN: "Du har inte behörighet till den här restaurangen.",
    FZ_ERR_LOAD: "Kunde inte hämtas",
    FZ_ERR_CONNECTION: "Kopplingen kunde inte hämtas",
    FZ_ERR_LISTS: "Konton och kostnadsställen från Fortnox kunde inte hämtas",
    FZ_ERR_ZLIST: "Z-rapporterna kunde inte hämtas",
    FZ_ERR_NOT_SIGNED_IN: "Du är inte inloggad.",
    FZ_ERR_SERVICE_TIMEOUT: "Fortnox-tjänsten svarade inte i tid",
    FZ_ERR_UNREACHABLE: "Kunde inte nå Fortnox-tjänsten (nätverk eller CORS)",
    // Status page (third-party service status)
    MENU_NAV_STATUS: "Systemstatus",
    MENU_SECTION_OVERVIEW: "Översikt",
    MENU_SECTION_MENU: "Meny & produkter",
    MENU_SECTION_CHANNELS: "Försäljningskanaler",
    MENU_SECTION_GUESTS: "Marknadsföring",
    MENU_SECTION_ECONOMY: "Ekonomi",
    MENU_SECTION_ADMIN: "Administration",
    MENU_SEARCH_PLACEHOLDER: "Sök i menyn",
    MENU_SEARCH_EMPTY: "Inga sidor matchar",
    STATUS_PAGE_TITLE: "Systemstatus",
    STATUS_PAGE_SUBTITLE: "Status för de tredjepartstjänster som er enhet använder",
    PROVIDER_REFRESH: "Uppdatera",
    PROVIDER_SECTION_TITLE: "Tredjepartstjänster",
    PROVIDER_ISSUES_COUNT: "Tjänster med problem",
    PROVIDER_ALL_OPERATIONAL: "Alla tjänster i drift",
    PROVIDER_LAST_UPDATED: "Uppdaterad",
    PROVIDER_STATUS_PAGE: "Statussida",
    PROVIDER_FETCH_FAILED: "Kunde inte hämta status",
    PROVIDER_LOADING: "Hämtar…",
    PROVIDER_EVENTS_TITLE: "Händelser",
    PROVIDER_NO_EVENTS: "Inga pågående, planerade eller nyligen lösta händelser.",
    PROVIDER_PER_PAGE: "Per sida:",
    PROVIDER_LEVEL_OPERATIONAL: "I drift",
    PROVIDER_LEVEL_MAINTENANCE: "Underhåll",
    PROVIDER_LEVEL_DEGRADED: "Försämrad",
    PROVIDER_LEVEL_PARTIAL_OUTAGE: "Delvis avbrott",
    PROVIDER_LEVEL_MAJOR_OUTAGE: "Större avbrott",
    PROVIDER_LEVEL_UNKNOWN: "Okänd",
    PROVIDER_EVENT_RESOLVED: "Löst",
    PROVIDER_EVENT_SCHEDULED_MAINTENANCE: "Planerat underhåll",
    PROVIDER_EVENT_ONGOING_MAINTENANCE: "Pågående underhåll",
    PROVIDER_EVENT_ONGOING_INCIDENT: "Pågående störning",


    // --- Organisation: gruppens siffror, delad katalog, delade erbjudanden ---
    ORG_MENU: "Organisation",
    ORG_ORGANISATION: "Organisation",
    ORG_DASHBOARD: "Översikt",
    ORG_DASHBOARD_SUBTITLE: "Försäljning för hela gruppen, och per enhet.",
    ORG_CATALOG: "Delad produktkatalog",
    ORG_CATALOG_SUBTITLE: "Produkter som gruppen delar. Publicering skriver till varje enhets egen meny.",
    ORG_CATALOG_HOW_IT_WORKS: "En publicering skriver produkten till varje vald enhets egen meny — det är därför varje kassa journalför sin egen prisändring. Enheter med eget pinnat pris hoppas över.",
    ORG_COUPONS: "Delade erbjudanden",
    ORG_COUPONS_SUBTITLE: "Kuponger och erbjudanden som gruppen delar ut till sina enheter.",
    ORG_COUPONS_HOW_IT_WORKS: "Definiera erbjudandet centralt och dela det till de enheter som ska ha det. En enhet kan ha ett eget värde.",
    ORG_ACCESS: "Organisationsåtkomst",
    ORG_ACCESS_SUBTITLE: "Vem som ser gruppens siffror, och vem som får administrera dem.",
    ORG_ACCESS_WARNING: "Medlemskap i en organisation ger inte åtkomst till gruppens försäljning. Bara en uttrycklig roll här gör det — 841 användare har redan en organisationsrad, och de ska inte se kedjans siffror av misstag.",
    ORG_UNITS: "enheter",
    ORG_UNIT: "Enhet",
    ORG_COMPANIES: "bolag",
    ORG_PERIOD: "Period",
    ORG_TOTAL_SALES: "Försäljning",
    ORG_RECEIPTS: "kvitton",
    ORG_AVG_RECEIPT: "Snittkvitto",
    ORG_SALES_PER_DAY: "Försäljning per dag",
    ORG_SALES_PER_HOUR: "Försäljning per timme",
    ORG_PER_UNIT: "Per enhet",
    ORG_PAYMENTS: "Betalsätt",
    ORG_PAYMENT_METHOD: "Betalsätt",
    ORG_TOP_PRODUCTS: "Mest sålda produkter",
    ORG_PRODUCT: "Produkt",
    ORG_CATEGORY: "Kategori",
    ORG_QUANTITY: "Antal",
    ORG_AMOUNT: "Belopp",
    ORG_COUNT: "Antal",
    ORG_SHARE: "Andel",
    ORG_TOTAL: "Totalt",
    ORG_NO_DATA: "Ingen data för perioden.",
    ORG_NO_UNITS: "Inga enheter i den här organisationen.",
    ORG_MULTI_CURRENCY: "Gruppen har enheter i flera valutor. Summorna visas per valuta — de läggs aldrig ihop.",
    ORG_UNITS_TRUNCATED: "Fler enheter än ett anrop rymmer. Dessa är inte med:",
    ORG_STATS_UNAVAILABLE: "Statistiktjänsten är inte påslagen i den här miljön.",
    ORG_STATS_FAILED: "Statistiken kunde inte hämtas.",
    ORG_LOAD_FAILED: "Kunde inte hämtas.",
    ORG_SAVE_FAILED: "Kunde inte sparas.",
    ORG_ERROR: "Fel",
    ORG_SAVED: "Sparat",
    ORG_UNITS_SAVED: "Enheterna sparades",
    ORG_DEMO_DATA: "DEMODATA",
    ORG_DEMO_DATA_HELP: "Endpointen finns inte ännu. Det som visas är påhittat och sparas inte.",
    ORG_DEMO_NOT_SAVED: "Demodata — ingenting sparades.",
    ORG_LIVE_DATA: "Skarp data",
    ORG_DERIVED_UNITS: "Egna enheter",
    ORG_DERIVED_UNITS_HELP: "Enheterna är de du själv är tilldelad, grupperade per organisation. Serverns egen enhetslista är inte klar, så en grupp kan visa för få enheter.",
    ORG_NEW_PRODUCT: "Ny produkt",
    ORG_EDIT_PRODUCT: "Redigera produkt",
    ORG_NO_PRODUCTS: "Inga produkter i katalogen ännu.",
    ORG_NAME: "Namn",
    ORG_DESCRIPTION: "Beskrivning",
    ORG_BASE_PRICE: "Pris",
    ORG_BASE_PRICE_ORE: "Pris (öre)",
    ORG_VAT: "Moms",
    ORG_SALES_ACCOUNT: "Försäljningskonto",
    ORG_ACTIVE: "Aktiv",
    ORG_INACTIVE: "Inaktiv",
    ORG_ASSIGNED_UNITS: "Enheter",
    ORG_VERSION: "Version",
    ORG_EDIT: "Redigera",
    ORG_ASSIGN_UNITS: "Välj enheter",
    ORG_SHARE_WITH_UNITS: "Dela med enheter",
    ORG_PUBLISH: "Publicera",
    ORG_PUBLISH_NOW: "Publicera nu",
    ORG_PUBLISHED: "Publicerat",
    ORG_UNITS_QUEUED: "enheter i kö",
    ORG_PUBLISH_FAILED: "Publiceringen misslyckades.",
    ORG_PREVIEW_FAILED: "Förhandsvisningen kunde inte hämtas.",
    ORG_ON: "På",
    ORG_PRICE_OVERRIDE: "Eget pris (öre)",
    ORG_VALUE_OVERRIDE: "Eget värde",
    ORG_ORG_PRICE: "Gruppens pris",
    ORG_ORG_VALUE: "Gruppens värde",
    ORG_CLEAR_OVERRIDE: "Ta bort eget värde",
    ORG_WONT_BE_PUBLISHED: "Publiceras inte över",
    ORG_PUBLISHED_LABEL: "Publicerad",
    ORG_OVERRIDE_HELP: "Ett eget pris på en enhet skrivs aldrig över av en publicering. Rensa det om enheten ska följa gruppens pris igen.",
    ORG_COUPON_OVERRIDE_HELP: "Ett eget värde på en enhet gäller före gruppens.",
    ORG_EDIT_NOT_PUBLISHED: "Att spara ändrar katalogen. Enheterna får ändringen först när du publicerar.",
    ORG_WILL_UPDATE: "Uppdateras",
    ORG_WILL_SKIP: "Hoppas över",
    ORG_PUBLISH_JOURNAL_NOTE: "Varje uppdaterad enhet journalför sin egen prisändring. Antal journalposter:",
    ORG_PUBLISH_BLOCKED_REGISTER: "Publiceringen är stoppad: kassaregister kunde inte hittas för alla enheter, och då skulle prisändringen gå igenom utan journalpost. Antal enheter:",
    ORG_PUBLISH_NOTHING: "Inget att publicera — alla enheter är redan i fas.",
    ORG_COUPON: "Erbjudande",
    ORG_NEW_COUPON: "Nytt erbjudande",
    ORG_EDIT_COUPON: "Redigera erbjudande",
    ORG_NO_COUPONS: "Inga erbjudanden ännu.",
    ORG_CODE: "Kod",
    ORG_VALUE: "Värde",
    ORG_VALID: "Gäller",
    ORG_VALID_FROM: "Gäller från",
    ORG_VALID_TO: "Gäller till",
    ORG_COUPON_KIND: "Typ",
    ORG_COUPON_PERCENTAGE: "Procent",
    ORG_COUPON_AMOUNT: "Belopp",
    ORG_COUPON_FREE_ITEM: "Gratis vara",
    ORG_COUPON_PCT_HELP: "0–100",
    ORG_GRANT_ACCESS: "Ge åtkomst",
    ORG_GRANT: "Ge åtkomst",
    ORG_REVOKE: "Ta bort åtkomst",
    ORG_REVOKE_CONFIRM: "Ta bort organisationsåtkomst för",
    ORG_ACCESS_GRANTED: "Åtkomst given",
    ORG_ACCESS_REVOKED: "Åtkomst borttagen",
    ORG_USER: "Användare",
    ORG_ROLE: "Roll",
    ORG_GRANTED: "Given",
    ORG_EMAIL: "E-post",
    ORG_ROLE_ADMIN: "Organisationsadmin",
    ORG_ROLE_VIEWER: "Läsare",
    ORG_ROLE_ADMIN_HELP: "ser gruppens försäljning och administrerar katalog, erbjudanden och vem som har åtkomst.",
    ORG_ROLE_VIEWER_HELP: "ser gruppens försäljning. Inget annat.",
    ORG_ROLES_EXPLAINED: "Vad rollerna betyder",
    ORG_ADMIN_ONLY: "Bara en organisationsadmin kan ändra det här.",
    ORG_NO_ACCESS_ROWS: "Ingen har organisationsåtkomst ännu.",
    ORG_GRANT_EMAIL_HELP: "Användaren måste redan finnas i PubQ.",
    ORG_GRANT_ADMIN_WARNING: "En organisationsadmin ser hela gruppens försäljning och kan ge andra samma åtkomst.",

    ORG_STAFF_ACCESS: "PubQ-personal",
    ORG_STAFF_ACCESS_HELP: "Du är inloggad som PubQ-personal och kan öppna vilken organisation som helst.",
    ORG_API_PROBLEM: "API-problem",
    ORG_API_NOT_DEPLOYED: "Organisations-API:t är inte utrullat i den här miljön.",
    ORG_FORBIDDEN: "Du har inte organisationsåtkomst till den här organisationen.",
    ORG_NET: "Netto",
    ORG_NO_SALES: "Ingen försäljning",
    ORG_OTHER_TYPES: "Övriga kvitton",
    ORG_OTHER_TYPES_HELP: "Kvitton som inte är försäljning (returer, proforma). Redovisas separat och räknas aldrig in i försäljningen.",
    ORG_SOLD_IN_UNITS: "Enheter",
    ORG_SHOW_ARCHIVED: "Visa arkiverade",
    ORG_ARCHIVED_TAG: "Arkiverad",
    ORG_ARCHIVE: "Arkivera",
    ORG_ARCHIVED: "Arkiverad",
    ORG_ARCHIVE_PUBLISH_NOTE: "Arkiverad i katalogen. Publicera för att ta bort den från enheterna.",
    ORG_PRODUCT_TYPE: "Produkttyp",
    ORG_CONTAINS_ALCOHOL: "Innehåller alkohol",
    ORG_VAT_ACCOUNT_HINT: "Försäljningskonto (ledtråd)",
    ORG_VAT_ACCOUNT_HINT_HELP: "Enheter har ofta flera konton för samma momssats (12 % mat och 12 % läsk). Utan ledtråd eller enhetsval vägrar publiceringen gissa.",
    ORG_SELLABLE: "Säljbar",
    ORG_SELLABLE_HELP: "Av betyder att varan finns i enheten men inte säljs. Den tas aldrig bort.",
    ORG_STALE: "Ej i fas",
    ORG_UNITS_IN_SCOPE: "enheter i omfånget",
    ORG_UNCHANGED: "oförändrade",
    ORG_WOULD_WITHDRAW: "tas bort",
    ORG_WOULD_FAIL: "misslyckas",
    ORG_WARNINGS: "varningar",
    ORG_PUBLISH_SOME_FAIL: "Några enheter skulle misslyckas. Publiceringen körs för de övriga — rätta dessa och publicera igen.",
    ORG_PUBLISH_QUEUED: "Publicering köad",
    ORG_RUN: "Körning",
    ORG_RUN_SWEEP: "plockas upp inom 15 min",
    ORG_ENABLED: "På",
    ORG_DISCOUNT: "Rabatt",
    ORG_DISCOUNT_HELP: "1–100 %. Bara procent stöds i apparna.",
    ORG_OFFER_KIND_CODE: "Rabattkod",
    ORG_OFFER_KIND_OFFER: "Erbjudande",
    ORG_CODE_HELP: "A–Z, 0–9, _ och -. 3–50 tecken. Unik bland organisationens aktiva koder.",
    ORG_CODE_CONFLICT: "Koden används redan av ett aktivt erbjudande i organisationen.",
    ORG_KIND_LOCKED: "Typen kan inte ändras efteråt.",
    ORG_LIVE_UNITS: "Live",
    ORG_LIVE_NOW: "Live nu",
    ORG_WITHDRAWN: "Borttagen",
    ORG_VALIDITY_ENFORCED: "Giltighetstiden styr publiceringen: utanför den tas koden bort i varje enhet, och läggs tillbaka inom cirka 15 minuter när den börjar gälla.",
    ORG_OFFER_CONFLICT_NOTE: "En enhet som redan har en egen kod med samma text får inte organisationens kod. Enhetens egen kod ändras aldrig.",
    ORG_UNIT_FLAG_NOTE: "Varningar: appar visar koder bara om enheten har kupongkoder påslagna, och erbjudanden bara om globala erbjudanden är påslagna. Publiceringen ändrar inte enhetens inställningar.",
    ORG_STAFF_ONLY: "Bara PubQ-personal kan ändra det här.",
    ORG_STAFF_ONLY_NOTE: "Du kan se vilka som har åtkomst. Att ge eller ta bort åtkomst görs av PubQ-personal — en organisationsadmin kan inte befordra andra.",
    ORG_ROLE_STAFF: "PubQ-personal",
    ORG_ROLE_STAFF_HELP: "ser allt, och är de enda som kan ge eller ta bort organisationsåtkomst.",
    ORG_ACCESS_ALREADY: "Åtkomst fanns redan",
    ORG_USER_NOT_FOUND: "Det finns inget PubQ-konto med den e-postadressen. En åtkomst skapar aldrig ett konto.",
    ORG_AUDIT: "Historik",
    ORG_NO_AUDIT: "Ingen historik.",
    ORG_REASON: "Anledning",
    ORG_REASON_HELP: "Hamnar i historiken.",
    ORG_WHEN: "När",
    ORG_ACTION: "Åtgärd",
    ORG_BY: "Av",

    ORG_MANAGED_TAG: "Organisation",
    ORG_MANAGED_HELP: "Styrs av organisationen. Den lades hit av en organisationspublicering, inte i den här enheten.",
    ORG_MANAGED_EDIT_WARNING: "Du kan ändra den här varan, men nästa publicering från organisationen skriver över de fält organisationen äger. Behöver enheten ett eget pris permanent — be organisationen lägga in ett undantag för enheten.",

    ORG_EXTERNAL_ID: "Externt ID",
    ORG_EXTERNAL_ID_HELP: "Varans ID i ett annat system, t.ex. Compass Groups TCPOS-artikelnummer. Skickas till varje enhet och är det fält TCPOS-exporten läser. Töm fältet för att ta bort det.",
    ORG_EXTERNAL_ID_KEY: "System",
    ORG_EXTERNAL_ID_OVERRIDE: "Externt ID för enheten",
    ORG_WRITTEN: "skrivna",
    ORG_FAILED: "misslyckades",
    ORG_RETRY: "Försök igen",
    ORG_PUBLISH_DONE: "Publicering klar",
    ORG_PUBLISH_PARTIAL: "Publicering klar med fel",
    ORG_RUN_STILL_GOING: "Körningen pågår fortfarande. Den fortsätter i bakgrunden — ladda om sidan senare för att se resultatet.",

    ORG_IMAGE: "Bild",
    ORG_IMAGE_CHOOSE: "Välj bild",
    ORG_IMAGE_REPLACE: "Byt bild",
    ORG_IMAGE_CLEAR: "Ta bort",
    ORG_IMAGE_HELP: "Laddas upp som organisationens bild (org/{id}/products/) och publiceras till varje enhet tillsammans med varan.",

    ORG_IMAGE_NOT_AN_IMAGE: "Filen är inte en bild.",
    ORG_IMAGE_UPLOAD_FAILED: "Bilden kunde inte laddas upp.",
    ORG_IMAGE_DENIED: "Lagringsreglerna nekade skrivningen till organisationens sökväg. Be PubQ lägga till regeln för:",

    // --- Skicka faktura till Fortnox (utkast, aldrig bokfört från PubQ) ----
    FZ_INV_COLUMN: "Fortnox",
    FZ_INV_SEND: "Skicka till Fortnox",
    FZ_INV_RETRY: "Försök igen",
    FZ_INV_RESEND: "Skicka igen",
    FZ_INV_SENDING: "Skickas…",
    FZ_INV_FAILED: "Misslyckades",
    FZ_INV_UNCERTAIN: "Osäker",
    FZ_INV_NOT_SENT: "Inte skickad",
    FZ_INV_NOT_SENT_YET: "Fakturan är inte skickad till Fortnox.",
    FZ_INV_DOC: "Fortnox-faktura",
    FZ_INV_DRAFT_NOTE: "skapad som obokfört utkast. Bokför och skicka den i Fortnox.",
    FZ_INV_SENT_TITLE: "Skickad till Fortnox",
    FZ_INV_ALREADY_TITLE: "Finns redan i Fortnox",
    FZ_INV_FAILED_TITLE: "Fortnox nekade fakturan",
    FZ_INV_NOT_READY: "Fakturan kan inte skickas till Fortnox än.",
    FZ_INV_CONFIRM: "Det här skapar en ny obokförd faktura i Fortnox. PubQ bokför den inte och skickar den inte till kunden.",
    FZ_INV_CONFIRM_DRIFT: "Fortnox summerar fakturan något annorlunda — kontrollera den där.",
    FZ_INV_LINK_CUSTOMER_FIRST: "Koppla kunden till Fortnox först",
    FZ_INV_GO_LINK_CUSTOMER: "Gå till företagskunder",
    FZ_INV_RECONNECT: "Återanslut Fortnox för att kunna fakturera",
    FZ_INV_RECONNECT_CTA: "Återanslut Fortnox",
    FZ_INV_DISABLED: "Fakturering till Fortnox är inte aktiverad i den här miljön",
    FZ_INV_NOT_CONNECTED: "Restaurangen är inte ansluten till Fortnox",
    FZ_INV_IN_PROGRESS: "Fakturan skickas just nu",
    FZ_INV_UNCERTAIN_HELP: "En tidigare sändning kan redan ha skapat fakturan i Fortnox. Kontrollera i Fortnox innan du skickar igen.",
    FZ_INV_RESEND_TITLE: "Skicka fakturan igen?",
    FZ_INV_RESEND_CONFIRM_LABEL: "Skriv in bekräftelsen för att skicka igen:",
    FZ_INV_RECONCILE: "Summa i PubQ / i Fortnox",

    // --- Kundimport från Fortnox (bokföringssystemet som källa) ------------
    FZ_CUST_SEARCH_LABEL: "Sök kund i Fortnox",
    FZ_CUST_SEARCH_PLACEHOLDER: "Namn, kundnummer eller organisationsnummer",
    FZ_CUST_SEARCH_HINT: "Skriv minst två tecken. Söker bland kunderna i det anslutna Fortnox-bolaget.",
    FZ_CUST_INCLUDE_INACTIVE: "Visa även inaktiva",
    FZ_CUST_INACTIVE: "inaktiv",
    FZ_CUST_NO_RESULTS: "Ingen kund i Fortnox matchar sökningen.",
    FZ_CUST_OR_MANUAL: "eller fyll i uppgifterna själv",
    FZ_CUST_PREFILLED_FROM: "Förifyllt från Fortnox:",
    FZ_CUST_DISCARD_PICK: "Ta bort",
    FZ_CUST_REVIEW_HELP: "Granska och justera uppgifterna innan du sparar. Inget skrivs till Fortnox — PubQ läser bara kundregistret.",
    FZ_CUST_REVIEW_TERMS: "Betalningsvillkoret i Fortnox är inte ett antal dagar. 30 dagar är ifyllt — kontrollera det.",
    FZ_CUST_REVIEW_EMAIL: "Kunden har ingen e-postadress i Fortnox. Fyll i fakturamottagare själv.",
    FZ_CUST_REVIEW_ORGNO: "Kunden har inget organisationsnummer i Fortnox. Fyll i det själv.",
    FZ_CUST_WILL_CREATE: "Sparas som en ny företagskund.",
    FZ_CUST_WILL_LINK: "Organisationsnumret finns redan som företagskund. Den kopplas till Fortnox-kunden; dina egna uppgifter lämnas orörda.",
    FZ_CUST_ALREADY_TITLE: "Redan importerad",
    FZ_CUST_ALREADY_HELP: "Den här Fortnox-kunden är redan importerad. Öppna den befintliga kunden, eller använd Uppdatera från Fortnox på den.",
    FZ_CUST_OPEN_EXISTING: "Öppna befintlig kund",
    FZ_CUST_CONFLICT_TITLE: "Flera möjliga träffar",
    FZ_CUST_CONFLICT_HELP: "Det finns en företagskund som kan vara samma företag, men träffen är för svag för att koppla automatiskt. Välj att koppla till en av dem, eller att skapa en ny kund.",
    FZ_CUST_MATCHED_ON: "Matchar på",
    FZ_CUST_LINK_THIS: "Koppla till denna",
    FZ_CUST_CREATE_ANYWAY: "Skapa ny kund ändå",
    FZ_CUST_CHOOSE_FIRST: "Välj koppla eller skapa ny innan du sparar.",
    FZ_CUST_IMPORTED: "Företagskunden importerades från Fortnox.",
    FZ_CUST_LINKED: "Företagskunden kopplades till Fortnox-kunden.",
    FZ_CUST_SOURCE_TAG: "Fortnox",
    FZ_CUST_REFRESH: "Uppdatera från Fortnox",
    FZ_CUST_REFRESH_NO_CHANGE: "Allt var redan i fas med Fortnox.",
    FZ_CUST_RECONNECT_TITLE: "Kundimport är inte aktiverad",
    FZ_CUST_RECONNECT_CTA: "Återanslut Fortnox för att aktivera kundimport",
    FZ_CUST_CONSENT_NOTE: "Anslutningen ger också PubQ läsrätt till ditt kundregister i Fortnox, så att du kan importera kunder. PubQ ändrar aldrig något där.",

    // Catering: partner-group companies, invoice PDF switch, delivery-time generator
    CC_GROUP_BANNER_TITLE: "Delas av alla restauranger i gruppen",
    CC_GROUP_BANNER_DESC: "Företagen tillhör partnergruppen, inte den här restaurangen. Ändringar gäller alla restauranger i gruppen.",
    CC_GROUP_MISCONFIGURED_TITLE: "Partnergruppen för den här restaurangen är inte korrekt inställd",
    CC_GROUP_NOT_MEMBER: "Gruppen finns men listar inte den här restaurangen.",
    CC_GROUP_NOT_FOUND: "Ingen partnergrupp med detta ID hittades.",
    CC_GROUP_FIX_IN_SETTINGS: "Rätta eller ta bort partnergruppen under Catering > Inställningar > Leverans. Företagen kan inte redigeras innan dess.",
    CC_EMAIL_DOMAINS: "E-postdomäner",
    CC_EMAIL_DOMAINS_NONE: "Inga domäner (endast manuellt kopplade användare)",
    CC_EMAIL_DOMAINS_HELP: "Inloggade användare vars verifierade e-post slutar på någon av dessa domäner kan beställa mot faktura för företaget. Ange domänen utan \"@\", t.ex. soupster.fi.",
    CC_EMAIL_DOMAINS_EMPTY_HINT: "Inga domäner ännu: endast användare du kopplar manuellt (Användare) får tillgång till företaget.",
    CC_EMAIL_DOMAIN_INVALID: "Ogiltig domän. Exempel: soupster.fi",
    CC_EMAIL_DOMAIN_PUBLIC: "Publika e-posttjänster (gmail.com, outlook.com, ...) kan inte användas: vem som helst kan skapa en adress där.",
    CC_EMAIL_DOMAIN_DUPLICATE: "Domänen finns redan i listan.",
    CC_EMAIL_DOMAIN_SHARED: "Används även av:",
    CC_COST_CENTERS: "Kostnadsställen",
    CC_COST_CENTERS_HELP: "Valfritt. Lägger du till kostnadsställen väljer användaren ett vid beställning; utan dem skrivs det fritt.",
    CC_COST_CENTER_PLACEHOLDER: "t.ex. 4010 Marknad",
    CATERING_INVOICE_PDF: "Faktura-PDF",
    CATERING_INVOICE_PDF_ON_DESC: "På: en faktura-PDF skapas och skickas med e-post när en fakturabeställning läggs.",
    CATERING_INVOICE_PDF_OFF_DESC: "Ingen faktura-PDF — restaurangen fakturerar från sitt kassasystem; godkännandemejlet är orderbekräftelsen.",
    CATERING_PARTNER_GROUP: "Partnergrupp",
    CATERING_PARTNER_GROUP_DESC: "Om restaurangen ingår i en partnergrupp, ange gruppens ID. Företagskunderna delas då av alla restauranger i gruppen.",
    CATERING_PARTNER_GROUP_PLACEHOLDER: "Grupp-ID, t.ex. soupster",
    CATERING_PARTNER_GROUP_CHECK: "Kontrollera",
    CATERING_PARTNER_GROUP_OK: "Hittade gruppen:",
    CATERING_PARTNER_GROUP_NOT_MEMBER: "Restaurangen finns inte med i gruppen:",
    CATERING_PARTNER_GROUP_NOT_FOUND: "Ingen partnergrupp med detta ID hittades.",
    CATERING_PARTNER_GROUP_INVALID_SLUG: "Grupp-ID får bara innehålla bokstäver, siffror, \"-\" och \"_\".",
    CATERING_PARTNER_GROUP_UNCHECKED: "Tryck på Kontrollera för att verifiera gruppen innan du sparar.",
    CATERING_PARTNER_GROUP_NONE: "Ingen partnergrupp: företagskunderna tillhör bara den här restaurangen.",
    CATERING_PARTNER_GROUP_NOT_SAVED: "Partnergruppen sparades inte: den finns inte eller listar inte den här restaurangen.",
    CATERING_DELIVERY_DEFAULT_TIME_ADDED: "En standardtid för leverans (10:00) lades till. Ändra den, lägg till fler eller generera dagens tider nedan.",
    CATERING_GENERATE_TIMES: "Generera tider",
    CATERING_GENERATE_TIMES_FROM: "Från",
    CATERING_GENERATE_TIMES_TO: "Till",
    CATERING_GENERATE_TIMES_STEP: "Var",
    CATERING_GENERATE_TIMES_APPLY: "Generera",
    CATERING_SORT_TIMES: "Sortera",
    CATERING_GENERATE_TIMES_HELP: "Ersätter dagens leveranstider med varje intervall från start- till sluttid (inklusive). Inget sparas förrän du trycker på Spara.",
    CATERING_GENERATE_TIMES_ERR_INVALID: "Ange båda tiderna som TT:MM.",
    CATERING_GENERATE_TIMES_ERR_ORDER: "Sluttiden får inte vara före starttiden.",
    CATERING_GENERATE_TIMES_ERR_STEP: "Välj ett intervall.",
    CATERING_GENERATE_TIMES_ERR_TOO_MANY: "För många tider för en dag. Välj ett längre intervall.",
}
